/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Json: { input: { [key: string]: any } | string | string[] | boolean | boolean[] | number | number[] | { [key: string]: any }[]; output: { [key: string]: any } | string | string[] | boolean | boolean[] | number | number[] | { [key: string]: any }[]; }
  join__FieldSet: { input: any; output: any; }
  link__Import: { input: any; output: any; }
};

export type AbstractHeader = {
  bodyText?: Maybe<RichText>;
  buttons?: Maybe<Array<Button>>;
  id: Scalars['ID']['output'];
  image?: Maybe<ContentAsset>;
  imagePosition?: Maybe<ImagePosition>;
  imageStyle?: Maybe<ImageStyle>;
  title: Scalars['String']['output'];
};

export type AbstractPage = {
  breadcrumbs?: Maybe<Array<Breadcrumb>>;
  full_slug: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  seo?: Maybe<ContentSeo>;
  storeContext: StoreContext;
  translatedPaths?: Maybe<Array<TranslatedPath>>;
};

export type AbstractProductSpecificationAttribute = {
  /** Optional descriptive information about the attribute, Localized to the current locale */
  description?: Maybe<Scalars['String']['output']>;
  /** The label of the attribute, e.g. 'Color'. Localized to the current locale */
  label: Scalars['String']['output'];
  /** The name of the attribute, e.g. 'color'. Consistent across all locales */
  name: Scalars['String']['output'];
};

export type AccountType =
  | 'business'
  | 'personal';

export type Address = {
  /** Additional address information (e.g. building number, floor, apartment number) */
  additionalAddressInfo?: Maybe<Scalars['String']['output']>;
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Company name */
  company?: Maybe<Scalars['String']['output']>;
  /** Country */
  country: Scalars['String']['output'];
  /** Email address */
  email?: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** House number */
  houseNumber?: Maybe<Scalars['String']['output']>;
  /** House number suffix */
  houseNumberSuffix?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the address */
  id?: Maybe<Scalars['ID']['output']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Phone number */
  phone?: Maybe<Scalars['String']['output']>;
  /** Postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Salutation */
  salutation?: Maybe<Scalars['String']['output']>;
  /** State */
  state?: Maybe<Scalars['String']['output']>;
  /** Street name and number */
  streetName?: Maybe<Scalars['String']['output']>;
  /** VAT Number */
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  /** City */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Company name */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Country */
  country: Scalars['String']['input'];
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Additional street information */
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  /** House number suffix */
  houseNumberSuffix?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Street name and number */
  streetName?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AddressSuggestion = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  houseNumberSuffix?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
};

/**
 * Input for updating customer information
 *
 * All default fields are required as the schema validation enforces this for both the frontend and backend.
 */
export type AddressUpdateInput = {
  accountType: AccountType;
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  houseNumberSuffix?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  salutation?: InputMaybe<Salutation>;
  street: Scalars['String']['input'];
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AddressValidationResult = {
  suggestions?: Maybe<Array<Maybe<AddressSuggestion>>>;
  valid: Scalars['Boolean']['output'];
};

export type ArticleCard = {
  id: Scalars['ID']['output'];
  image?: Maybe<ContentAsset>;
  link?: Maybe<ResourceLink>;
  location?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
};

export type ArticleItemsResult = {
  results?: Maybe<Array<Maybe<ArticleCard>>>;
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ArticleOverview = {
  id: Scalars['ID']['output'];
  items: ArticleItemsResult;
};


export type ArticleOverviewItemsArgs = {
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};

export type ArticlePage = AbstractPage & {
  body?: Maybe<Array<Maybe<Block>>>;
  breadcrumbs?: Maybe<Array<Breadcrumb>>;
  full_slug: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<ContentAsset>;
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seo?: Maybe<ContentSeo>;
  storeContext: StoreContext;
  title: Scalars['String']['output'];
  translatedPaths?: Maybe<Array<TranslatedPath>>;
};

export type Block = ArticleOverview | BlockQuote | Buttons | Card | CategorySection | CookieDeclaration | CountrySpecificContainer | Divider | FaqItemList | FourColumns | Iframe | Image | Jafix | NewsletterCta | RichText | Section | SectionHeader | ShopSection | Table | TeaserRow | ThreeColumns | TwoColumns | UgcFlowbox | Video;

export type BlockQuote = {
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Breadcrumb = {
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type Button = {
  id: Scalars['ID']['output'];
  link: ResourceLink;
  size: ButtonSize;
  title: Scalars['String']['output'];
  variant: ButtonVariant;
};

export type ButtonSize =
  | 'lg'
  | 'xl'
  | 'xxl';

export type ButtonVariant =
  | 'destructive'
  | 'primary'
  | 'secondary'
  | 'secondaryColor'
  | 'tertiary'
  | 'tertiaryColor';

export type Buttons = {
  buttons?: Maybe<Array<Button>>;
  id: Scalars['ID']['output'];
};

export type CacheControlScope =
  | 'PRIVATE'
  | 'PUBLIC';

export type Card = {
  category?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: ContentAsset;
  link?: Maybe<ResourceLink>;
  supportingText?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Cart = {
  availablePaymentMethods: Array<PaymentMethodGroup>;
  billingAddress?: Maybe<Address>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<CartDiscount>;
  id: CartIdentifier;
  isGuest: Scalars['Boolean']['output'];
  lastModifiedAt: Scalars['DateTime']['output'];
  lineItems: Array<LineItem>;
  paazlCheckoutConfig: PaazlCheckoutConfig;
  selectedPaymentMethod?: Maybe<PaymentMethod>;
  shippingAddress?: Maybe<Address>;
  shippingCosts?: Maybe<Money>;
  shippingMethod?: Maybe<ShippingMethod>;
  shippingOption?: Maybe<ShippingOption>;
  /** Total amount of all line items, after discount, before shipping and payment costs */
  subTotal: Money;
  /** Total amount of all line items, before discount, shipping and payment costs */
  subTotalBeforeDiscount: Money;
  /** Total price, after discount, shipping and payment costs */
  total: Money;
};


export type CartAvailablePaymentMethodsArgs = {
  device: ClientDevice;
};

export type CartDiscount = {
  /** Total Discount amount */
  amount: Money;
};

export type CartIdentifier = {
  id: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

export type CartIdentifierInput = {
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type CartLineItemCreateInput = {
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type CartLineItemUpdateInput = {
  id: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type CategorySection = {
  category?: Maybe<Scalars['String']['output']>;
  headerAlign: CategorySectionHeaderAlign;
  id: Scalars['ID']['output'];
  items: Array<Card>;
  link?: Maybe<ResourceLink>;
  supportingText?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  variant: ComponentVariant;
};

export type CategorySectionHeaderAlign =
  | 'left'
  | 'top';

export type CheckoutCompleted = {
  orderId: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
};

export type ClientDevice =
  | 'android'
  | 'ios'
  | 'web';

export type ColumnAlignment =
  | 'bottom'
  | 'center'
  | 'top';

export type ColumnBlock = BlockQuote | Buttons | CookieDeclaration | CountrySpecificContainer | Divider | FaqItemList | Iframe | Image | NewsletterCta | RichText | Table | Video;

export type CompanyReview = {
  amount: Scalars['Int']['output'];
  averageRating: Scalars['Float']['output'];
  totalAmount?: Maybe<Scalars['Int']['output']>;
};

export type ComponentVariant =
  | 'carousel'
  | 'grid';

export type ContentAsset = {
  alt?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  focus?: Maybe<Scalars['String']['output']>;
  isExternalUrl?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContentPage = AbstractPage & {
  body?: Maybe<Array<Maybe<Block>>>;
  breadcrumbs?: Maybe<Array<Breadcrumb>>;
  description?: Maybe<Scalars['String']['output']>;
  full_slug: Scalars['String']['output'];
  hero?: Maybe<Hero>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  seo?: Maybe<ContentSeo>;
  storeContext: StoreContext;
  title?: Maybe<Scalars['String']['output']>;
  translatedPaths?: Maybe<Array<TranslatedPath>>;
  usps?: Maybe<Usps>;
};

export type ContentSeo = {
  description?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  ogDescription?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<Scalars['String']['output']>;
  ogTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitterDescription?: Maybe<Scalars['String']['output']>;
  twitterImage?: Maybe<Scalars['String']['output']>;
  twitterTitle?: Maybe<Scalars['String']['output']>;
};

export type ContentTable = {
  tbody: Array<ContentTableRow>;
  thead: Array<ContentTableCell>;
};

export type ContentTableCell = {
  value: Scalars['String']['output'];
};

export type ContentTableRow = {
  body: Array<ContentTableCell>;
};

export type ContentVersion =
  | 'draft'
  | 'published';

export type CookieDeclaration = {
  id: Scalars['ID']['output'];
};

export type CountrySpecificContainer = {
  body?: Maybe<Array<Maybe<Block>>>;
  countries: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type Currency =
  | 'EUR'
  | 'USD';

export type Customer = {
  accountType: AccountType;
  addresses?: Maybe<Array<Address>>;
  billingAddress?: Maybe<Address>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Salutation>;
  shippingAddress?: Maybe<Address>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type CustomerCreateInput = {
  accountType: AccountType;
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  salutation?: InputMaybe<Salutation>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerExistsResult = {
  result: Scalars['Boolean']['output'];
};

export type Divider = {
  id: Scalars['ID']['output'];
};

export type FaqGroup = {
  faqItems: Array<FaqItem>;
  icon?: Maybe<ContentAsset>;
  id: Scalars['ID']['output'];
  leadText?: Maybe<RichText>;
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  translatedPaths?: Maybe<Array<TranslatedPath>>;
};

export type FaqItem = {
  content?: Maybe<RichText>;
  countries?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type FaqItemList = {
  faqItems: Array<FaqItem>;
  id: Scalars['ID']['output'];
};

export type FaqPage = AbstractPage & {
  breadcrumbs?: Maybe<Array<Breadcrumb>>;
  faqGroups: Array<FaqGroup>;
  full_slug: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  seo?: Maybe<ContentSeo>;
  storeContext: StoreContext;
  title: Scalars['String']['output'];
  translatedPaths?: Maybe<Array<TranslatedPath>>;
};

export type Facet = OptionsFacet | RangeFacet | ToggleFacet;

export type FacetFilterInput = {
  key: Scalars['String']['input'];
  /** Required for Range Facets */
  max?: InputMaybe<Scalars['Float']['input']>;
  /** Required for Range Facets */
  min?: InputMaybe<Scalars['Float']['input']>;
  /** Required for Options Facets */
  selections?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Required for Toggle Facets */
  toggle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FacetValue = {
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
};

export type FourColumns = {
  alignment: ColumnAlignment;
  column_1: Array<ColumnBlock>;
  column_2: Array<ColumnBlock>;
  column_3: Array<ColumnBlock>;
  column_4: Array<ColumnBlock>;
  id: Scalars['ID']['output'];
};

export type Hero = AbstractHeader & {
  bodyText?: Maybe<RichText>;
  buttons?: Maybe<Array<Button>>;
  id: Scalars['ID']['output'];
  image?: Maybe<ContentAsset>;
  imagePosition: ImagePosition;
  imageStyle: ImageStyle;
  title: Scalars['String']['output'];
  variant?: Maybe<HeroVariant>;
};

export type HeroVariant =
  /** Banner */
  | 'banner'
  /** Hero */
  | 'hero';

export type Iframe = {
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type Image = {
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  image: ContentAsset;
};

export type ImagePosition =
  /** Full background */
  | 'full'
  /** Right */
  | 'right';

export type ImageStyle =
  /** Dark */
  | 'dark'
  /** Light */
  | 'light';

export type Jafix = {
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
};

export type LayoutOrientation =
  | 'horizontal'
  | 'vertical';

export type LineItem = UnderlineAttributes & {
  _storeContext: StoreContext;
  addedAt?: Maybe<Scalars['String']['output']>;
  availableStock: Scalars['Int']['output'];
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<ProductCategory>;
  /** Indicates the density of a fabric, mostly used in pantyhose */
  denier?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<LineItemDiscount>>;
  /** Description of the fit of the product, e.g. 'loose', 'tight' */
  fit?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /**
   * Represents the list price, also known as te Manufacturer's Suggested Retail
   * Price (MSRP).  It's the highest price shown and could be used as the
   * strikethrough price to indicate the original value of the product before any
   * discounts.
   */
  listPrice: TaxedPrice;
  /** Neckline of the product, used for tops and shirts */
  neckline?: Maybe<Scalars['String']['output']>;
  /** The amount of items in a pack */
  packSize?: Maybe<Scalars['Int']['output']>;
  /**
   * The line-item is the final price after applying any additional discounts on
   * top of the regular price. It's the final price that customers pay.
   */
  price: TaxedPrice;
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  productSlug?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  /** Raw materials used in the product */
  rawMaterial?: Maybe<Scalars['String']['output']>;
  /**
   * The regular selling price on the platform, potentially already discounted
   * from the MSRP. It's the standard price at which the product is usually offered
   * when there are no special sales or additional discounts.
   */
  regularPrice: TaxedPrice;
  variant: ProductInfo;
};

export type LineItemDiscount = {
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  value: Money;
};

export type LocalizedSlug = {
  locale: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Media = ProductImage | ProductImage360 | ProductYouTubeVideo;

export type MenuBlock = {
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  menuLinks: Array<MenuLink>;
};

/** A top level menu item with a submenu */
export type MenuItem = {
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  link?: Maybe<ResourceLink>;
  subMenuItems: Array<TopMenuOption>;
};

/** A link in a menu (does not have a submenu) */
export type MenuLink = {
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  link: ResourceLink;
};

export type Method =
  | 'GET'
  | 'POST';

export type Money = {
  centAmount: Scalars['Int']['output'];
  currency: Currency;
};

export type Mutation = {
  applyDiscount: Cart;
  /**
   * Add new line items to the cart. The cart identifier is optional. If no
   * identifier is passed a new cart is created
   */
  cartLineItemsAdd: Cart;
  /** Remove line items from the cart */
  cartLineItemsRemove: Cart;
  /** Update line items in the cart. This is for changing the quantity of line items. */
  cartLineItemsUpdate: Cart;
  checkoutComplete: CheckoutCompleted;
  /**
   * Update the cart metadata. This is for setting for example the shipping method.
   * If no identifier is passed a new cart is created.
   */
  checkoutUpdate: Cart;
  createPayment: PaymentData;
  customerCreate: Customer;
  customerDelete: Scalars['Boolean']['output'];
  customerEmailUpdate: Customer;
  customerInformationUpdate: Customer;
  customerLogin: Customer;
  customerLogout: Scalars['Boolean']['output'];
  customerPasswordReset: Customer;
  customerPasswordResetRequest?: Maybe<Scalars['Boolean']['output']>;
  customerPasswordUpdate: Customer;
  newsletterSignUp?: Maybe<Scalars['Boolean']['output']>;
  refreshToken: RefreshTokenResponse;
  storeContentPreview: StoreContentPreviewData;
};


export type MutationApplyDiscountArgs = {
  storeContext: StoreContextInput;
};


export type MutationCartLineItemsAddArgs = {
  id?: InputMaybe<CartIdentifierInput>;
  lineItems: Array<CartLineItemCreateInput>;
  storeContext: StoreContextInput;
};


export type MutationCartLineItemsRemoveArgs = {
  id: CartIdentifierInput;
  lineItemIds: Array<Scalars['String']['input']>;
  storeContext: StoreContextInput;
};


export type MutationCartLineItemsUpdateArgs = {
  id: CartIdentifierInput;
  lineItems: Array<CartLineItemUpdateInput>;
  storeContext: StoreContextInput;
};


export type MutationCheckoutCompleteArgs = {
  storeContext: StoreContextInput;
};


export type MutationCheckoutUpdateArgs = {
  id?: InputMaybe<CartIdentifierInput>;
  processPaazlCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  setBillingAddress?: InputMaybe<AddressInput>;
  setCustomerEmail?: InputMaybe<Scalars['String']['input']>;
  setPaymentMethod?: InputMaybe<PaymentMethodInput>;
  setShippingAddress?: InputMaybe<AddressInput>;
  storeContext: StoreContextInput;
};


export type MutationCreatePaymentArgs = {
  paymentContext: PaymentContextInput;
  storeContext: StoreContextInput;
};


export type MutationCustomerCreateArgs = {
  customer: CustomerCreateInput;
  storeContext: StoreContextInput;
};


export type MutationCustomerDeleteArgs = {
  password: Scalars['String']['input'];
  storeContext: StoreContextInput;
};


export type MutationCustomerEmailUpdateArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  storeContext: StoreContextInput;
};


export type MutationCustomerInformationUpdateArgs = {
  address: AddressUpdateInput;
  storeContext: StoreContextInput;
};


export type MutationCustomerLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  storeContext: StoreContextInput;
};


export type MutationCustomerLogoutArgs = {
  storeContext: StoreContextInput;
};


export type MutationCustomerPasswordResetArgs = {
  password: Scalars['String']['input'];
  storeContext: StoreContextInput;
  token: Scalars['String']['input'];
};


export type MutationCustomerPasswordResetRequestArgs = {
  email: Scalars['String']['input'];
  storeContext: StoreContextInput;
};


export type MutationCustomerPasswordUpdateArgs = {
  newPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  storeContext: StoreContextInput;
};


export type MutationNewsletterSignUpArgs = {
  email: Scalars['String']['input'];
  storeContext: StoreContextInput;
};


export type MutationStoreContentPreviewArgs = {
  data: Scalars['String']['input'];
  path: Scalars['String']['input'];
};

export type NearbyStore = {
  address?: Maybe<StoreAddress>;
  distanceInMeters: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  objectID?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  storeCode?: Maybe<Scalars['String']['output']>;
};

export type NewsletterCta = {
  id: Scalars['ID']['output'];
  orientation: LayoutOrientation;
};

export type NotificationBanner = {
  id: Scalars['ID']['output'];
  link?: Maybe<ResourceLink>;
  linkLabel?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type OptionsFacet = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<FacetValue>;
};

export type Order = {
  billingAddress?: Maybe<Address>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<CartDiscount>;
  estimatedMaxDeliveryDays?: Maybe<Scalars['Int']['output']>;
  id: OrderIdentifier;
  isGuest: Scalars['Boolean']['output'];
  lineItems: Array<LineItem>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** OrderStatus contains a general status of the order. This is useful for categorizing orders in the UI. */
  orderStatus?: Maybe<OrderStatus>;
  paymentStatus?: Maybe<PaymentStatus>;
  selectedPaymentMethod?: Maybe<PaymentMethod>;
  shippingAddress?: Maybe<Address>;
  shippingCosts?: Maybe<Money>;
  shippingMethod?: Maybe<Scalars['String']['output']>;
  shippingNotice?: Maybe<Scalars['String']['output']>;
  shippingOption?: Maybe<ShippingOption>;
  /** Total amount of all line items (i.e. price excluding shipping/payment costs) */
  subTotal: TaxedTotalPrice;
  /** Total price, including shipping and payment costs */
  total: TaxedTotalPrice;
  vatShifting?: Maybe<Money>;
};

export type OrderIdentifier = {
  id: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

export type OrderResult = {
  results: Array<Order>;
  total: Scalars['Int']['output'];
};

export type OrderStatus =
  | 'Open';

export type OrganizationAddress = {
  country?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type PaazlCheckoutConfig = {
  configObject: Scalars['Json']['output'];
  token: Scalars['String']['output'];
};

export type Page = ArticlePage | ContentPage | FaqPage | ProductListingPage;

export type PageRedirect = {
  destination: Scalars['String']['output'];
  source: Scalars['String']['output'];
  statusCode: Scalars['Int']['output'];
  storeContext: StoreContext;
};

export type PageRedirectPageType =
  | 'CONTENT'
  | 'PRODUCT';

export type PageType =
  | 'CONTENT'
  | 'PDP';

export type PagesResult = {
  moreResultsCountryUnique?: Maybe<Scalars['Boolean']['output']>;
  moreResultsShared?: Maybe<Scalars['Boolean']['output']>;
  results: Array<Page>;
  total: Scalars['Int']['output'];
};

export type Payment = {
  id: Scalars['ID']['output'];
};

export type PaymentContextInput = {
  method: PaymentMethodInput;
  /**
   * Optional order ID to associate the payment with. Only relevant if we create
   * the order before the payment
   */
  orderId?: InputMaybe<Scalars['String']['input']>;
  returnURL: Scalars['String']['input'];
};

export type PaymentData = {
  additionalData?: Maybe<Scalars['Json']['output']>;
  method?: Maybe<Method>;
  /** URL to redirect the customer to */
  redirectURL?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethod = {
  /** Unique identifier of the payment method */
  id: Scalars['ID']['output'];
  issuers?: Maybe<Array<PaymentMethodOption>>;
  /** Human readable name of the payment method (localized) */
  name: Scalars['String']['output'];
  /** Payment method provider */
  provider: Scalars['String']['output'];
};

export type PaymentMethodArgumentInput = {
  /** Key of the argument */
  key: Scalars['String']['input'];
  /** Value of the argument */
  value: Scalars['String']['input'];
};

export type PaymentMethodGroup = {
  /** Human readable name of the payment method group (localized) */
  name: Scalars['String']['output'];
  /** Payment methods in this group */
  paymentMethod: Array<PaymentMethod>;
};

export type PaymentMethodInput = {
  /**
   * Optional arguments that can be passed to the payment provider. For example
   * the credit card number and expiry date
   */
  arguments?: InputMaybe<Array<PaymentMethodArgumentInput>>;
  browserInfo?: InputMaybe<Scalars['Json']['input']>;
  /** The payment id as returned by the PaymentMethod */
  id: Scalars['String']['input'];
  /** The provider that facilitates the payment. E.g. stripe or adyen */
  provider: Scalars['String']['input'];
};

export type PaymentMethodOption = {
  /** Unique identifier of the payment method option */
  id: Scalars['ID']['output'];
  /** Human readable name of the payment method (localized) */
  name: Scalars['String']['output'];
};

export type PaymentStatus =
  | 'BalanceDue'
  | 'CreditOwed'
  | 'Failed'
  | 'Paid'
  | 'Pending';

export type Product = UnderlineAttributes & {
  articles?: Maybe<Array<ContentPage>>;
  availability?: Maybe<ProductAvailability>;
  brand?: Maybe<Scalars['String']['output']>;
  breadcrumbs?: Maybe<Array<Breadcrumb>>;
  /** The categories to which the product belongs. */
  categories?: Maybe<Array<ProductCategory>>;
  /** Indicates the density of a fabric, mostly used in pantyhose */
  denier?: Maybe<Scalars['String']['output']>;
  /** Description of the fit of the product, e.g. 'loose', 'tight' */
  fit?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The primary image associated with the product. */
  image?: Maybe<ProductImage>;
  /** Instruction labels like isHazourdous, isRecalled */
  instructions?: Maybe<Array<Maybe<ProductSpecification>>>;
  localizedSlugs: Array<LocalizedSlug>;
  /** Marketing ribbons */
  marketingRibbons?: Maybe<Array<Maybe<ProductRibbon>>>;
  /** Materials used in the product */
  materials?: Maybe<ProductMaterials>;
  meta?: Maybe<ResourceMeta>;
  name: Scalars['String']['output'];
  /** Neckline of the product, used for tops and shirts */
  neckline?: Maybe<Scalars['String']['output']>;
  /** The amount of items in a pack */
  packSize?: Maybe<Scalars['Int']['output']>;
  /** The categories to which the product belongs. */
  primaryCategory?: Maybe<ProductCategory>;
  /** The primary variant, often used to show data in a product card */
  primaryVariant: ProductVariant;
  /** The product promotions */
  promotionRibbons?: Maybe<Array<Maybe<ProductRibbon>>>;
  /** Raw materials used in the product */
  rawMaterial?: Maybe<Scalars['String']['output']>;
  /** Products that are similar. E.g. the same t-shirt in another color. */
  relatedProducts?: Maybe<Array<Product>>;
  reviews?: Maybe<ProductReview>;
  sizeGuide?: Maybe<Array<Maybe<SizeGuideBlock>>>;
  /** Min and max sizes for the product */
  sizeRange?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** The lowest price of all variants, often used to communicate the price on the product list page. */
  startingPrice?: Maybe<TaxedPrice>;
  storeContext: StoreContext;
  usps?: Maybe<Usps>;
  variants: Array<ProductVariant>;
};


export type ProductLocalizedSlugsArgs = {
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ProductVariantsArgs = {
  sku?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductAttribute = {
  /** The label of the attribute, e.g. 'Color'. Localized to the current locale */
  label: Scalars['String']['output'];
  /** The name of the attribute, e.g. 'color'. Consistent across all locales */
  name: Scalars['String']['output'];
  /** Optional descriptive information about the attribute, Localized to the current locale */
  toolTip?: Maybe<Scalars['String']['output']>;
  /** The value of the attribute, e.g. 'Red'. Localized to the current locale */
  value: Scalars['String']['output'];
};

export type ProductAvailability =
  /**
   * The product is temporarily out of stock, but customers can still place orders.
   * The product will be shipped once it becomes available again.
   */
  | 'BACKORDER'
  /**
   * The product has been permanently discontinued and is no longer available for
   * purchase.
   */
  | 'DISCONTINUED'
  /** The product is currently in stock and available for purchase. */
  | 'IN_STOCK'
  /**
   * The product is not available for purchase.
   * It might be discontinued or permanently out of stock.
   */
  | 'NOT_AVAILABLE'
  /**
   * The product is temporarily unavailable because it is out of stock.
   * Customers cannot purchase it at the moment.
   */
  | 'OUT_OF_STOCK'
  /**
   * The product is not yet released but can be preordered.
   * Customers can reserve their copy in advance.
   */
  | 'PREORDER';

export type ProductCategory = {
  _storeContext: StoreContext;
  ancestors: Array<ProductCategory>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  storyblokName?: Maybe<Scalars['String']['output']>;
};

export type ProductCategoryReference = {
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
};

export type ProductEntityReference = {
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type ProductImage = {
  alt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The URL to the image. */
  url: Scalars['String']['output'];
};

export type ProductImage360 = {
  alt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** A list of URLs to the images. */
  urls: Array<Scalars['String']['output']>;
};

export type ProductInfo = {
  /** The product color label. */
  color?: Maybe<Scalars['String']['output']>;
  /** The product description. */
  descriptionShort?: Maybe<Scalars['String']['output']>;
  /** The name of the product. */
  name: Scalars['String']['output'];
  /** The order configuration contains restrictions about quantities that can be ordered */
  orderConfiguration?: Maybe<ProductOrderConfiguration>;
  /** The image associated with the product. */
  primaryImage?: Maybe<ProductInfoImage>;
  /** The product size label. */
  size?: Maybe<Scalars['String']['output']>;
  /** The SKU (stock keeping unit) for the variant. */
  sku: Scalars['String']['output'];
};

export type ProductInfoImage = {
  alt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The URL to the image. */
  url: Scalars['String']['output'];
};

export type ProductListingConfig = {
  categoryId: Scalars['String']['output'];
  categoryPageId: Scalars['String']['output'];
  defaultOrder?: Maybe<ProductSortOrder>;
  enabledFacets?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProductListingPage = AbstractPage & {
  afterBlocks?: Maybe<Array<Maybe<Block>>>;
  beforeBlocks?: Maybe<Array<Maybe<Block>>>;
  body?: Maybe<Array<ShopSection>>;
  breadcrumbs?: Maybe<Array<Breadcrumb>>;
  category?: Maybe<ProductCategoryReference>;
  description?: Maybe<Scalars['String']['output']>;
  full_slug: Scalars['String']['output'];
  hero?: Maybe<Hero>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  productListingConfig?: Maybe<ProductListingConfig>;
  seo?: Maybe<ContentSeo>;
  storeContext: StoreContext;
  title?: Maybe<Scalars['String']['output']>;
  translatedPaths?: Maybe<Array<TranslatedPath>>;
  usps?: Maybe<Usps>;
};

export type ProductMaterials = {
  base?: Maybe<Scalars['String']['output']>;
  filling?: Maybe<Scalars['String']['output']>;
  lining?: Maybe<Scalars['String']['output']>;
  outside?: Maybe<Scalars['String']['output']>;
};

export type ProductOrderConfiguration = {
  /** Whether the maximum order quantity is set, otherwise the default fallback will be used */
  hasMax?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum order quantity */
  max?: Maybe<Scalars['Int']['output']>;
  /** Minimum order quantity */
  min?: Maybe<Scalars['Int']['output']>;
  /** Step size (order per 2, 4, etc) */
  stepSize?: Maybe<Scalars['Int']['output']>;
};

export type ProductReview = {
  amount: Scalars['Int']['output'];
  averageRating: Scalars['Float']['output'];
  highestRating: Scalars['Float']['output'];
  lowestRating: Scalars['Float']['output'];
};

export type ProductRibbon = {
  /** Color of the ribbon, e.g. 'yellow', 'blue' */
  color?: Maybe<ProductRibbonColors>;
  /** Unique key for the ribbon */
  kind: Scalars['String']['output'];
  /** Text in the ribbon. Localized to the current locale */
  label?: Maybe<Scalars['String']['output']>;
};

export type ProductRibbonColors =
  | 'blue'
  | 'yellow';

export type ProductSearchResults = {
  facets?: Maybe<Array<Facet>>;
  queryID?: Maybe<Scalars['String']['output']>;
  results: Array<Product>;
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ProductSortOrder =
  | 'nameAscending'
  | 'nameDescending'
  | 'popularity'
  | 'priceAscending'
  | 'priceDescending';

export type ProductSpecification = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ProductSpecificationAttribute = ProductSpecificationBooleanAttribute | ProductSpecificationDateTimeAttribute | ProductSpecificationEnumAttribute | ProductSpecificationEnumListAttribute | ProductSpecificationNumberAttribute | ProductSpecificationStringAttribute;

export type ProductSpecificationBooleanAttribute = AbstractProductSpecificationAttribute & {
  /** Optional descriptive information about the attribute, Localized to the current locale */
  description?: Maybe<Scalars['String']['output']>;
  /** The label of the attribute, e.g. 'Is fragile'. Localized to the current locale */
  label: Scalars['String']['output'];
  /** The name of the attribute, e.g. 'isFragile'. Consistent across all locales */
  name: Scalars['String']['output'];
  /** The boolean value of the attribute, e.g. true */
  value: Scalars['Boolean']['output'];
};

export type ProductSpecificationDateTimeAttribute = AbstractProductSpecificationAttribute & {
  /** Optional descriptive information about the attribute, Localized to the current locale */
  description?: Maybe<Scalars['String']['output']>;
  /** The label of the attribute, e.g. 'Available from'. Localized to the current locale */
  label: Scalars['String']['output'];
  /** The name of the attribute, e.g. 'availableFrom'. Consistent across all locales */
  name: Scalars['String']['output'];
  /** The datetime value of the attribute, e.g. 2024-08-14T07:52:15.520Z */
  value: Scalars['DateTime']['output'];
};

export type ProductSpecificationEnumAttribute = AbstractProductSpecificationAttribute & {
  /** Optional descriptive information about the attribute, Localized to the current locale */
  description?: Maybe<Scalars['String']['output']>;
  /** The label of the attribute, e.g. 'Season'. Localized to the current locale */
  label: Scalars['String']['output'];
  /** The name of the attribute, e.g. 'season'. Consistent across all locales */
  name: Scalars['String']['output'];
  /** The enum value of the attribute */
  value: ProductSpecificationEnumValue;
};

export type ProductSpecificationEnumListAttribute = AbstractProductSpecificationAttribute & {
  /** Optional descriptive information about the attribute, Localized to the current locale */
  description?: Maybe<Scalars['String']['output']>;
  /** The label of the attribute, e.g. 'Audiences'. Localized to the current locale */
  label: Scalars['String']['output'];
  /** The name of the attribute, e.g. 'audiences'. Consistent across all locales */
  name: Scalars['String']['output'];
  /** The enumc values of the attribute */
  values: Array<Maybe<ProductSpecificationEnumValue>>;
};

export type ProductSpecificationEnumValue = {
  /** The label of the enum, e.g. 'green'. Consistent across all locales */
  label: Scalars['String']['output'];
  /** The string value of the enum, e.g. 'Green' */
  value: Scalars['String']['output'];
};

export type ProductSpecificationGroup = {
  /** Attributes for this specification group. These reflect a list of all the attributes associated with this group. */
  attributes: Array<ProductSpecificationAttribute>;
  /** Optional descriptive information about the attribute group, Localized to the current locale */
  description?: Maybe<Scalars['String']['output']>;
  /** The label of the attribute group, e.g. 'Generic'. Localized to the current locale */
  label: Scalars['String']['output'];
  /** The name of the attribute group, e.g. 'generic'. Consistent across all locales */
  name: Scalars['String']['output'];
};

export type ProductSpecificationNumberAttribute = AbstractProductSpecificationAttribute & {
  /** Optional descriptive information about the attribute, Localized to the current locale */
  description?: Maybe<Scalars['String']['output']>;
  /** The label of the attribute, e.g. 'Length'. Localized to the current locale */
  label: Scalars['String']['output'];
  /** The name of the attribute, e.g. 'length'. Consistent across all locales */
  name: Scalars['String']['output'];
  /** The integer value of the attribute, e.g. 1 */
  value: Scalars['Float']['output'];
};

export type ProductSpecificationStringAttribute = AbstractProductSpecificationAttribute & {
  /** Optional descriptive information about the attribute, Localized to the current locale */
  description?: Maybe<Scalars['String']['output']>;
  /** The label of the attribute, e.g. 'Size'. Localized to the current locale */
  label: Scalars['String']['output'];
  /** The name of the attribute, e.g. 'size'. Consistent across all locales */
  name: Scalars['String']['output'];
  /** The string value of the attribute, e.g. 'XL'. Localized to the current locale */
  value: Scalars['String']['output'];
};

export type ProductVariant = {
  /** All product attributes set for this variant */
  attributes?: Maybe<Array<ProductAttribute>>;
  availability?: Maybe<ProductAvailability>;
  availabilityQuantity?: Maybe<Scalars['Int']['output']>;
  /**
   * A description about when the product can be delivered. For example: Ordered
   * before 23:00, delivered tomorrow.
   */
  deliveryTime?: Maybe<Scalars['String']['output']>;
  /** The variant description, can be formatted using Markdown. */
  description?: Maybe<Scalars['String']['output']>;
  /** European Article Number (EAN) */
  ean?: Maybe<Scalars['String']['output']>;
  /** Harmonized System (HS) code for the variant. */
  hscode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** All images associated with the product variant. */
  images?: Maybe<Array<ProductImage>>;
  /**
   * Represents the list price, also known as te Manufacturer's Suggested Retail
   * Price (MSRP).  It's the highest price shown and could be used as the
   * strikethrough price to indicate the original value of the product before any
   * discounts.
   */
  listPrice?: Maybe<TaxedPrice>;
  /** The name of the variant. */
  name?: Maybe<Scalars['String']['output']>;
  /** The order configuration contains restrictions about quantities that can be ordered */
  orderConfiguration?: Maybe<ProductOrderConfiguration>;
  /**
   * The price on the platform after regular product discounts are applied, it's
   * the price communicated to the customer in the storefront.
   */
  price?: Maybe<TaxedPrice>;
  /** The main image associated with the product variant. */
  primaryImage?: Maybe<ProductImage>;
  /**
   * The regular selling price on the platform, potentially already discounted
   * from the MSRP. It's the standard price at which the product is usually offered
   * when there are no special sales or additional discounts.
   */
  regularPrice?: Maybe<TaxedPrice>;
  /** The SKU (stock keeping unit) for the variant. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The product specifications attribute groups and the associated attributes. */
  specifications?: Maybe<Array<ProductSpecificationGroup>>;
};


export type ProductVariantAttributesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProductYouTubeVideo = {
  alt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The YouTube video ID. */
  videoId: Scalars['String']['output'];
};

export type ProductsResult = {
  lastId?: Maybe<Scalars['String']['output']>;
  results: Array<Product>;
  total: Scalars['Int']['output'];
};

export type Query = {
  addressValidate?: Maybe<AddressValidationResult>;
  availablePaymentMethods: Array<PaymentMethodGroup>;
  cart?: Maybe<Cart>;
  companyReview?: Maybe<CompanyReview>;
  customer?: Maybe<Customer>;
  customerExists: CustomerExistsResult;
  /** Returns the requested order for the current user. */
  order?: Maybe<Order>;
  /** Returns the requested order overview for a global user. This is meant for anonymous viewing of orders. */
  orderConfirmation?: Maybe<Order>;
  orderPaymentStatus?: Maybe<Scalars['String']['output']>;
  /**
   * Returns the list of orders for the current user. If a search term is provided the results will be filtered to match
   * the search term. The results will be sorted with the most recent order shown first.
   */
  orders?: Maybe<OrderResult>;
  page?: Maybe<Page>;
  pageRedirect?: Maybe<PageRedirect>;
  pages: PagesResult;
  product?: Maybe<Product>;
  productSearch?: Maybe<ProductSearchResults>;
  products?: Maybe<ProductsResult>;
  site?: Maybe<Site>;
  store?: Maybe<Store>;
};


export type QueryAddressValidateArgs = {
  address: AddressInput;
  storeContext: StoreContextInput;
};


export type QueryAvailablePaymentMethodsArgs = {
  device: ClientDevice;
  orderId: Scalars['String']['input'];
  storeContext: StoreContextInput;
};


export type QueryCartArgs = {
  recalculate?: InputMaybe<Scalars['Boolean']['input']>;
  storeContext: StoreContextInput;
};


export type QueryCompanyReviewArgs = {
  storeContext: StoreContextInput;
};


export type QueryCustomerExistsArgs = {
  email: Scalars['String']['input'];
  storeContext: StoreContextInput;
};


export type QueryOrderArgs = {
  orderId: Scalars['String']['input'];
  storeContext: StoreContextInput;
};


export type QueryOrderConfirmationArgs = {
  orderId: Scalars['String']['input'];
  storeContext: StoreContextInput;
};


export type QueryOrderPaymentStatusArgs = {
  orderId: Scalars['String']['input'];
  storeContext: StoreContextInput;
};


export type QueryOrdersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  storeContext: StoreContextInput;
};


export type QueryPageArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  path: Scalars['String']['input'];
  previewID?: InputMaybe<Scalars['String']['input']>;
  storeContext: StoreContextInput;
  version?: InputMaybe<ContentVersion>;
};


export type QueryPageRedirectArgs = {
  pageType: PageRedirectPageType;
  path: Scalars['String']['input'];
  storeContext: StoreContextInput;
};


export type QueryPagesArgs = {
  includeCountryUnique?: Scalars['Boolean']['input'];
  includeShared?: Scalars['Boolean']['input'];
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  storeContext: StoreContextInput;
  version?: InputMaybe<ContentVersion>;
};


export type QueryProductArgs = {
  slug: Scalars['String']['input'];
  storeContext: StoreContextInput;
};


export type QueryProductSearchArgs = {
  categoryPageId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FacetFilterInput>>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort: ProductSortOrder;
  storeContext: StoreContextInput;
};


export type QueryProductsArgs = {
  excludeOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
  fromId?: InputMaybe<Scalars['String']['input']>;
  pageSize?: Scalars['Int']['input'];
  storeContext: StoreContextInput;
};


export type QuerySiteArgs = {
  previewID?: InputMaybe<Scalars['String']['input']>;
  storeContext: StoreContextInput;
  version?: InputMaybe<ContentVersion>;
};


export type QueryStoreArgs = {
  slug: Scalars['String']['input'];
};

export type RangeFacet = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  selectedMax?: Maybe<Scalars['Int']['output']>;
  selectedMin?: Maybe<Scalars['Int']['output']>;
};

export type RefreshTokenResponse = {
  success: Scalars['Boolean']['output'];
};

export type ResourceLink = {
  hash?: Maybe<Scalars['String']['output']>;
  newTab: Scalars['Boolean']['output'];
  pathname?: Maybe<Scalars['String']['output']>;
  type: ResourceLinkType;
  url: Scalars['String']['output'];
};

export type ResourceLinkType =
  | 'asset'
  | 'email'
  | 'external'
  | 'internal';

export type ResourceMeta = {
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RichText = {
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Salutation =
  | 'F'
  | 'M';

export type Section = {
  backgroundColor?: Maybe<SectionColor>;
  body: Array<Block>;
  id: Scalars['ID']['output'];
  size?: Maybe<SectionSize>;
  spacing?: Maybe<SectionSpacing>;
};

export type SectionColor =
  | 'gray'
  | 'white';

export type SectionHeader = AbstractHeader & {
  bodyText?: Maybe<RichText>;
  buttons?: Maybe<Array<Button>>;
  id: Scalars['ID']['output'];
  image?: Maybe<ContentAsset>;
  imagePosition?: Maybe<ImagePosition>;
  imageStyle?: Maybe<ImageStyle>;
  title: Scalars['String']['output'];
};

export type SectionSize =
  | 'full'
  | 'full_bleed'
  | 'large'
  | 'medium'
  | 'small';

export type SectionSpacing =
  | 'bottom'
  | 'none'
  | 'top'
  | 'top_bottom';

export type ShippingMethod = {
  /** Shipping method enabled */
  enabled: Scalars['Boolean']['output'];
  /** Unique key of the shipping method */
  key: Scalars['String']['output'];
  /** Shipping method price */
  price: Money;
};

export type ShippingOption =
  | 'home_delivery'
  | 'pick_up_point';

export type ShopSection = {
  category?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productReferences?: Maybe<Array<Scalars['ID']['output']>>;
  products?: Maybe<Array<Product>>;
  storeContext: StoreContext;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  variant: ComponentVariant;
  viewAllLabel?: Maybe<Scalars['String']['output']>;
  viewAllLink?: Maybe<ResourceLink>;
};

export type ShopSectionProduct = {
  id: Scalars['ID']['output'];
};

export type Site = {
  businessLabel?: Maybe<Scalars['String']['output']>;
  businessPage?: Maybe<ResourceLink>;
  carriers?: Maybe<Array<ContentAsset>>;
  cookiesLabel?: Maybe<Scalars['String']['output']>;
  cookiesPage?: Maybe<ResourceLink>;
  customerService?: Maybe<RichText>;
  customerServiceEmail?: Maybe<Scalars['String']['output']>;
  customerServiceHours?: Maybe<Scalars['String']['output']>;
  customerServicePhone?: Maybe<Scalars['String']['output']>;
  disclaimerLabel?: Maybe<Scalars['String']['output']>;
  disclaimerPage?: Maybe<ResourceLink>;
  facebook?: Maybe<ResourceLink>;
  faqItems?: Maybe<Array<FaqItem>>;
  footerLogo: ContentAsset;
  footerMenu?: Maybe<Array<MenuBlock>>;
  id: Scalars['ID']['output'];
  instagram?: Maybe<ResourceLink>;
  linkedIn?: Maybe<ResourceLink>;
  logo: ContentAsset;
  mainMenu?: Maybe<Array<TopMenuOption>>;
  newsletterCTABody?: Maybe<Scalars['String']['output']>;
  newsletterCTATitle?: Maybe<Scalars['String']['output']>;
  notificationBanners?: Maybe<Array<NotificationBanner>>;
  organizationAddress?: Maybe<OrganizationAddress>;
  paymentMethods?: Maybe<Array<ContentAsset>>;
  paymentTerms?: Maybe<RichText>;
  pinterest?: Maybe<ResourceLink>;
  privacyLabel?: Maybe<Scalars['String']['output']>;
  privacyPage?: Maybe<ResourceLink>;
  serviceLabel?: Maybe<Scalars['String']['output']>;
  servicePage?: Maybe<ResourceLink>;
  showNewsletterCTA: Scalars['Boolean']['output'];
  socialsHeading?: Maybe<Scalars['String']['output']>;
  termsLabel?: Maybe<Scalars['String']['output']>;
  termsPage?: Maybe<ResourceLink>;
  tiktok?: Maybe<ResourceLink>;
  trustMarks?: Maybe<Array<ContentAsset>>;
  usps?: Maybe<Array<Usps>>;
  youtube?: Maybe<ResourceLink>;
};

export type SizeGuideBlock = CountrySpecificContainer | Image | RichText | Table;

export type Store = {
  address?: Maybe<StoreAddress>;
  coordinates: StoreCoordinates;
  name: Scalars['String']['output'];
  nearbyStores?: Maybe<Array<NearbyStore>>;
  openingHours?: Maybe<StoreOpeningHours>;
  slug: Scalars['String']['output'];
  storeCode?: Maybe<Scalars['String']['output']>;
};

export type StoreAddress = {
  addressLine: Scalars['String']['output'];
  city: Scalars['String']['output'];
  countryId?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type StoreContext = {
  /** The currency used in the store context. */
  currency: Scalars['String']['output'];
  /** The locale of the store context. For example: en-US. */
  locale: Scalars['String']['output'];
  /** The store key associated with the store context. */
  storeKey: Scalars['String']['output'];
};

export type StoreContextInput = {
  /** The currency used in the store context. */
  currency: Scalars['String']['input'];
  /** The locale of the store context. For example: en-US. */
  locale: Scalars['String']['input'];
  /** The store key associated with the store context. */
  storeKey: Scalars['String']['input'];
};

export type StoreCoordinates = {
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type StoreOpeningHours = {
  fridayclose1?: Maybe<Scalars['Int']['output']>;
  fridayclose2?: Maybe<Scalars['Int']['output']>;
  fridayopen1?: Maybe<Scalars['Int']['output']>;
  fridayopen2?: Maybe<Scalars['Int']['output']>;
  mondayclose1?: Maybe<Scalars['Int']['output']>;
  mondayclose2?: Maybe<Scalars['Int']['output']>;
  mondayopen1?: Maybe<Scalars['Int']['output']>;
  mondayopen2?: Maybe<Scalars['Int']['output']>;
  saturdayclose1?: Maybe<Scalars['Int']['output']>;
  saturdayclose2?: Maybe<Scalars['Int']['output']>;
  saturdayopen1?: Maybe<Scalars['Int']['output']>;
  saturdayopen2?: Maybe<Scalars['Int']['output']>;
  sundayclose1?: Maybe<Scalars['Int']['output']>;
  sundayclose2?: Maybe<Scalars['Int']['output']>;
  sundayopen1?: Maybe<Scalars['Int']['output']>;
  sundayopen2?: Maybe<Scalars['Int']['output']>;
  thursdayclose1?: Maybe<Scalars['Int']['output']>;
  thursdayclose2?: Maybe<Scalars['Int']['output']>;
  thursdayopen1?: Maybe<Scalars['Int']['output']>;
  thursdayopen2?: Maybe<Scalars['Int']['output']>;
  tuesdayclose1?: Maybe<Scalars['Int']['output']>;
  tuesdayclose2?: Maybe<Scalars['Int']['output']>;
  tuesdayopen1?: Maybe<Scalars['Int']['output']>;
  tuesdayopen2?: Maybe<Scalars['Int']['output']>;
  wednesdayclose1?: Maybe<Scalars['Int']['output']>;
  wednesdayclose2?: Maybe<Scalars['Int']['output']>;
  wednesdayopen1?: Maybe<Scalars['Int']['output']>;
  wednesdayopen2?: Maybe<Scalars['Int']['output']>;
};

/** A second level menu item with a submenu */
export type SubMenuItem = {
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  link?: Maybe<ResourceLink>;
  subMenuLinks: Array<MenuLink>;
};

export type Table = {
  dividers: TableDividers;
  id: Scalars['ID']['output'];
  style: TableStyle;
  table: ContentTable;
  width: TableWidth;
};

export type TableDividers =
  | 'all'
  | 'horizontal'
  | 'none'
  | 'vertical';

export type TableStyle =
  | 'highlightLeft'
  | 'highlightTop'
  | 'none'
  | 'zebra';

export type TableWidth =
  | 'fit'
  | 'scroll';

export type Tax = {
  /** Rate of the tax line item as percentage from 0 to 1. */
  rate: Scalars['Float']['output'];
  /** Value in money of the tax line item. */
  value: Money;
};

export type TaxedPrice = {
  gross: Money;
  net: Money;
  tax: Tax;
};

/** A total price consists of items that can have different tax rates. */
export type TaxedTotalPrice = {
  gross: Money;
  net: Money;
  taxes: Array<Tax>;
};

export type Teaser = {
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: ContentAsset;
  link: ResourceLink;
  title: Scalars['String']['output'];
};

export type TeaserRow = {
  id: Scalars['ID']['output'];
  items: Array<Teaser>;
  title: Scalars['String']['output'];
  /** If empty, no view more button will be shown */
  viewMoreLink?: Maybe<ResourceLink>;
};

export type ThreeColumns = {
  alignment: ColumnAlignment;
  column_1: Array<ColumnBlock>;
  column_2: Array<ColumnBlock>;
  column_3: Array<ColumnBlock>;
  id: Scalars['ID']['output'];
};

export type ToggleFacet = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<FacetValue>;
};

export type TopMenuOption = MenuItem | MenuLink;

export type TranslatedPath = {
  locale: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type TwoColumns = {
  alignment: ColumnAlignment;
  column_1: Array<ColumnBlock>;
  column_2: Array<ColumnBlock>;
  id: Scalars['ID']['output'];
  ratio: TwoColumnsRatio;
};

export type TwoColumnsRatio =
  /** 50 / 50 */
  | 'equal'
  /** 60 / 40 */
  | 'leftBig'
  /** 40 / 60 */
  | 'rightBig';

export type UgcFlowbox = {
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  tags?: Maybe<Scalars['String']['output']>;
};

export type UnderlineAttributes = {
  /** Brand of the product */
  brand?: Maybe<Scalars['String']['output']>;
  /** Indicates the density of a fabric, mostly used in pantyhose */
  denier?: Maybe<Scalars['String']['output']>;
  /** Description of the fit of the product, e.g. 'loose', 'tight' */
  fit?: Maybe<Scalars['String']['output']>;
  /** Neckline of the product, used for tops and shirts */
  neckline?: Maybe<Scalars['String']['output']>;
  /** The amount of items in a pack */
  packSize?: Maybe<Scalars['Int']['output']>;
  /** Raw materials used in the product */
  rawMaterial?: Maybe<Scalars['String']['output']>;
};

export type Usps = {
  id: Scalars['ID']['output'];
  usp1: Scalars['String']['output'];
  usp1Link?: Maybe<ResourceLink>;
  usp2: Scalars['String']['output'];
  usp2Link?: Maybe<ResourceLink>;
  usp3: Scalars['String']['output'];
  usp3Link?: Maybe<ResourceLink>;
};

export type Video = {
  id: Scalars['ID']['output'];
  video: Scalars['String']['output'];
};

export type Join__Graph =
  | 'ACCOUNT'
  | 'CATALOG'
  | 'CHECKOUT'
  | 'CMS'
  | 'ORDER'
  | 'REDIRECT'
  | 'REVIEWS'
  | 'STORE_FINDER';

export type Link__Purpose =
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  | 'EXECUTION'
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  | 'SECURITY';

export type StoreContentPreviewData = {
  id?: Maybe<Scalars['ID']['output']>;
};

export type StoreContentPreviewDataMutationVariables = Exact<{
  path: Scalars['String']['input'];
  data: Scalars['String']['input'];
}>;


export type StoreContentPreviewDataMutation = { storeContentPreview: { id?: string | null } };

export type FooterNewsletterFragmentFragment = { showNewsletterCTA: boolean, newsletterCTATitle?: string | null, newsletterCTABody?: string | null };

export type NewsletterSignUpMutationVariables = Exact<{
  storeContext: StoreContextInput;
  email: Scalars['String']['input'];
}>;


export type NewsletterSignUpMutation = { newsletterSignUp?: boolean | null };

export type GetCompanyReviewQueryVariables = Exact<{
  storeContext: StoreContextInput;
}>;


export type GetCompanyReviewQuery = { companyReview?: { amount: number, totalAmount?: number | null, averageRating: number } | null };

export type GetSiteQueryVariables = Exact<{
  storeContext: StoreContextInput;
  version: ContentVersion;
  previewID?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSiteQuery = { site?: { __typename: 'Site', id: string, customerServiceEmail?: string | null, customerServiceHours?: string | null, customerServicePhone?: string | null, socialsHeading?: string | null, businessLabel?: string | null, serviceLabel?: string | null, disclaimerLabel?: string | null, termsLabel?: string | null, cookiesLabel?: string | null, privacyLabel?: string | null, showNewsletterCTA: boolean, newsletterCTATitle?: string | null, newsletterCTABody?: string | null, logo: { filename: string, alt?: string | null, focus?: string | null }, organizationAddress?: { postalCode?: string | null, locality?: string | null, country?: string | null, street?: string | null } | null, footerLogo: { filename: string, alt?: string | null, focus?: string | null }, mainMenu?: Array<{ __typename: 'MenuItem', id: string, label: string, subMenuItems: Array<{ __typename: 'MenuItem', id: string, label: string, subMenuItems: Array<{ __typename: 'MenuItem', id: string, label: string, optionalLink?: { url: string } | null } | { __typename: 'MenuLink', id: string, label: string, link: { url: string, newTab: boolean } }>, optionalLink?: { url: string } | null } | { __typename: 'MenuLink', id: string, label: string, link: { url: string, newTab: boolean } }>, optionalLink?: { url: string } | null } | { __typename: 'MenuLink', id: string, label: string, link: { url: string, newTab: boolean } }> | null, footerMenu?: Array<{ __typename: 'MenuBlock', id: string, label: string, menuLinks: Array<{ __typename: 'MenuLink', id: string, label: string, link: { url: string, newTab: boolean } }> }> | null, paymentMethods?: Array<{ filename: string, alt?: string | null, focus?: string | null }> | null, faqItems?: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> | null, trustMarks?: Array<{ filename: string, alt?: string | null, focus?: string | null }> | null, carriers?: Array<{ filename: string, alt?: string | null, focus?: string | null }> | null, paymentTerms?: { __typename: 'RichText', id: string, content: string } | null, facebook?: { url: string } | null, instagram?: { url: string } | null, linkedIn?: { url: string } | null, youtube?: { url: string } | null, tiktok?: { url: string } | null, pinterest?: { url: string } | null, businessPage?: { url: string, newTab: boolean } | null, servicePage?: { url: string, newTab: boolean } | null, disclaimerPage?: { url: string, newTab: boolean } | null, termsPage?: { url: string, newTab: boolean } | null, cookiesPage?: { url: string, newTab: boolean } | null, privacyPage?: { url: string, newTab: boolean } | null, usps?: Array<{ id: string, usp1: string, usp2: string, usp3: string, usp1Link?: { url: string, newTab: boolean, hash?: string | null } | null, usp2Link?: { url: string, newTab: boolean, hash?: string | null } | null, usp3Link?: { url: string, newTab: boolean, hash?: string | null } | null }> | null, notificationBanners?: Array<{ __typename: 'NotificationBanner', id: string, text: string, linkLabel?: string | null, optionalLink?: { url: string } | null }> | null } | null };

export type SiteFragment = { __typename: 'Site', id: string, customerServiceEmail?: string | null, customerServiceHours?: string | null, customerServicePhone?: string | null, socialsHeading?: string | null, businessLabel?: string | null, serviceLabel?: string | null, disclaimerLabel?: string | null, termsLabel?: string | null, cookiesLabel?: string | null, privacyLabel?: string | null, showNewsletterCTA: boolean, newsletterCTATitle?: string | null, newsletterCTABody?: string | null, logo: { filename: string, alt?: string | null, focus?: string | null }, organizationAddress?: { postalCode?: string | null, locality?: string | null, country?: string | null, street?: string | null } | null, footerLogo: { filename: string, alt?: string | null, focus?: string | null }, mainMenu?: Array<{ __typename: 'MenuItem', id: string, label: string, subMenuItems: Array<{ __typename: 'MenuItem', id: string, label: string, subMenuItems: Array<{ __typename: 'MenuItem', id: string, label: string, optionalLink?: { url: string } | null } | { __typename: 'MenuLink', id: string, label: string, link: { url: string, newTab: boolean } }>, optionalLink?: { url: string } | null } | { __typename: 'MenuLink', id: string, label: string, link: { url: string, newTab: boolean } }>, optionalLink?: { url: string } | null } | { __typename: 'MenuLink', id: string, label: string, link: { url: string, newTab: boolean } }> | null, footerMenu?: Array<{ __typename: 'MenuBlock', id: string, label: string, menuLinks: Array<{ __typename: 'MenuLink', id: string, label: string, link: { url: string, newTab: boolean } }> }> | null, paymentMethods?: Array<{ filename: string, alt?: string | null, focus?: string | null }> | null, faqItems?: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> | null, trustMarks?: Array<{ filename: string, alt?: string | null, focus?: string | null }> | null, carriers?: Array<{ filename: string, alt?: string | null, focus?: string | null }> | null, paymentTerms?: { __typename: 'RichText', id: string, content: string } | null, facebook?: { url: string } | null, instagram?: { url: string } | null, linkedIn?: { url: string } | null, youtube?: { url: string } | null, tiktok?: { url: string } | null, pinterest?: { url: string } | null, businessPage?: { url: string, newTab: boolean } | null, servicePage?: { url: string, newTab: boolean } | null, disclaimerPage?: { url: string, newTab: boolean } | null, termsPage?: { url: string, newTab: boolean } | null, cookiesPage?: { url: string, newTab: boolean } | null, privacyPage?: { url: string, newTab: boolean } | null, usps?: Array<{ id: string, usp1: string, usp2: string, usp3: string, usp1Link?: { url: string, newTab: boolean, hash?: string | null } | null, usp2Link?: { url: string, newTab: boolean, hash?: string | null } | null, usp3Link?: { url: string, newTab: boolean, hash?: string | null } | null }> | null, notificationBanners?: Array<{ __typename: 'NotificationBanner', id: string, text: string, linkLabel?: string | null, optionalLink?: { url: string } | null }> | null };

export type MainMenuFragment = { __typename: 'MenuItem', id: string, label: string, subMenuItems: Array<{ __typename: 'MenuItem', id: string, label: string, subMenuItems: Array<{ __typename: 'MenuItem', id: string, label: string, optionalLink?: { url: string } | null } | { __typename: 'MenuLink', id: string, label: string, link: { url: string, newTab: boolean } }>, optionalLink?: { url: string } | null } | { __typename: 'MenuLink', id: string, label: string, link: { url: string, newTab: boolean } }>, optionalLink?: { url: string } | null };

export type MenuItemFieldsFragment = { __typename: 'MenuItem', id: string, label: string, optionalLink?: { url: string } | null };

export type MenuLinkFragment = { __typename: 'MenuLink', id: string, label: string, link: { url: string, newTab: boolean } };

export type MenuBlockFragment = { __typename: 'MenuBlock', id: string, label: string, menuLinks: Array<{ __typename: 'MenuLink', id: string, label: string, link: { url: string, newTab: boolean } }> };

export type NotificationBannerFragment = { __typename: 'NotificationBanner', id: string, text: string, linkLabel?: string | null, optionalLink?: { url: string } | null };

export type CustomerPasswordResetMutationVariables = Exact<{
  storeContext: StoreContextInput;
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type CustomerPasswordResetMutation = { customerPasswordReset: { firstName?: string | null, lastName?: string | null, accountType: AccountType, company?: string | null, email: string, vatNumber?: string | null, billingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, shippingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, addresses?: Array<{ id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null }> | null } };

export type CustomerPasswordResetRequestMutationVariables = Exact<{
  storeContext: StoreContextInput;
  email: Scalars['String']['input'];
}>;


export type CustomerPasswordResetRequestMutation = { customerPasswordResetRequest?: boolean | null };

export type CustomerCreateMutationVariables = Exact<{
  storeContext: StoreContextInput;
  customer: CustomerCreateInput;
}>;


export type CustomerCreateMutation = { customerCreate: { firstName?: string | null, lastName?: string | null, accountType: AccountType, company?: string | null, email: string, vatNumber?: string | null, billingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, shippingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, addresses?: Array<{ id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null }> | null } };

export type CustomerPasswordUpdateMutationVariables = Exact<{
  storeContext: StoreContextInput;
  password: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type CustomerPasswordUpdateMutation = { customerPasswordUpdate: { firstName?: string | null, lastName?: string | null, accountType: AccountType, company?: string | null, email: string, vatNumber?: string | null, billingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, shippingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, addresses?: Array<{ id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null }> | null } };

type AbstractPageFragment_ArticlePage_Fragment = { __typename: 'ArticlePage', id: string, name: string, path: string, translatedPaths?: Array<{ locale: string, path: string }> | null, breadcrumbs?: Array<{ name: string, path: string }> | null, seo?: { __typename: 'ContentSEO', title?: string | null, description?: string | null, ogTitle?: string | null, ogDescription?: string | null, ogImage?: string | null, twitterTitle?: string | null, twitterDescription?: string | null, twitterImage?: string | null } | null };

type AbstractPageFragment_ContentPage_Fragment = { __typename: 'ContentPage', id: string, name: string, path: string, translatedPaths?: Array<{ locale: string, path: string }> | null, breadcrumbs?: Array<{ name: string, path: string }> | null, seo?: { __typename: 'ContentSEO', title?: string | null, description?: string | null, ogTitle?: string | null, ogDescription?: string | null, ogImage?: string | null, twitterTitle?: string | null, twitterDescription?: string | null, twitterImage?: string | null } | null };

type AbstractPageFragment_FaqPage_Fragment = { __typename: 'FAQPage', id: string, name: string, path: string, translatedPaths?: Array<{ locale: string, path: string }> | null, breadcrumbs?: Array<{ name: string, path: string }> | null, seo?: { __typename: 'ContentSEO', title?: string | null, description?: string | null, ogTitle?: string | null, ogDescription?: string | null, ogImage?: string | null, twitterTitle?: string | null, twitterDescription?: string | null, twitterImage?: string | null } | null };

type AbstractPageFragment_ProductListingPage_Fragment = { __typename: 'ProductListingPage', id: string, name: string, path: string, translatedPaths?: Array<{ locale: string, path: string }> | null, breadcrumbs?: Array<{ name: string, path: string }> | null, seo?: { __typename: 'ContentSEO', title?: string | null, description?: string | null, ogTitle?: string | null, ogDescription?: string | null, ogImage?: string | null, twitterTitle?: string | null, twitterDescription?: string | null, twitterImage?: string | null } | null };

export type AbstractPageFragmentFragment = AbstractPageFragment_ArticlePage_Fragment | AbstractPageFragment_ContentPage_Fragment | AbstractPageFragment_FaqPage_Fragment | AbstractPageFragment_ProductListingPage_Fragment;

export type ContentSeoFragmentFragment = { __typename: 'ContentSEO', title?: string | null, description?: string | null, ogTitle?: string | null, ogDescription?: string | null, ogImage?: string | null, twitterTitle?: string | null, twitterDescription?: string | null, twitterImage?: string | null };

export type ContentPageFragmentFragment = { __typename: 'ContentPage', description?: string | null, id: string, name: string, path: string, contentPageTitle?: string | null, hero?: { __typename: 'Hero', id: string, title: string, variant?: HeroVariant | null, imagePosition: ImagePosition, imageStyle: ImageStyle, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, image?: { filename: string, alt?: string | null, focus?: string | null } | null } | null, usps?: { id: string, usp1: string, usp2: string, usp3: string, usp1Link?: { url: string, newTab: boolean, hash?: string | null } | null, usp2Link?: { url: string, newTab: boolean, hash?: string | null } | null, usp3Link?: { url: string, newTab: boolean, hash?: string | null } | null } | null, body?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'CountrySpecificContainer', id: string, countries: Array<string>, countrySpecificContainerBody?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null, translatedPaths?: Array<{ locale: string, path: string }> | null, breadcrumbs?: Array<{ name: string, path: string }> | null, seo?: { __typename: 'ContentSEO', title?: string | null, description?: string | null, ogTitle?: string | null, ogDescription?: string | null, ogImage?: string | null, twitterTitle?: string | null, twitterDescription?: string | null, twitterImage?: string | null } | null };

export type FaqPageFragmentFragment = { __typename: 'FAQPage', title: string, id: string, name: string, path: string, faqGroups: Array<{ id: string, title: string, slug?: string | null, translatedPaths?: Array<{ locale: string, path: string }> | null, icon?: { filename: string, alt?: string | null, focus?: string | null } | null, leadText?: { __typename: 'RichText', id: string, content: string } | null, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> }>, translatedPaths?: Array<{ locale: string, path: string }> | null, breadcrumbs?: Array<{ name: string, path: string }> | null, seo?: { __typename: 'ContentSEO', title?: string | null, description?: string | null, ogTitle?: string | null, ogDescription?: string | null, ogImage?: string | null, twitterTitle?: string | null, twitterDescription?: string | null, twitterImage?: string | null } | null };

type BaseBlocksFragment_ArticleOverview_Fragment = { __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } };

type BaseBlocksFragment_BlockQuote_Fragment = { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string };

type BaseBlocksFragment_Buttons_Fragment = { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null };

type BaseBlocksFragment_Card_Fragment = {};

type BaseBlocksFragment_CategorySection_Fragment = { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> };

type BaseBlocksFragment_CookieDeclaration_Fragment = { __typename: 'CookieDeclaration', id: string };

type BaseBlocksFragment_CountrySpecificContainer_Fragment = {};

type BaseBlocksFragment_Divider_Fragment = { __typename: 'Divider', id: string };

type BaseBlocksFragment_FaqItemList_Fragment = { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> };

type BaseBlocksFragment_FourColumns_Fragment = { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> };

type BaseBlocksFragment_Iframe_Fragment = { __typename: 'Iframe', id: string, url: string, height?: number | null };

type BaseBlocksFragment_Image_Fragment = { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } };

type BaseBlocksFragment_Jafix_Fragment = { __typename: 'Jafix', id: string, key: string };

type BaseBlocksFragment_NewsletterCta_Fragment = { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation };

type BaseBlocksFragment_RichText_Fragment = { __typename: 'RichText', id: string, content: string };

type BaseBlocksFragment_Section_Fragment = { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> };

type BaseBlocksFragment_SectionHeader_Fragment = { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null };

type BaseBlocksFragment_ShopSection_Fragment = { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null };

type BaseBlocksFragment_Table_Fragment = { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } };

type BaseBlocksFragment_TeaserRow_Fragment = { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> };

type BaseBlocksFragment_ThreeColumns_Fragment = { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> };

type BaseBlocksFragment_TwoColumns_Fragment = { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> };

type BaseBlocksFragment_UgcFlowbox_Fragment = { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null };

type BaseBlocksFragment_Video_Fragment = { __typename: 'Video', id: string, video: string };

export type BaseBlocksFragmentFragment = BaseBlocksFragment_ArticleOverview_Fragment | BaseBlocksFragment_BlockQuote_Fragment | BaseBlocksFragment_Buttons_Fragment | BaseBlocksFragment_Card_Fragment | BaseBlocksFragment_CategorySection_Fragment | BaseBlocksFragment_CookieDeclaration_Fragment | BaseBlocksFragment_CountrySpecificContainer_Fragment | BaseBlocksFragment_Divider_Fragment | BaseBlocksFragment_FaqItemList_Fragment | BaseBlocksFragment_FourColumns_Fragment | BaseBlocksFragment_Iframe_Fragment | BaseBlocksFragment_Image_Fragment | BaseBlocksFragment_Jafix_Fragment | BaseBlocksFragment_NewsletterCta_Fragment | BaseBlocksFragment_RichText_Fragment | BaseBlocksFragment_Section_Fragment | BaseBlocksFragment_SectionHeader_Fragment | BaseBlocksFragment_ShopSection_Fragment | BaseBlocksFragment_Table_Fragment | BaseBlocksFragment_TeaserRow_Fragment | BaseBlocksFragment_ThreeColumns_Fragment | BaseBlocksFragment_TwoColumns_Fragment | BaseBlocksFragment_UgcFlowbox_Fragment | BaseBlocksFragment_Video_Fragment;

type BlocksFragment_ArticleOverview_Fragment = { __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } };

type BlocksFragment_BlockQuote_Fragment = { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string };

type BlocksFragment_Buttons_Fragment = { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null };

type BlocksFragment_Card_Fragment = {};

type BlocksFragment_CategorySection_Fragment = { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> };

type BlocksFragment_CookieDeclaration_Fragment = { __typename: 'CookieDeclaration', id: string };

type BlocksFragment_CountrySpecificContainer_Fragment = { __typename: 'CountrySpecificContainer', id: string, countries: Array<string>, countrySpecificContainerBody?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null };

type BlocksFragment_Divider_Fragment = { __typename: 'Divider', id: string };

type BlocksFragment_FaqItemList_Fragment = { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> };

type BlocksFragment_FourColumns_Fragment = { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> };

type BlocksFragment_Iframe_Fragment = { __typename: 'Iframe', id: string, url: string, height?: number | null };

type BlocksFragment_Image_Fragment = { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } };

type BlocksFragment_Jafix_Fragment = { __typename: 'Jafix', id: string, key: string };

type BlocksFragment_NewsletterCta_Fragment = { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation };

type BlocksFragment_RichText_Fragment = { __typename: 'RichText', id: string, content: string };

type BlocksFragment_Section_Fragment = { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> };

type BlocksFragment_SectionHeader_Fragment = { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null };

type BlocksFragment_ShopSection_Fragment = { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null };

type BlocksFragment_Table_Fragment = { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } };

type BlocksFragment_TeaserRow_Fragment = { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> };

type BlocksFragment_ThreeColumns_Fragment = { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> };

type BlocksFragment_TwoColumns_Fragment = { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> };

type BlocksFragment_UgcFlowbox_Fragment = { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null };

type BlocksFragment_Video_Fragment = { __typename: 'Video', id: string, video: string };

export type BlocksFragmentFragment = BlocksFragment_ArticleOverview_Fragment | BlocksFragment_BlockQuote_Fragment | BlocksFragment_Buttons_Fragment | BlocksFragment_Card_Fragment | BlocksFragment_CategorySection_Fragment | BlocksFragment_CookieDeclaration_Fragment | BlocksFragment_CountrySpecificContainer_Fragment | BlocksFragment_Divider_Fragment | BlocksFragment_FaqItemList_Fragment | BlocksFragment_FourColumns_Fragment | BlocksFragment_Iframe_Fragment | BlocksFragment_Image_Fragment | BlocksFragment_Jafix_Fragment | BlocksFragment_NewsletterCta_Fragment | BlocksFragment_RichText_Fragment | BlocksFragment_Section_Fragment | BlocksFragment_SectionHeader_Fragment | BlocksFragment_ShopSection_Fragment | BlocksFragment_Table_Fragment | BlocksFragment_TeaserRow_Fragment | BlocksFragment_ThreeColumns_Fragment | BlocksFragment_TwoColumns_Fragment | BlocksFragment_UgcFlowbox_Fragment | BlocksFragment_Video_Fragment;

export type ProductListingPageFragmentFragment = { __typename: 'ProductListingPage', description?: string | null, id: string, name: string, path: string, plpTitle?: string | null, hero?: { __typename: 'Hero', id: string, title: string, variant?: HeroVariant | null, imagePosition: ImagePosition, imageStyle: ImageStyle, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, image?: { filename: string, alt?: string | null, focus?: string | null } | null } | null, afterBlocks?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'CountrySpecificContainer', id: string, countries: Array<string>, countrySpecificContainerBody?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null, beforeBlocks?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'CountrySpecificContainer', id: string, countries: Array<string>, countrySpecificContainerBody?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null, category?: { id: string } | null, productListingConfig?: { categoryId: string, categoryPageId: string, defaultOrder?: ProductSortOrder | null, enabledFacets?: Array<string> | null } | null, translatedPaths?: Array<{ locale: string, path: string }> | null, breadcrumbs?: Array<{ name: string, path: string }> | null, seo?: { __typename: 'ContentSEO', title?: string | null, description?: string | null, ogTitle?: string | null, ogDescription?: string | null, ogImage?: string | null, twitterTitle?: string | null, twitterDescription?: string | null, twitterImage?: string | null } | null };

export type ArticlePageFragmentFragment = { __typename: 'ArticlePage', title: string, location?: string | null, publishedAt?: string | null, id: string, name: string, path: string, image?: { filename: string, alt?: string | null } | null, body?: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Video', id: string, video: string } | {} | null> | null, translatedPaths?: Array<{ locale: string, path: string }> | null, breadcrumbs?: Array<{ name: string, path: string }> | null, seo?: { __typename: 'ContentSEO', title?: string | null, description?: string | null, ogTitle?: string | null, ogDescription?: string | null, ogImage?: string | null, twitterTitle?: string | null, twitterDescription?: string | null, twitterImage?: string | null } | null };

export type PageRedirectQueryVariables = Exact<{
  path: Scalars['String']['input'];
  storeContext: StoreContextInput;
  pageType: PageRedirectPageType;
}>;


export type PageRedirectQuery = { pageRedirect?: { destination: string, statusCode: number } | null };

export type GetContentPageQueryVariables = Exact<{
  storeContext: StoreContextInput;
  path: Scalars['String']['input'];
  previewID?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<ContentVersion>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetContentPageQuery = { page?: { __typename: 'ArticlePage', title: string, location?: string | null, publishedAt?: string | null, id: string, name: string, path: string, image?: { filename: string, alt?: string | null } | null, body?: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Video', id: string, video: string } | {} | null> | null, translatedPaths?: Array<{ locale: string, path: string }> | null, breadcrumbs?: Array<{ name: string, path: string }> | null, seo?: { __typename: 'ContentSEO', title?: string | null, description?: string | null, ogTitle?: string | null, ogDescription?: string | null, ogImage?: string | null, twitterTitle?: string | null, twitterDescription?: string | null, twitterImage?: string | null } | null } | { __typename: 'ContentPage', description?: string | null, id: string, name: string, path: string, contentPageTitle?: string | null, hero?: { __typename: 'Hero', id: string, title: string, variant?: HeroVariant | null, imagePosition: ImagePosition, imageStyle: ImageStyle, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, image?: { filename: string, alt?: string | null, focus?: string | null } | null } | null, usps?: { id: string, usp1: string, usp2: string, usp3: string, usp1Link?: { url: string, newTab: boolean, hash?: string | null } | null, usp2Link?: { url: string, newTab: boolean, hash?: string | null } | null, usp3Link?: { url: string, newTab: boolean, hash?: string | null } | null } | null, body?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'CountrySpecificContainer', id: string, countries: Array<string>, countrySpecificContainerBody?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null, translatedPaths?: Array<{ locale: string, path: string }> | null, breadcrumbs?: Array<{ name: string, path: string }> | null, seo?: { __typename: 'ContentSEO', title?: string | null, description?: string | null, ogTitle?: string | null, ogDescription?: string | null, ogImage?: string | null, twitterTitle?: string | null, twitterDescription?: string | null, twitterImage?: string | null } | null } | { __typename: 'FAQPage', title: string, id: string, name: string, path: string, faqGroups: Array<{ id: string, title: string, slug?: string | null, translatedPaths?: Array<{ locale: string, path: string }> | null, icon?: { filename: string, alt?: string | null, focus?: string | null } | null, leadText?: { __typename: 'RichText', id: string, content: string } | null, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> }>, translatedPaths?: Array<{ locale: string, path: string }> | null, breadcrumbs?: Array<{ name: string, path: string }> | null, seo?: { __typename: 'ContentSEO', title?: string | null, description?: string | null, ogTitle?: string | null, ogDescription?: string | null, ogImage?: string | null, twitterTitle?: string | null, twitterDescription?: string | null, twitterImage?: string | null } | null } | { __typename: 'ProductListingPage', description?: string | null, id: string, name: string, path: string, plpTitle?: string | null, hero?: { __typename: 'Hero', id: string, title: string, variant?: HeroVariant | null, imagePosition: ImagePosition, imageStyle: ImageStyle, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, image?: { filename: string, alt?: string | null, focus?: string | null } | null } | null, afterBlocks?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'CountrySpecificContainer', id: string, countries: Array<string>, countrySpecificContainerBody?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null, beforeBlocks?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'CountrySpecificContainer', id: string, countries: Array<string>, countrySpecificContainerBody?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null, category?: { id: string } | null, productListingConfig?: { categoryId: string, categoryPageId: string, defaultOrder?: ProductSortOrder | null, enabledFacets?: Array<string> | null } | null, translatedPaths?: Array<{ locale: string, path: string }> | null, breadcrumbs?: Array<{ name: string, path: string }> | null, seo?: { __typename: 'ContentSEO', title?: string | null, description?: string | null, ogTitle?: string | null, ogDescription?: string | null, ogImage?: string | null, twitterTitle?: string | null, twitterDescription?: string | null, twitterImage?: string | null } | null } | null };

export type FaqGroupFragmentFragment = { id: string, title: string, slug?: string | null, icon?: { filename: string, alt?: string | null, focus?: string | null } | null, leadText?: { __typename: 'RichText', id: string, content: string } | null, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> };

export type ProductBuySectionFragmentFragment = { sku?: string | null, availability?: ProductAvailability | null, availabilityQuantity?: number | null, price?: { gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null };

export type ProductDetailPageFragmentFragment = { name: string, slug: string, availability?: ProductAvailability | null, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, meta?: { title?: string | null, description?: string | null } | null, usps?: { id: string, usp1: string, usp2: string, usp3: string, usp1Link?: { url: string, newTab: boolean, hash?: string | null } | null, usp2Link?: { url: string, newTab: boolean, hash?: string | null } | null, usp3Link?: { url: string, newTab: boolean, hash?: string | null } | null } | null, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, primaryVariant: { sku?: string | null, name?: string | null, images?: Array<{ url: string, alt?: string | null }> | null, orderConfiguration?: { min?: number | null, max?: number | null, hasMax?: boolean | null, stepSize?: number | null } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { id: string, name: string, slug: string, ancestors: Array<{ storyblokName?: string | null, name: string, id: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, id: string, availability?: ProductAvailability | null, deliveryTime?: string | null, description?: string | null, availabilityQuantity?: number | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string, label: string }> | null, images?: Array<{ url: string, alt?: string | null }> | null, orderConfiguration?: { min?: number | null, max?: number | null, hasMax?: boolean | null, stepSize?: number | null } | null, price?: { gross: { centAmount: number, currency: Currency } } | null }>, relatedProducts?: Array<{ id: string, slug: string, availability?: ProductAvailability | null, image?: { url: string, alt?: string | null } | null, primaryVariant: { sku?: string | null }, variants: Array<{ availability?: ProductAvailability | null, price?: { gross: { centAmount: number } } | null }>, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null }> | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, instructions?: Array<{ key: string, label: string } | null> | null, materials?: { base?: string | null, outside?: string | null, filling?: string | null, lining?: string | null } | null, reviews?: { amount: number, averageRating: number, lowestRating: number, highestRating: number } | null, sizeGuide?: Array<{ __typename: 'CountrySpecificContainer', id: string, countries: Array<string>, countrySpecificContainerBody?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | null> | null, breadcrumbs?: Array<{ name: string, path: string }> | null };

export type ProductVariantFragmentFragment = { id: string, name?: string | null, sku?: string | null, availability?: ProductAvailability | null, deliveryTime?: string | null, description?: string | null, images?: Array<{ url: string, alt?: string | null }> | null, attributes?: Array<{ name: string, label: string, value: string }> | null, orderConfiguration?: { min?: number | null, max?: number | null, hasMax?: boolean | null, stepSize?: number | null } | null };

export type GetProductDetailPageQueryVariables = Exact<{
  storeContext: StoreContextInput;
  slug: Scalars['String']['input'];
  currentPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProductDetailPageQuery = { product?: { name: string, slug: string, availability?: ProductAvailability | null, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, localizedSlugs: Array<{ locale: string, slug: string }>, meta?: { title?: string | null, description?: string | null } | null, usps?: { id: string, usp1: string, usp2: string, usp3: string, usp1Link?: { url: string, newTab: boolean, hash?: string | null } | null, usp2Link?: { url: string, newTab: boolean, hash?: string | null } | null, usp3Link?: { url: string, newTab: boolean, hash?: string | null } | null } | null, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, primaryVariant: { sku?: string | null, name?: string | null, images?: Array<{ url: string, alt?: string | null }> | null, orderConfiguration?: { min?: number | null, max?: number | null, hasMax?: boolean | null, stepSize?: number | null } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { id: string, name: string, slug: string, ancestors: Array<{ storyblokName?: string | null, name: string, id: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, id: string, availability?: ProductAvailability | null, deliveryTime?: string | null, description?: string | null, availabilityQuantity?: number | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string, label: string }> | null, images?: Array<{ url: string, alt?: string | null }> | null, orderConfiguration?: { min?: number | null, max?: number | null, hasMax?: boolean | null, stepSize?: number | null } | null, price?: { gross: { centAmount: number, currency: Currency } } | null }>, relatedProducts?: Array<{ id: string, slug: string, availability?: ProductAvailability | null, image?: { url: string, alt?: string | null } | null, primaryVariant: { sku?: string | null }, variants: Array<{ availability?: ProductAvailability | null, price?: { gross: { centAmount: number } } | null }>, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null }> | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, instructions?: Array<{ key: string, label: string } | null> | null, materials?: { base?: string | null, outside?: string | null, filling?: string | null, lining?: string | null } | null, reviews?: { amount: number, averageRating: number, lowestRating: number, highestRating: number } | null, sizeGuide?: Array<{ __typename: 'CountrySpecificContainer', id: string, countries: Array<string>, countrySpecificContainerBody?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | null> | null, breadcrumbs?: Array<{ name: string, path: string }> | null } | null };

export type StoreFragmentFragment = { slug: string, name: string, storeCode?: string | null, address?: { addressLine: string, city: string, district?: string | null, phone?: string | null, zipcode?: string | null, streetNumber?: string | null, countryId?: string | null } | null, openingHours?: { fridayclose1?: number | null, fridayclose2?: number | null, fridayopen1?: number | null, fridayopen2?: number | null, mondayclose1?: number | null, mondayclose2?: number | null, mondayopen1?: number | null, mondayopen2?: number | null, saturdayclose1?: number | null, saturdayclose2?: number | null, saturdayopen1?: number | null, saturdayopen2?: number | null, sundayclose1?: number | null, sundayclose2?: number | null, sundayopen1?: number | null, sundayopen2?: number | null, thursdayclose1?: number | null, thursdayclose2?: number | null, thursdayopen1?: number | null, thursdayopen2?: number | null, tuesdayclose1?: number | null, tuesdayclose2?: number | null, tuesdayopen1?: number | null, tuesdayopen2?: number | null, wednesdayclose1?: number | null, wednesdayclose2?: number | null, wednesdayopen1?: number | null, wednesdayopen2?: number | null } | null, coordinates: { lat: number, lng: number }, nearbyStores?: Array<{ name: string, slug: string, distanceInMeters: number, objectID?: string | null, storeCode?: string | null, address?: { addressLine: string, city: string, streetNumber?: string | null, phone?: string | null, zipcode?: string | null } | null }> | null };

export type GetStoreQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetStoreQuery = { store?: { slug: string, name: string, storeCode?: string | null, address?: { addressLine: string, city: string, district?: string | null, phone?: string | null, zipcode?: string | null, streetNumber?: string | null, countryId?: string | null } | null, openingHours?: { fridayclose1?: number | null, fridayclose2?: number | null, fridayopen1?: number | null, fridayopen2?: number | null, mondayclose1?: number | null, mondayclose2?: number | null, mondayopen1?: number | null, mondayopen2?: number | null, saturdayclose1?: number | null, saturdayclose2?: number | null, saturdayopen1?: number | null, saturdayopen2?: number | null, sundayclose1?: number | null, sundayclose2?: number | null, sundayopen1?: number | null, sundayopen2?: number | null, thursdayclose1?: number | null, thursdayclose2?: number | null, thursdayopen1?: number | null, thursdayopen2?: number | null, tuesdayclose1?: number | null, tuesdayclose2?: number | null, tuesdayopen1?: number | null, tuesdayopen2?: number | null, wednesdayclose1?: number | null, wednesdayclose2?: number | null, wednesdayopen1?: number | null, wednesdayopen2?: number | null } | null, coordinates: { lat: number, lng: number }, nearbyStores?: Array<{ name: string, slug: string, distanceInMeters: number, objectID?: string | null, storeCode?: string | null, address?: { addressLine: string, city: string, streetNumber?: string | null, phone?: string | null, zipcode?: string | null } | null }> | null } | null };

export type CheckoutSummaryFragmentFragment = { lineItems: Array<{ id: string, quantity: number, productSlug?: string | null, productName: string, addedAt?: string | null, productId: string, availableStock: number, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, variant: { name: string, sku: string, descriptionShort?: string | null, size?: string | null, color?: string | null, primaryImage?: { url: string, alt?: string | null } | null, orderConfiguration?: { min?: number | null, max?: number | null, stepSize?: number | null } | null }, category?: { ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, regularPrice: { gross: { centAmount: number, currency: Currency } }, price: { gross: { centAmount: number, currency: Currency }, tax: { rate: number, value: { centAmount: number, currency: Currency } } }, discounts?: Array<{ code?: string | null, description?: string | null, value: { centAmount: number, currency: Currency } }> | null }>, subTotal: { centAmount: number, currency: Currency }, discount?: { amount: { centAmount: number, currency: Currency } } | null, total: { centAmount: number, currency: Currency }, subTotalBeforeDiscount: { centAmount: number, currency: Currency }, shippingCosts?: { centAmount: number, currency: Currency } | null };

export type OrderDetailFragment = { customerEmail?: string | null, orderNumber?: string | null, estimatedMaxDeliveryDays?: number | null, currency: string, shippingMethod?: string | null, shippingOption?: ShippingOption | null, shippingAddress?: { firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null } | null, shippingCosts?: { centAmount: number, currency: Currency } | null, lineItems: Array<{ id: string, quantity: number, productId: string, productSlug?: string | null, productName: string, category?: { ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, price: { gross: { centAmount: number, currency: Currency } }, variant: { name: string, size?: string | null, color?: string | null, sku: string, primaryImage?: { url: string, alt?: string | null } | null } }>, total: { gross: { centAmount: number, currency: Currency } }, selectedPaymentMethod?: { id: string, name: string, provider: string, issuers?: Array<{ id: string, name: string }> | null } | null };

export type OrderQueryVariables = Exact<{
  storeContext: StoreContextInput;
  orderId: Scalars['String']['input'];
}>;


export type OrderQuery = { orderConfirmation?: { customerEmail?: string | null, orderNumber?: string | null, estimatedMaxDeliveryDays?: number | null, currency: string, shippingMethod?: string | null, shippingOption?: ShippingOption | null, shippingAddress?: { firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null } | null, shippingCosts?: { centAmount: number, currency: Currency } | null, lineItems: Array<{ id: string, quantity: number, productId: string, productSlug?: string | null, productName: string, category?: { ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, price: { gross: { centAmount: number, currency: Currency } }, variant: { name: string, size?: string | null, color?: string | null, sku: string, primaryImage?: { url: string, alt?: string | null } | null } }>, total: { gross: { centAmount: number, currency: Currency } }, selectedPaymentMethod?: { id: string, name: string, provider: string, issuers?: Array<{ id: string, name: string }> | null } | null } | null };

export type GetCheckoutDeliveryQueryVariables = Exact<{
  storeContext: StoreContextInput;
}>;


export type GetCheckoutDeliveryQuery = { cart?: { paazlCheckoutConfig: { configObject: { [key: string]: any } | string | string[] | boolean | boolean[] | number | number[] | { [key: string]: any }[] } } | null };

export type PaazlConfigFragmentFragment = { configObject: { [key: string]: any } | string | string[] | boolean | boolean[] | number | number[] | { [key: string]: any }[] };

export type AddressFragmentFragment = { id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null, vatNumber?: string | null };

export type CustomerAddressUpdateMutationVariables = Exact<{
  storeContext: StoreContextInput;
  address: AddressUpdateInput;
}>;


export type CustomerAddressUpdateMutation = { customerInformationUpdate: { firstName?: string | null, lastName?: string | null, accountType: AccountType, company?: string | null, email: string, vatNumber?: string | null, billingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, shippingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, addresses?: Array<{ id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null }> | null } };

export type GetCheckoutInformationQueryVariables = Exact<{
  storeContext: StoreContextInput;
}>;


export type GetCheckoutInformationQuery = { cart?: { customerEmail?: string | null, billingAddress?: { id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null, vatNumber?: string | null } | null } | null };

export type UpdateCheckoutInformationMutationVariables = Exact<{
  storeContext: StoreContextInput;
  setBillingAddress?: InputMaybe<AddressInput>;
  setShippingAddress?: InputMaybe<AddressInput>;
  setCustomerEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCheckoutInformationMutation = { checkoutUpdate: { customerEmail?: string | null, shippingAddress?: { id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null, vatNumber?: string | null } | null, billingAddress?: { id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null, vatNumber?: string | null } | null } };

export type UpdateCheckoutLoginMutationVariables = Exact<{
  storeContext: StoreContextInput;
  id: CartIdentifierInput;
  setCustomerEmail?: InputMaybe<Scalars['String']['input']>;
  setBillingAddress?: InputMaybe<AddressInput>;
}>;


export type UpdateCheckoutLoginMutation = { checkoutUpdate: { id: { id: string, version: number } } };

export type CheckoutCustomerLoginMutationVariables = Exact<{
  storeContext: StoreContextInput;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type CheckoutCustomerLoginMutation = { customerLogin: { firstName?: string | null, lastName?: string | null, accountType: AccountType, company?: string | null, email: string, vatNumber?: string | null, billingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, shippingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, addresses?: Array<{ id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null }> | null } };

export type GetCheckoutLoginQueryVariables = Exact<{
  storeContext: StoreContextInput;
}>;


export type GetCheckoutLoginQuery = { cart?: { customerEmail?: string | null, id: { id: string, version: number } } | null };

export type FailedOrderDetailFragment = { shippingOption?: ShippingOption | null, paymentStatus?: PaymentStatus | null, customerEmail?: string | null, orderNumber?: string | null, estimatedMaxDeliveryDays?: number | null, currency: string, shippingMethod?: string | null, lineItems: Array<{ id: string, quantity: number, productId: string, productSlug?: string | null, productName: string, addedAt?: string | null, category?: { ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, price: { gross: { centAmount: number, currency: Currency } }, variant: { name: string, sku: string, size?: string | null, color?: string | null, primaryImage?: { url: string, alt?: string | null } | null } }>, subTotal: { gross: { centAmount: number, currency: Currency } }, total: { gross: { centAmount: number, currency: Currency } }, shippingCosts?: { centAmount: number, currency: Currency } | null, selectedPaymentMethod?: { id: string, name: string, provider: string, issuers?: Array<{ id: string, name: string }> | null } | null, shippingAddress?: { firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null } | null };

export type FailedOrderQueryVariables = Exact<{
  storeContext: StoreContextInput;
  orderId: Scalars['String']['input'];
}>;


export type FailedOrderQuery = { order?: { shippingOption?: ShippingOption | null, paymentStatus?: PaymentStatus | null, customerEmail?: string | null, orderNumber?: string | null, estimatedMaxDeliveryDays?: number | null, currency: string, shippingMethod?: string | null, lineItems: Array<{ id: string, quantity: number, productId: string, productSlug?: string | null, productName: string, addedAt?: string | null, category?: { ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, price: { gross: { centAmount: number, currency: Currency } }, variant: { name: string, sku: string, size?: string | null, color?: string | null, primaryImage?: { url: string, alt?: string | null } | null } }>, subTotal: { gross: { centAmount: number, currency: Currency } }, total: { gross: { centAmount: number, currency: Currency } }, shippingCosts?: { centAmount: number, currency: Currency } | null, selectedPaymentMethod?: { id: string, name: string, provider: string, issuers?: Array<{ id: string, name: string }> | null } | null, shippingAddress?: { firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null } | null } | null, availablePaymentMethods: Array<{ name: string, paymentMethod: Array<{ id: string, name: string, provider: string, issuers?: Array<{ id: string, name: string }> | null }> }> };

export type GetOrderPaymentStatusQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
  storeContext: StoreContextInput;
}>;


export type GetOrderPaymentStatusQuery = { orderPaymentStatus?: string | null };

export type PaymentCreateMutationVariables = Exact<{
  storeContext: StoreContextInput;
  paymentContext: PaymentContextInput;
}>;


export type PaymentCreateMutation = { createPayment: { redirectURL?: string | null, additionalData?: { [key: string]: any } | string | string[] | boolean | boolean[] | number | number[] | { [key: string]: any }[] | null, method?: Method | null } };

export type GetCheckoutPaymentQueryVariables = Exact<{
  storeContext: StoreContextInput;
}>;


export type GetCheckoutPaymentQuery = { cart?: { availablePaymentMethods: Array<{ name: string, paymentMethod: Array<{ id: string, name: string, provider: string, issuers?: Array<{ id: string, name: string }> | null }> }>, selectedPaymentMethod?: { id: string, name: string, provider: string, issuers?: Array<{ id: string, name: string }> | null } | null } | null };

export type PaymentMethodFragment = { id: string, name: string, provider: string, issuers?: Array<{ id: string, name: string }> | null };

export type CreateOrderMutationVariables = Exact<{
  storeContext: StoreContextInput;
}>;


export type CreateOrderMutation = { checkoutComplete: { orderId: string, orderNumber: string } };

export type GetContentSlugsQueryVariables = Exact<{
  storeContext: StoreContextInput;
  pageSize: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  includeCountryUnique: Scalars['Boolean']['input'];
  includeShared: Scalars['Boolean']['input'];
}>;


export type GetContentSlugsQuery = { pages: { total: number, moreResultsCountryUnique?: boolean | null, moreResultsShared?: boolean | null, results: Array<{ __typename: 'ArticlePage', name: string, path: string } | { __typename: 'ContentPage', name: string, path: string } | { __typename: 'FAQPage', name: string, path: string } | { __typename: 'ProductListingPage', name: string, path: string }> } };

export type GetProductSlugsQueryVariables = Exact<{
  storeContext: StoreContextInput;
  pageSize: Scalars['Int']['input'];
  fromId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductSlugsQuery = { products?: { lastId?: string | null, total: number, results: Array<{ slug: string }> } | null };

export type ArticleCardFragmentFragment = { id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null };

export type ImageAssetFragment = { filename: string, alt?: string | null, focus?: string | null };

export type BreadcrumbFragmentFragment = { name: string, path: string };

export type CartSummaryFragmentFragment = { subTotal: { centAmount: number, currency: Currency }, discount?: { amount: { centAmount: number, currency: Currency } } | null, total: { centAmount: number, currency: Currency }, subTotalBeforeDiscount: { centAmount: number, currency: Currency }, shippingCosts?: { centAmount: number, currency: Currency } | null };

export type CategoryCardFragmentFragment = { __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null };

export type FaqItemFragmentFragment = { __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null };

export type FacetValueFragmentFragment = { key: string, label: string, count: number };

export type RangeFacetFragmentFragment = { __typename: 'RangeFacet', key: string, label: string, min: number, max: number, selectedMin?: number | null, selectedMax?: number | null };

export type OptionsFacetFragmentFragment = { __typename: 'OptionsFacet', key: string, label: string, options: Array<{ key: string, label: string, count: number }> };

export type ToggleFacetFragmentFragment = { __typename: 'ToggleFacet', key: string, label: string, options: Array<{ key: string, label: string, count: number }> };

type FacetFragment_OptionsFacet_Fragment = { __typename: 'OptionsFacet', key: string, label: string, options: Array<{ key: string, label: string, count: number }> };

type FacetFragment_RangeFacet_Fragment = { __typename: 'RangeFacet', key: string, label: string, min: number, max: number, selectedMin?: number | null, selectedMax?: number | null };

type FacetFragment_ToggleFacet_Fragment = { __typename: 'ToggleFacet', key: string, label: string, options: Array<{ key: string, label: string, count: number }> };

export type FacetFragmentFragment = FacetFragment_OptionsFacet_Fragment | FacetFragment_RangeFacet_Fragment | FacetFragment_ToggleFacet_Fragment;

export type HeroFragmentFragment = { __typename: 'Hero', id: string, title: string, variant?: HeroVariant | null, imagePosition: ImagePosition, imageStyle: ImageStyle, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, image?: { filename: string, alt?: string | null, focus?: string | null } | null };

export type LineItemSummaryFragmentFragment = { id: string, quantity: number, productName: string, variant: { name: string, color?: string | null, size?: string | null, primaryImage?: { url: string, alt?: string | null } | null } };

export type PriceFragment = { centAmount: number, currency: Currency };

export type PriceTagFragment = { centAmount: number, currency: Currency };

export type ProductCardFragment = { name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> };

export type ProductListingConfigFragment = { categoryId: string, categoryPageId: string, defaultOrder?: ProductSortOrder | null, enabledFacets?: Array<string> | null };

export type ProductSearchResultsFragment = { total: number, totalPages: number, queryID?: string | null, results: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }>, facets?: Array<{ __typename: 'OptionsFacet', key: string, label: string, options: Array<{ key: string, label: string, count: number }> } | { __typename: 'RangeFacet', key: string, label: string, min: number, max: number, selectedMin?: number | null, selectedMax?: number | null } | { __typename: 'ToggleFacet', key: string, label: string, options: Array<{ key: string, label: string, count: number }> }> | null };

export type SectionHeaderFragmentFragment = { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null };

export type GetProductCountQueryVariables = Exact<{
  storeContext: StoreContextInput;
  sort: ProductSortOrder;
  filters?: InputMaybe<Array<FacetFilterInput> | FacetFilterInput>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  categoryPageId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProductCountQuery = { productSearch?: { total: number } | null };

export type TeaserRowFragmentFragment = { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> };

export type UspsFragmentFragment = { id: string, usp1: string, usp2: string, usp3: string, usp1Link?: { url: string, newTab: boolean, hash?: string | null } | null, usp2Link?: { url: string, newTab: boolean, hash?: string | null } | null, usp3Link?: { url: string, newTab: boolean, hash?: string | null } | null };

export type ArticleOverviewFragmentFragment = { __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } };

export type BlockQuoteFragmentFragment = { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string };

export type ButtonFragmentFragment = { __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } };

export type ButtonsFragmentFragment = { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null };

export type CategorySectionFragmentFragment = { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> };

type ColumnBlockFragment_BlockQuote_Fragment = { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string };

type ColumnBlockFragment_Buttons_Fragment = { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null };

type ColumnBlockFragment_CookieDeclaration_Fragment = { __typename: 'CookieDeclaration', id: string };

type ColumnBlockFragment_CountrySpecificContainer_Fragment = {};

type ColumnBlockFragment_Divider_Fragment = { __typename: 'Divider', id: string };

type ColumnBlockFragment_FaqItemList_Fragment = { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> };

type ColumnBlockFragment_Iframe_Fragment = { __typename: 'Iframe', id: string, url: string, height?: number | null };

type ColumnBlockFragment_Image_Fragment = { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } };

type ColumnBlockFragment_NewsletterCta_Fragment = { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation };

type ColumnBlockFragment_RichText_Fragment = { __typename: 'RichText', id: string, content: string };

type ColumnBlockFragment_Table_Fragment = { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } };

type ColumnBlockFragment_Video_Fragment = { __typename: 'Video', id: string, video: string };

export type ColumnBlockFragmentFragment = ColumnBlockFragment_BlockQuote_Fragment | ColumnBlockFragment_Buttons_Fragment | ColumnBlockFragment_CookieDeclaration_Fragment | ColumnBlockFragment_CountrySpecificContainer_Fragment | ColumnBlockFragment_Divider_Fragment | ColumnBlockFragment_FaqItemList_Fragment | ColumnBlockFragment_Iframe_Fragment | ColumnBlockFragment_Image_Fragment | ColumnBlockFragment_NewsletterCta_Fragment | ColumnBlockFragment_RichText_Fragment | ColumnBlockFragment_Table_Fragment | ColumnBlockFragment_Video_Fragment;

export type FourColumnFragmentFragment = { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> };

export type ThreeColumnFragmentFragment = { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> };

export type TwoColumnFragmentFragment = { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> };

export type CookieDeclarationFragmentFragment = { __typename: 'CookieDeclaration', id: string };

export type CountrySpecificContainerFragmentFragment = { __typename: 'CountrySpecificContainer', id: string, countries: Array<string>, countrySpecificContainerBody?: Array<{ __typename: 'ArticleOverview', id: string, articleItems: { totalPages: number, results?: Array<{ id: string, title: string, location?: string | null, publishedAt?: string | null, image?: { filename: string, alt?: string | null } | null, link?: { url: string } | null } | null> | null } } | { __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {} | null> | null };

export type DividerFragmentFragment = { __typename: 'Divider', id: string };

export type FaqItemListFragmentFragment = { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> };

export type IframeFragmentFragment = { __typename: 'Iframe', id: string, url: string, height?: number | null };

export type ImageFragmentFragment = { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } };

export type JafixFragmentFragment = { __typename: 'Jafix', id: string, key: string };

export type NewsletterCtaFragmentFragment = { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation };

export type RichTextFragmentFragment = { __typename: 'RichText', id: string, content: string };

export type SectionFragmentFragment = { __typename: 'Section', id: string, backgroundColor?: SectionColor | null, size?: SectionSize | null, spacing?: SectionSpacing | null, body: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CategorySection', id: string, title: string, category?: string | null, supportingText?: string | null, headerAlign: CategorySectionHeaderAlign, variant: ComponentVariant, link?: { url: string, newTab: boolean, hash?: string | null } | null, items: Array<{ __typename: 'Card', id: string, title: string, category?: string | null, supportingText?: string | null, image: { filename: string, alt?: string | null, focus?: string | null }, cardLink?: { url: string, newTab: boolean, hash?: string | null } | null }> } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'FourColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_4: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'Jafix', id: string, key: string } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'SectionHeader', id: string, title: string, imagePosition?: ImagePosition | null, imageStyle?: ImageStyle | null, bodyText?: { __typename: 'RichText', id: string, content: string } | null, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null, headerImage?: { filename: string, alt?: string | null, focus?: string | null } | null } | { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'TeaserRow', id: string, title: string, viewMoreLink?: { url: string, newTab: boolean } | null, items: Array<{ __typename: 'Teaser', id: string, content: string, title: string, image: { filename: string, alt?: string | null, focus?: string | null }, link: { url: string } }> } | { __typename: 'ThreeColumns', id: string, alignment: ColumnAlignment, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_3: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'TwoColumns', id: string, alignment: ColumnAlignment, ratio: TwoColumnsRatio, column_1: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}>, column_2: Array<{ __typename: 'BlockQuote', id: string, content: string, name?: string | null, title: string } | { __typename: 'Buttons', id: string, buttons?: Array<{ __typename: 'Button', id: string, title: string, variant: ButtonVariant, size: ButtonSize, link: { url: string, newTab: boolean, hash?: string | null } }> | null } | { __typename: 'CookieDeclaration', id: string } | { __typename: 'Divider', id: string } | { __typename: 'FAQItemList', id: string, faqItems: Array<{ __typename: 'FAQItem', id: string, slug?: string | null, title: string, richContent?: { __typename: 'RichText', id: string, content: string } | null }> } | { __typename: 'Iframe', id: string, url: string, height?: number | null } | { __typename: 'Image', id: string, aspectRatio?: number | null, image: { filename: string, alt?: string | null, focus?: string | null } } | { __typename: 'NewsletterCTA', id: string, orientation: LayoutOrientation } | { __typename: 'RichText', id: string, content: string } | { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } } | { __typename: 'Video', id: string, video: string } | {}> } | { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null } | { __typename: 'Video', id: string, video: string } | {}> };

export type ShopSectionFragmentFragment = { __typename: 'ShopSection', id: string, title: string, subtitle?: string | null, category?: string | null, viewAllLabel?: string | null, variant: ComponentVariant, viewAllLink?: { url: string, newTab: boolean } | null, products?: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }> | null };

export type TableCellFragmentFragment = { value: string };

export type TableFragmentFragment = { __typename: 'Table', id: string, style: TableStyle, dividers: TableDividers, width: TableWidth, table: { thead: Array<{ value: string }>, tbody: Array<{ body: Array<{ value: string }> }> } };

export type UgcFlowboxFragmentFragment = { __typename: 'UGCFlowbox', id: string, key: string, tags?: string | null };

export type VideoFragmentFragment = { __typename: 'Video', id: string, video: string };

export type CartFragment = { shippingOption?: ShippingOption | null, id: { id: string, version: number }, lineItems: Array<{ id: string, quantity: number, productSlug?: string | null, productName: string, addedAt?: string | null, productId: string, availableStock: number, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, variant: { name: string, sku: string, descriptionShort?: string | null, size?: string | null, color?: string | null, primaryImage?: { url: string, alt?: string | null } | null, orderConfiguration?: { min?: number | null, max?: number | null, stepSize?: number | null } | null }, category?: { ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, regularPrice: { gross: { centAmount: number, currency: Currency } }, price: { gross: { centAmount: number, currency: Currency }, tax: { rate: number, value: { centAmount: number, currency: Currency } } }, discounts?: Array<{ code?: string | null, description?: string | null, value: { centAmount: number, currency: Currency } }> | null }>, subTotal: { centAmount: number, currency: Currency }, discount?: { amount: { centAmount: number, currency: Currency } } | null, total: { centAmount: number, currency: Currency }, subTotalBeforeDiscount: { centAmount: number, currency: Currency }, shippingCosts?: { centAmount: number, currency: Currency } | null };

export type LineItemFragment = { id: string, quantity: number, productId: string, productSlug?: string | null, productName: string, addedAt?: string | null, availableStock: number, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, category?: { ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, regularPrice: { gross: { centAmount: number, currency: Currency } }, price: { gross: { centAmount: number, currency: Currency }, tax: { rate: number, value: { centAmount: number, currency: Currency } } }, discounts?: Array<{ code?: string | null, description?: string | null, value: { centAmount: number, currency: Currency } }> | null, variant: { name: string, descriptionShort?: string | null, sku: string, size?: string | null, color?: string | null, primaryImage?: { url: string, alt?: string | null } | null, orderConfiguration?: { min?: number | null, max?: number | null, stepSize?: number | null } | null } };

export type CartLineItemsAddMutationVariables = Exact<{
  storeContext: StoreContextInput;
  id?: InputMaybe<CartIdentifierInput>;
  lineItems: Array<CartLineItemCreateInput> | CartLineItemCreateInput;
}>;


export type CartLineItemsAddMutation = { cartLineItemsAdd: { shippingOption?: ShippingOption | null, id: { id: string, version: number }, lineItems: Array<{ id: string, quantity: number, productSlug?: string | null, productName: string, addedAt?: string | null, productId: string, availableStock: number, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, variant: { name: string, sku: string, descriptionShort?: string | null, size?: string | null, color?: string | null, primaryImage?: { url: string, alt?: string | null } | null, orderConfiguration?: { min?: number | null, max?: number | null, stepSize?: number | null } | null }, category?: { ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, regularPrice: { gross: { centAmount: number, currency: Currency } }, price: { gross: { centAmount: number, currency: Currency }, tax: { rate: number, value: { centAmount: number, currency: Currency } } }, discounts?: Array<{ code?: string | null, description?: string | null, value: { centAmount: number, currency: Currency } }> | null }>, subTotal: { centAmount: number, currency: Currency }, discount?: { amount: { centAmount: number, currency: Currency } } | null, total: { centAmount: number, currency: Currency }, subTotalBeforeDiscount: { centAmount: number, currency: Currency }, shippingCosts?: { centAmount: number, currency: Currency } | null } };

export type GetCartQueryVariables = Exact<{
  storeContext: StoreContextInput;
}>;


export type GetCartQuery = { cart?: { shippingOption?: ShippingOption | null, id: { id: string, version: number }, lineItems: Array<{ id: string, quantity: number, productSlug?: string | null, productName: string, addedAt?: string | null, productId: string, availableStock: number, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, variant: { name: string, sku: string, descriptionShort?: string | null, size?: string | null, color?: string | null, primaryImage?: { url: string, alt?: string | null } | null, orderConfiguration?: { min?: number | null, max?: number | null, stepSize?: number | null } | null }, category?: { ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, regularPrice: { gross: { centAmount: number, currency: Currency } }, price: { gross: { centAmount: number, currency: Currency }, tax: { rate: number, value: { centAmount: number, currency: Currency } } }, discounts?: Array<{ code?: string | null, description?: string | null, value: { centAmount: number, currency: Currency } }> | null }>, subTotal: { centAmount: number, currency: Currency }, discount?: { amount: { centAmount: number, currency: Currency } } | null, total: { centAmount: number, currency: Currency }, subTotalBeforeDiscount: { centAmount: number, currency: Currency }, shippingCosts?: { centAmount: number, currency: Currency } | null } | null };

export type CartLineItemsUpdateMutationVariables = Exact<{
  storeContext: StoreContextInput;
  id: CartIdentifierInput;
  lineItems: Array<CartLineItemUpdateInput> | CartLineItemUpdateInput;
}>;


export type CartLineItemsUpdateMutation = { cartLineItemsUpdate: { shippingOption?: ShippingOption | null, id: { id: string, version: number }, lineItems: Array<{ id: string, quantity: number, productSlug?: string | null, productName: string, addedAt?: string | null, productId: string, availableStock: number, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, variant: { name: string, sku: string, descriptionShort?: string | null, size?: string | null, color?: string | null, primaryImage?: { url: string, alt?: string | null } | null, orderConfiguration?: { min?: number | null, max?: number | null, stepSize?: number | null } | null }, category?: { ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, regularPrice: { gross: { centAmount: number, currency: Currency } }, price: { gross: { centAmount: number, currency: Currency }, tax: { rate: number, value: { centAmount: number, currency: Currency } } }, discounts?: Array<{ code?: string | null, description?: string | null, value: { centAmount: number, currency: Currency } }> | null }>, subTotal: { centAmount: number, currency: Currency }, discount?: { amount: { centAmount: number, currency: Currency } } | null, total: { centAmount: number, currency: Currency }, subTotalBeforeDiscount: { centAmount: number, currency: Currency }, shippingCosts?: { centAmount: number, currency: Currency } | null } };

export type ProcessPaazlCheckoutMutationVariables = Exact<{
  storeContext: StoreContextInput;
}>;


export type ProcessPaazlCheckoutMutation = { checkoutUpdate: { shippingOption?: ShippingOption | null, id: { id: string, version: number }, lineItems: Array<{ id: string, quantity: number, productSlug?: string | null, productName: string, addedAt?: string | null, productId: string, availableStock: number, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, variant: { name: string, sku: string, descriptionShort?: string | null, size?: string | null, color?: string | null, primaryImage?: { url: string, alt?: string | null } | null, orderConfiguration?: { min?: number | null, max?: number | null, stepSize?: number | null } | null }, category?: { ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, regularPrice: { gross: { centAmount: number, currency: Currency } }, price: { gross: { centAmount: number, currency: Currency }, tax: { rate: number, value: { centAmount: number, currency: Currency } } }, discounts?: Array<{ code?: string | null, description?: string | null, value: { centAmount: number, currency: Currency } }> | null }>, subTotal: { centAmount: number, currency: Currency }, discount?: { amount: { centAmount: number, currency: Currency } } | null, total: { centAmount: number, currency: Currency }, subTotalBeforeDiscount: { centAmount: number, currency: Currency }, shippingCosts?: { centAmount: number, currency: Currency } | null } };

export type AddressFragment = { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null };

export type GetCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerQuery = { customer?: { firstName?: string | null, lastName?: string | null, accountType: AccountType, company?: string | null, email: string, vatNumber?: string | null, billingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, shippingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, addresses?: Array<{ id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null }> | null } | null };

export type CustomerFragment = { firstName?: string | null, lastName?: string | null, accountType: AccountType, company?: string | null, email: string, vatNumber?: string | null, billingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, shippingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, addresses?: Array<{ id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null }> | null };

export type CustomerLoginMutationVariables = Exact<{
  storeContext: StoreContextInput;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type CustomerLoginMutation = { customerLogin: { firstName?: string | null, lastName?: string | null, accountType: AccountType, company?: string | null, email: string, vatNumber?: string | null, billingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, shippingAddress?: { id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null } | null, addresses?: Array<{ id?: string | null, email?: string | null, salutation?: string | null, firstName?: string | null, lastName?: string | null, streetName?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, city?: string | null, phone?: string | null, country: string, company?: string | null }> | null } };

export type CustomerLogoutMutationVariables = Exact<{
  storeContext: StoreContextInput;
}>;


export type CustomerLogoutMutation = { customerLogout: boolean };

export type AddressValidationResultFragment = { valid: boolean, suggestions?: Array<{ city?: string | null, country?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, streetName?: string | null } | null> | null };

export type GetAddressValidateQueryVariables = Exact<{
  storeContext: StoreContextInput;
  address: AddressInput;
}>;


export type GetAddressValidateQuery = { addressValidate?: { valid: boolean, suggestions?: Array<{ city?: string | null, country?: string | null, houseNumber?: string | null, houseNumberSuffix?: string | null, postalCode?: string | null, streetName?: string | null } | null> | null } | null };

export type GetProductsQueryVariables = Exact<{
  storeContext: StoreContextInput;
  sort: ProductSortOrder;
  filters?: InputMaybe<Array<FacetFilterInput> | FacetFilterInput>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  categoryPageId?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetProductsQuery = { productSearch?: { total: number, totalPages: number, queryID?: string | null, results: Array<{ name: string, slug: string, neckline?: string | null, rawMaterial?: string | null, brand?: string | null, denier?: string | null, fit?: string | null, packSize?: number | null, id: string, marketingRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, promotionRibbons?: Array<{ kind: string, label?: string | null, color?: ProductRibbonColors | null } | null> | null, image?: { url: string, alt?: string | null } | null, startingPrice?: { gross: { centAmount: number, currency: Currency } } | null, primaryVariant: { id: string, sku?: string | null, availability?: ProductAvailability | null, name?: string | null, price?: { net: { centAmount: number, currency: Currency }, gross: { centAmount: number, currency: Currency } } | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> }>, facets?: Array<{ __typename: 'OptionsFacet', key: string, label: string, options: Array<{ key: string, label: string, count: number }> } | { __typename: 'RangeFacet', key: string, label: string, min: number, max: number, selectedMin?: number | null, selectedMax?: number | null } | { __typename: 'ToggleFacet', key: string, label: string, options: Array<{ key: string, label: string, count: number }> }> | null } | null };

export type ProductVariantAnalyticsFragmentFragment = { name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null };

export type CategoryAnalyticsFragmentFragment = { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> };

export type ProductAnalyticsFragmentFragment = { id: string, brand?: string | null, name: string };

export type CombinedProductAnalyticsFragmentFragment = { id: string, brand?: string | null, name: string, primaryCategory?: { name: string, id: string, ancestors: Array<{ storyblokName?: string | null, name: string }> } | null, primaryVariant: { name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }, variants: Array<{ name?: string | null, sku?: string | null, regularPrice?: { gross: { centAmount: number, currency: Currency } } | null, attributes?: Array<{ name: string, value: string }> | null }> };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType'];

  constructor(private value: string, public __meta__?: Record<string, any>) {
    super(value);
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const ImageAssetFragmentDoc = new TypedDocumentString(`
    fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
    `, {"fragmentName":"ImageAsset"}) as unknown as TypedDocumentString<ImageAssetFragment, unknown>;
export const MenuItemFieldsFragmentDoc = new TypedDocumentString(`
    fragment MenuItemFields on MenuItem {
  __typename
  id
  label
  optionalLink: link {
    url
  }
}
    `, {"fragmentName":"MenuItemFields"}) as unknown as TypedDocumentString<MenuItemFieldsFragment, unknown>;
export const MenuLinkFragmentDoc = new TypedDocumentString(`
    fragment MenuLink on MenuLink {
  __typename
  id
  label
  link {
    url
    newTab
  }
}
    `, {"fragmentName":"MenuLink"}) as unknown as TypedDocumentString<MenuLinkFragment, unknown>;
export const MainMenuFragmentDoc = new TypedDocumentString(`
    fragment MainMenu on MenuItem {
  ...MenuItemFields
  subMenuItems {
    ...MenuItemFields
    ...MenuLink
    ... on MenuItem {
      subMenuItems {
        ...MenuItemFields
        ...MenuLink
      }
    }
  }
}
    fragment MenuItemFields on MenuItem {
  __typename
  id
  label
  optionalLink: link {
    url
  }
}
fragment MenuLink on MenuLink {
  __typename
  id
  label
  link {
    url
    newTab
  }
}`, {"fragmentName":"MainMenu"}) as unknown as TypedDocumentString<MainMenuFragment, unknown>;
export const MenuBlockFragmentDoc = new TypedDocumentString(`
    fragment MenuBlock on MenuBlock {
  __typename
  id
  label
  menuLinks {
    ...MenuLink
  }
}
    fragment MenuLink on MenuLink {
  __typename
  id
  label
  link {
    url
    newTab
  }
}`, {"fragmentName":"MenuBlock"}) as unknown as TypedDocumentString<MenuBlockFragment, unknown>;
export const RichTextFragmentFragmentDoc = new TypedDocumentString(`
    fragment RichTextFragment on RichText {
  __typename
  id
  content
}
    `, {"fragmentName":"RichTextFragment"}) as unknown as TypedDocumentString<RichTextFragmentFragment, unknown>;
export const FaqItemFragmentFragmentDoc = new TypedDocumentString(`
    fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
    fragment RichTextFragment on RichText {
  __typename
  id
  content
}`, {"fragmentName":"FAQItemFragment"}) as unknown as TypedDocumentString<FaqItemFragmentFragment, unknown>;
export const UspsFragmentFragmentDoc = new TypedDocumentString(`
    fragment UspsFragment on Usps {
  id
  usp1
  usp1Link {
    url
    newTab
    hash
  }
  usp2
  usp2Link {
    url
    newTab
    hash
  }
  usp3
  usp3Link {
    url
    newTab
    hash
  }
}
    `, {"fragmentName":"UspsFragment"}) as unknown as TypedDocumentString<UspsFragmentFragment, unknown>;
export const NotificationBannerFragmentDoc = new TypedDocumentString(`
    fragment NotificationBanner on NotificationBanner {
  __typename
  id
  text
  linkLabel
  optionalLink: link {
    url
  }
}
    `, {"fragmentName":"NotificationBanner"}) as unknown as TypedDocumentString<NotificationBannerFragment, unknown>;
export const FooterNewsletterFragmentFragmentDoc = new TypedDocumentString(`
    fragment FooterNewsletterFragment on Site {
  showNewsletterCTA
  newsletterCTATitle
  newsletterCTABody
}
    `, {"fragmentName":"FooterNewsletterFragment"}) as unknown as TypedDocumentString<FooterNewsletterFragmentFragment, unknown>;
export const SiteFragmentDoc = new TypedDocumentString(`
    fragment Site on Site {
  __typename
  id
  logo {
    ...ImageAsset
  }
  organizationAddress {
    postalCode
    locality
    country
    street
  }
  footerLogo {
    ...ImageAsset
  }
  mainMenu {
    ...MainMenu
    ...MenuLink
  }
  footerMenu {
    ...MenuBlock
  }
  paymentMethods {
    ...ImageAsset
  }
  customerServiceEmail
  customerServiceHours
  customerServicePhone
  faqItems {
    ...FAQItemFragment
  }
  trustMarks {
    ...ImageAsset
  }
  carriers {
    ...ImageAsset
  }
  paymentTerms {
    ...RichTextFragment
  }
  socialsHeading
  facebook {
    url
  }
  instagram {
    url
  }
  linkedIn {
    url
  }
  youtube {
    url
  }
  tiktok {
    url
  }
  pinterest {
    url
  }
  businessLabel
  businessPage {
    url
    newTab
  }
  serviceLabel
  servicePage {
    url
    newTab
  }
  disclaimerLabel
  disclaimerPage {
    url
    newTab
  }
  termsLabel
  termsPage {
    url
    newTab
  }
  cookiesLabel
  cookiesPage {
    url
    newTab
  }
  privacyLabel
  privacyPage {
    url
    newTab
  }
  usps {
    ...UspsFragment
  }
  notificationBanners {
    ...NotificationBanner
  }
  ...FooterNewsletterFragment
}
    fragment FooterNewsletterFragment on Site {
  showNewsletterCTA
  newsletterCTATitle
  newsletterCTABody
}
fragment MainMenu on MenuItem {
  ...MenuItemFields
  subMenuItems {
    ...MenuItemFields
    ...MenuLink
    ... on MenuItem {
      subMenuItems {
        ...MenuItemFields
        ...MenuLink
      }
    }
  }
}
fragment MenuItemFields on MenuItem {
  __typename
  id
  label
  optionalLink: link {
    url
  }
}
fragment MenuLink on MenuLink {
  __typename
  id
  label
  link {
    url
    newTab
  }
}
fragment MenuBlock on MenuBlock {
  __typename
  id
  label
  menuLinks {
    ...MenuLink
  }
}
fragment NotificationBanner on NotificationBanner {
  __typename
  id
  text
  linkLabel
  optionalLink: link {
    url
  }
}
fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment UspsFragment on Usps {
  id
  usp1
  usp1Link {
    url
    newTab
    hash
  }
  usp2
  usp2Link {
    url
    newTab
    hash
  }
  usp3
  usp3Link {
    url
    newTab
    hash
  }
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}`, {"fragmentName":"Site"}) as unknown as TypedDocumentString<SiteFragment, unknown>;
export const BreadcrumbFragmentFragmentDoc = new TypedDocumentString(`
    fragment BreadcrumbFragment on Breadcrumb {
  name
  path
}
    `, {"fragmentName":"BreadcrumbFragment"}) as unknown as TypedDocumentString<BreadcrumbFragmentFragment, unknown>;
export const ContentSeoFragmentFragmentDoc = new TypedDocumentString(`
    fragment ContentSEOFragment on ContentSEO {
  __typename
  title
  description
  ogTitle
  ogDescription
  ogImage
  twitterTitle
  twitterDescription
  twitterImage
}
    `, {"fragmentName":"ContentSEOFragment"}) as unknown as TypedDocumentString<ContentSeoFragmentFragment, unknown>;
export const AbstractPageFragmentFragmentDoc = new TypedDocumentString(`
    fragment AbstractPageFragment on AbstractPage {
  __typename
  id
  name
  path
  translatedPaths {
    locale
    path
  }
  breadcrumbs {
    ...BreadcrumbFragment
  }
  seo {
    ...ContentSEOFragment
  }
}
    fragment ContentSEOFragment on ContentSEO {
  __typename
  title
  description
  ogTitle
  ogDescription
  ogImage
  twitterTitle
  twitterDescription
  twitterImage
}
fragment BreadcrumbFragment on Breadcrumb {
  name
  path
}`, {"fragmentName":"AbstractPageFragment"}) as unknown as TypedDocumentString<AbstractPageFragmentFragment, unknown>;
export const ButtonFragmentFragmentDoc = new TypedDocumentString(`
    fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
    `, {"fragmentName":"ButtonFragment"}) as unknown as TypedDocumentString<ButtonFragmentFragment, unknown>;
export const HeroFragmentFragmentDoc = new TypedDocumentString(`
    fragment HeroFragment on Hero {
  __typename
  id
  title
  variant
  imagePosition
  imageStyle
  bodyText {
    ...RichTextFragment
  }
  buttons {
    ...ButtonFragment
  }
  image {
    ...ImageAsset
  }
}
    fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}`, {"fragmentName":"HeroFragment"}) as unknown as TypedDocumentString<HeroFragmentFragment, unknown>;
export const IframeFragmentFragmentDoc = new TypedDocumentString(`
    fragment IframeFragment on Iframe {
  __typename
  id
  url
  height
}
    `, {"fragmentName":"IframeFragment"}) as unknown as TypedDocumentString<IframeFragmentFragment, unknown>;
export const TeaserRowFragmentFragmentDoc = new TypedDocumentString(`
    fragment TeaserRowFragment on TeaserRow {
  __typename
  id
  title
  viewMoreLink {
    url
    newTab
  }
  items {
    __typename
    id
    content
    image {
      ...ImageAsset
    }
    link {
      url
    }
    title
  }
}
    fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}`, {"fragmentName":"TeaserRowFragment"}) as unknown as TypedDocumentString<TeaserRowFragmentFragment, unknown>;
export const DividerFragmentFragmentDoc = new TypedDocumentString(`
    fragment DividerFragment on Divider {
  __typename
  id
}
    `, {"fragmentName":"DividerFragment"}) as unknown as TypedDocumentString<DividerFragmentFragment, unknown>;
export const ImageFragmentFragmentDoc = new TypedDocumentString(`
    fragment ImageFragment on Image {
  __typename
  id
  image {
    ...ImageAsset
  }
  aspectRatio
}
    fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}`, {"fragmentName":"ImageFragment"}) as unknown as TypedDocumentString<ImageFragmentFragment, unknown>;
export const ButtonsFragmentFragmentDoc = new TypedDocumentString(`
    fragment ButtonsFragment on Buttons {
  __typename
  id
  buttons {
    ...ButtonFragment
  }
}
    fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}`, {"fragmentName":"ButtonsFragment"}) as unknown as TypedDocumentString<ButtonsFragmentFragment, unknown>;
export const BlockQuoteFragmentFragmentDoc = new TypedDocumentString(`
    fragment BlockQuoteFragment on BlockQuote {
  __typename
  id
  content
  name
  title
}
    `, {"fragmentName":"BlockQuoteFragment"}) as unknown as TypedDocumentString<BlockQuoteFragmentFragment, unknown>;
export const TableCellFragmentFragmentDoc = new TypedDocumentString(`
    fragment TableCellFragment on ContentTableCell {
  value
}
    `, {"fragmentName":"TableCellFragment"}) as unknown as TypedDocumentString<TableCellFragmentFragment, unknown>;
export const TableFragmentFragmentDoc = new TypedDocumentString(`
    fragment TableFragment on Table {
  __typename
  id
  style
  dividers
  width
  table {
    thead {
      ...TableCellFragment
    }
    tbody {
      body {
        ...TableCellFragment
      }
    }
  }
}
    fragment TableCellFragment on ContentTableCell {
  value
}`, {"fragmentName":"TableFragment"}) as unknown as TypedDocumentString<TableFragmentFragment, unknown>;
export const NewsletterCtaFragmentFragmentDoc = new TypedDocumentString(`
    fragment NewsletterCTAFragment on NewsletterCTA {
  __typename
  id
  orientation
}
    `, {"fragmentName":"NewsletterCTAFragment"}) as unknown as TypedDocumentString<NewsletterCtaFragmentFragment, unknown>;
export const CookieDeclarationFragmentFragmentDoc = new TypedDocumentString(`
    fragment CookieDeclarationFragment on CookieDeclaration {
  __typename
  id
}
    `, {"fragmentName":"CookieDeclarationFragment"}) as unknown as TypedDocumentString<CookieDeclarationFragmentFragment, unknown>;
export const VideoFragmentFragmentDoc = new TypedDocumentString(`
    fragment VideoFragment on Video {
  __typename
  id
  video
}
    `, {"fragmentName":"VideoFragment"}) as unknown as TypedDocumentString<VideoFragmentFragment, unknown>;
export const FaqItemListFragmentFragmentDoc = new TypedDocumentString(`
    fragment FAQItemListFragment on FAQItemList {
  __typename
  id
  faqItems {
    ...FAQItemFragment
  }
}
    fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}`, {"fragmentName":"FAQItemListFragment"}) as unknown as TypedDocumentString<FaqItemListFragmentFragment, unknown>;
export const ColumnBlockFragmentFragmentDoc = new TypedDocumentString(`
    fragment ColumnBlockFragment on ColumnBlock {
  ...DividerFragment
  ...IframeFragment
  ...ImageFragment
  ...RichTextFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...CookieDeclarationFragment
  ...VideoFragment
  ...FAQItemListFragment
}
    fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment BlockQuoteFragment on BlockQuote {
  __typename
  id
  content
  name
  title
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment ButtonsFragment on Buttons {
  __typename
  id
  buttons {
    ...ButtonFragment
  }
}
fragment CookieDeclarationFragment on CookieDeclaration {
  __typename
  id
}
fragment DividerFragment on Divider {
  __typename
  id
}
fragment FAQItemListFragment on FAQItemList {
  __typename
  id
  faqItems {
    ...FAQItemFragment
  }
}
fragment IframeFragment on Iframe {
  __typename
  id
  url
  height
}
fragment ImageFragment on Image {
  __typename
  id
  image {
    ...ImageAsset
  }
  aspectRatio
}
fragment NewsletterCTAFragment on NewsletterCTA {
  __typename
  id
  orientation
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}
fragment TableCellFragment on ContentTableCell {
  value
}
fragment TableFragment on Table {
  __typename
  id
  style
  dividers
  width
  table {
    thead {
      ...TableCellFragment
    }
    tbody {
      body {
        ...TableCellFragment
      }
    }
  }
}
fragment VideoFragment on Video {
  __typename
  id
  video
}`, {"fragmentName":"ColumnBlockFragment"}) as unknown as TypedDocumentString<ColumnBlockFragmentFragment, unknown>;
export const TwoColumnFragmentFragmentDoc = new TypedDocumentString(`
    fragment TwoColumnFragment on TwoColumns {
  __typename
  id
  alignment
  ratio
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
}
    fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment BlockQuoteFragment on BlockQuote {
  __typename
  id
  content
  name
  title
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment ButtonsFragment on Buttons {
  __typename
  id
  buttons {
    ...ButtonFragment
  }
}
fragment ColumnBlockFragment on ColumnBlock {
  ...DividerFragment
  ...IframeFragment
  ...ImageFragment
  ...RichTextFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...CookieDeclarationFragment
  ...VideoFragment
  ...FAQItemListFragment
}
fragment CookieDeclarationFragment on CookieDeclaration {
  __typename
  id
}
fragment DividerFragment on Divider {
  __typename
  id
}
fragment FAQItemListFragment on FAQItemList {
  __typename
  id
  faqItems {
    ...FAQItemFragment
  }
}
fragment IframeFragment on Iframe {
  __typename
  id
  url
  height
}
fragment ImageFragment on Image {
  __typename
  id
  image {
    ...ImageAsset
  }
  aspectRatio
}
fragment NewsletterCTAFragment on NewsletterCTA {
  __typename
  id
  orientation
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}
fragment TableCellFragment on ContentTableCell {
  value
}
fragment TableFragment on Table {
  __typename
  id
  style
  dividers
  width
  table {
    thead {
      ...TableCellFragment
    }
    tbody {
      body {
        ...TableCellFragment
      }
    }
  }
}
fragment VideoFragment on Video {
  __typename
  id
  video
}`, {"fragmentName":"TwoColumnFragment"}) as unknown as TypedDocumentString<TwoColumnFragmentFragment, unknown>;
export const ThreeColumnFragmentFragmentDoc = new TypedDocumentString(`
    fragment ThreeColumnFragment on ThreeColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
}
    fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment BlockQuoteFragment on BlockQuote {
  __typename
  id
  content
  name
  title
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment ButtonsFragment on Buttons {
  __typename
  id
  buttons {
    ...ButtonFragment
  }
}
fragment ColumnBlockFragment on ColumnBlock {
  ...DividerFragment
  ...IframeFragment
  ...ImageFragment
  ...RichTextFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...CookieDeclarationFragment
  ...VideoFragment
  ...FAQItemListFragment
}
fragment CookieDeclarationFragment on CookieDeclaration {
  __typename
  id
}
fragment DividerFragment on Divider {
  __typename
  id
}
fragment FAQItemListFragment on FAQItemList {
  __typename
  id
  faqItems {
    ...FAQItemFragment
  }
}
fragment IframeFragment on Iframe {
  __typename
  id
  url
  height
}
fragment ImageFragment on Image {
  __typename
  id
  image {
    ...ImageAsset
  }
  aspectRatio
}
fragment NewsletterCTAFragment on NewsletterCTA {
  __typename
  id
  orientation
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}
fragment TableCellFragment on ContentTableCell {
  value
}
fragment TableFragment on Table {
  __typename
  id
  style
  dividers
  width
  table {
    thead {
      ...TableCellFragment
    }
    tbody {
      body {
        ...TableCellFragment
      }
    }
  }
}
fragment VideoFragment on Video {
  __typename
  id
  video
}`, {"fragmentName":"ThreeColumnFragment"}) as unknown as TypedDocumentString<ThreeColumnFragmentFragment, unknown>;
export const FourColumnFragmentFragmentDoc = new TypedDocumentString(`
    fragment FourColumnFragment on FourColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
  column_4 {
    ...ColumnBlockFragment
  }
}
    fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment BlockQuoteFragment on BlockQuote {
  __typename
  id
  content
  name
  title
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment ButtonsFragment on Buttons {
  __typename
  id
  buttons {
    ...ButtonFragment
  }
}
fragment ColumnBlockFragment on ColumnBlock {
  ...DividerFragment
  ...IframeFragment
  ...ImageFragment
  ...RichTextFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...CookieDeclarationFragment
  ...VideoFragment
  ...FAQItemListFragment
}
fragment CookieDeclarationFragment on CookieDeclaration {
  __typename
  id
}
fragment DividerFragment on Divider {
  __typename
  id
}
fragment FAQItemListFragment on FAQItemList {
  __typename
  id
  faqItems {
    ...FAQItemFragment
  }
}
fragment IframeFragment on Iframe {
  __typename
  id
  url
  height
}
fragment ImageFragment on Image {
  __typename
  id
  image {
    ...ImageAsset
  }
  aspectRatio
}
fragment NewsletterCTAFragment on NewsletterCTA {
  __typename
  id
  orientation
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}
fragment TableCellFragment on ContentTableCell {
  value
}
fragment TableFragment on Table {
  __typename
  id
  style
  dividers
  width
  table {
    thead {
      ...TableCellFragment
    }
    tbody {
      body {
        ...TableCellFragment
      }
    }
  }
}
fragment VideoFragment on Video {
  __typename
  id
  video
}`, {"fragmentName":"FourColumnFragment"}) as unknown as TypedDocumentString<FourColumnFragmentFragment, unknown>;
export const SectionHeaderFragmentFragmentDoc = new TypedDocumentString(`
    fragment SectionHeaderFragment on SectionHeader {
  __typename
  id
  title
  imagePosition
  imageStyle
  bodyText {
    ...RichTextFragment
  }
  buttons {
    ...ButtonFragment
  }
  headerImage: image {
    ...ImageAsset
  }
}
    fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}`, {"fragmentName":"SectionHeaderFragment"}) as unknown as TypedDocumentString<SectionHeaderFragmentFragment, unknown>;
export const UgcFlowboxFragmentFragmentDoc = new TypedDocumentString(`
    fragment UGCFlowboxFragment on UGCFlowbox {
  __typename
  id
  key
  tags
}
    `, {"fragmentName":"UGCFlowboxFragment"}) as unknown as TypedDocumentString<UgcFlowboxFragmentFragment, unknown>;
export const PriceTagFragmentDoc = new TypedDocumentString(`
    fragment PriceTag on Money {
  centAmount
  currency
}
    `, {"fragmentName":"PriceTag"}) as unknown as TypedDocumentString<PriceTagFragment, unknown>;
export const PriceFragmentDoc = new TypedDocumentString(`
    fragment Price on Money {
  centAmount
  currency
}
    `, {"fragmentName":"Price"}) as unknown as TypedDocumentString<PriceFragment, unknown>;
export const ProductVariantAnalyticsFragmentFragmentDoc = new TypedDocumentString(`
    fragment ProductVariantAnalyticsFragment on ProductVariant {
  name
  sku
  regularPrice {
    gross {
      ...Price
    }
  }
  attributes {
    name
    value
  }
}
    fragment Price on Money {
  centAmount
  currency
}`, {"fragmentName":"ProductVariantAnalyticsFragment"}) as unknown as TypedDocumentString<ProductVariantAnalyticsFragmentFragment, unknown>;
export const CategoryAnalyticsFragmentFragmentDoc = new TypedDocumentString(`
    fragment CategoryAnalyticsFragment on ProductCategory {
  name
  id
  ancestors {
    storyblokName
    name
  }
}
    `, {"fragmentName":"CategoryAnalyticsFragment"}) as unknown as TypedDocumentString<CategoryAnalyticsFragmentFragment, unknown>;
export const ProductAnalyticsFragmentFragmentDoc = new TypedDocumentString(`
    fragment ProductAnalyticsFragment on Product {
  id
  brand
  name
}
    `, {"fragmentName":"ProductAnalyticsFragment"}) as unknown as TypedDocumentString<ProductAnalyticsFragmentFragment, unknown>;
export const ProductCardFragmentDoc = new TypedDocumentString(`
    fragment ProductCard on Product {
  name
  slug
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  marketingRibbons {
    kind
    label
    color
  }
  promotionRibbons {
    kind
    label
    color
  }
  image {
    url
    alt
  }
  startingPrice {
    gross {
      ...PriceTag
    }
  }
  primaryVariant {
    ...ProductVariantAnalyticsFragment
    id
    sku
    availability
    price {
      net {
        ...PriceTag
      }
      gross {
        ...PriceTag
      }
    }
  }
  primaryCategory {
    ...CategoryAnalyticsFragment
  }
  variants {
    ...ProductVariantAnalyticsFragment
  }
  ...ProductAnalyticsFragment
}
    fragment Price on Money {
  centAmount
  currency
}
fragment PriceTag on Money {
  centAmount
  currency
}
fragment ProductVariantAnalyticsFragment on ProductVariant {
  name
  sku
  regularPrice {
    gross {
      ...Price
    }
  }
  attributes {
    name
    value
  }
}
fragment CategoryAnalyticsFragment on ProductCategory {
  name
  id
  ancestors {
    storyblokName
    name
  }
}
fragment ProductAnalyticsFragment on Product {
  id
  brand
  name
}`, {"fragmentName":"ProductCard"}) as unknown as TypedDocumentString<ProductCardFragment, unknown>;
export const ShopSectionFragmentFragmentDoc = new TypedDocumentString(`
    fragment ShopSectionFragment on ShopSection {
  __typename
  id
  title
  subtitle
  category
  viewAllLink {
    url
    newTab
  }
  viewAllLabel
  variant
  products {
    ...ProductCard
  }
}
    fragment Price on Money {
  centAmount
  currency
}
fragment PriceTag on Money {
  centAmount
  currency
}
fragment ProductCard on Product {
  name
  slug
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  marketingRibbons {
    kind
    label
    color
  }
  promotionRibbons {
    kind
    label
    color
  }
  image {
    url
    alt
  }
  startingPrice {
    gross {
      ...PriceTag
    }
  }
  primaryVariant {
    ...ProductVariantAnalyticsFragment
    id
    sku
    availability
    price {
      net {
        ...PriceTag
      }
      gross {
        ...PriceTag
      }
    }
  }
  primaryCategory {
    ...CategoryAnalyticsFragment
  }
  variants {
    ...ProductVariantAnalyticsFragment
  }
  ...ProductAnalyticsFragment
}
fragment ProductVariantAnalyticsFragment on ProductVariant {
  name
  sku
  regularPrice {
    gross {
      ...Price
    }
  }
  attributes {
    name
    value
  }
}
fragment CategoryAnalyticsFragment on ProductCategory {
  name
  id
  ancestors {
    storyblokName
    name
  }
}
fragment ProductAnalyticsFragment on Product {
  id
  brand
  name
}`, {"fragmentName":"ShopSectionFragment"}) as unknown as TypedDocumentString<ShopSectionFragmentFragment, unknown>;
export const CategoryCardFragmentFragmentDoc = new TypedDocumentString(`
    fragment CategoryCardFragment on Card {
  __typename
  id
  title
  category
  supportingText
  image {
    ...ImageAsset
  }
  cardLink: link {
    url
    newTab
    hash
  }
}
    fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}`, {"fragmentName":"CategoryCardFragment"}) as unknown as TypedDocumentString<CategoryCardFragmentFragment, unknown>;
export const CategorySectionFragmentFragmentDoc = new TypedDocumentString(`
    fragment CategorySectionFragment on CategorySection {
  __typename
  id
  title
  category
  supportingText
  headerAlign
  variant
  link {
    url
    newTab
    hash
  }
  items {
    ...CategoryCardFragment
  }
}
    fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment CategoryCardFragment on Card {
  __typename
  id
  title
  category
  supportingText
  image {
    ...ImageAsset
  }
  cardLink: link {
    url
    newTab
    hash
  }
}`, {"fragmentName":"CategorySectionFragment"}) as unknown as TypedDocumentString<CategorySectionFragmentFragment, unknown>;
export const JafixFragmentFragmentDoc = new TypedDocumentString(`
    fragment JafixFragment on Jafix {
  __typename
  id
  key
}
    `, {"fragmentName":"JafixFragment"}) as unknown as TypedDocumentString<JafixFragmentFragment, unknown>;
export const SectionFragmentFragmentDoc = new TypedDocumentString(`
    fragment SectionFragment on Section {
  __typename
  id
  backgroundColor
  size
  spacing
  body {
    ...TeaserRowFragment
    ...RichTextFragment
    ...TwoColumnFragment
    ...ThreeColumnFragment
    ...FourColumnFragment
    ...SectionHeaderFragment
    ...ImageFragment
    ...DividerFragment
    ...IframeFragment
    ...ButtonsFragment
    ...BlockQuoteFragment
    ...TableFragment
    ...NewsletterCTAFragment
    ...UGCFlowboxFragment
    ...CookieDeclarationFragment
    ...VideoFragment
    ...FAQItemListFragment
    ...ShopSectionFragment
    ...CategorySectionFragment
    ...JafixFragment
  }
}
    fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment CategoryCardFragment on Card {
  __typename
  id
  title
  category
  supportingText
  image {
    ...ImageAsset
  }
  cardLink: link {
    url
    newTab
    hash
  }
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment Price on Money {
  centAmount
  currency
}
fragment PriceTag on Money {
  centAmount
  currency
}
fragment ProductCard on Product {
  name
  slug
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  marketingRibbons {
    kind
    label
    color
  }
  promotionRibbons {
    kind
    label
    color
  }
  image {
    url
    alt
  }
  startingPrice {
    gross {
      ...PriceTag
    }
  }
  primaryVariant {
    ...ProductVariantAnalyticsFragment
    id
    sku
    availability
    price {
      net {
        ...PriceTag
      }
      gross {
        ...PriceTag
      }
    }
  }
  primaryCategory {
    ...CategoryAnalyticsFragment
  }
  variants {
    ...ProductVariantAnalyticsFragment
  }
  ...ProductAnalyticsFragment
}
fragment SectionHeaderFragment on SectionHeader {
  __typename
  id
  title
  imagePosition
  imageStyle
  bodyText {
    ...RichTextFragment
  }
  buttons {
    ...ButtonFragment
  }
  headerImage: image {
    ...ImageAsset
  }
}
fragment TeaserRowFragment on TeaserRow {
  __typename
  id
  title
  viewMoreLink {
    url
    newTab
  }
  items {
    __typename
    id
    content
    image {
      ...ImageAsset
    }
    link {
      url
    }
    title
  }
}
fragment BlockQuoteFragment on BlockQuote {
  __typename
  id
  content
  name
  title
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment ButtonsFragment on Buttons {
  __typename
  id
  buttons {
    ...ButtonFragment
  }
}
fragment CategorySectionFragment on CategorySection {
  __typename
  id
  title
  category
  supportingText
  headerAlign
  variant
  link {
    url
    newTab
    hash
  }
  items {
    ...CategoryCardFragment
  }
}
fragment ColumnBlockFragment on ColumnBlock {
  ...DividerFragment
  ...IframeFragment
  ...ImageFragment
  ...RichTextFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...CookieDeclarationFragment
  ...VideoFragment
  ...FAQItemListFragment
}
fragment FourColumnFragment on FourColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
  column_4 {
    ...ColumnBlockFragment
  }
}
fragment ThreeColumnFragment on ThreeColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
}
fragment TwoColumnFragment on TwoColumns {
  __typename
  id
  alignment
  ratio
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
}
fragment CookieDeclarationFragment on CookieDeclaration {
  __typename
  id
}
fragment DividerFragment on Divider {
  __typename
  id
}
fragment FAQItemListFragment on FAQItemList {
  __typename
  id
  faqItems {
    ...FAQItemFragment
  }
}
fragment IframeFragment on Iframe {
  __typename
  id
  url
  height
}
fragment ImageFragment on Image {
  __typename
  id
  image {
    ...ImageAsset
  }
  aspectRatio
}
fragment JafixFragment on Jafix {
  __typename
  id
  key
}
fragment NewsletterCTAFragment on NewsletterCTA {
  __typename
  id
  orientation
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}
fragment ShopSectionFragment on ShopSection {
  __typename
  id
  title
  subtitle
  category
  viewAllLink {
    url
    newTab
  }
  viewAllLabel
  variant
  products {
    ...ProductCard
  }
}
fragment TableCellFragment on ContentTableCell {
  value
}
fragment TableFragment on Table {
  __typename
  id
  style
  dividers
  width
  table {
    thead {
      ...TableCellFragment
    }
    tbody {
      body {
        ...TableCellFragment
      }
    }
  }
}
fragment UGCFlowboxFragment on UGCFlowbox {
  __typename
  id
  key
  tags
}
fragment VideoFragment on Video {
  __typename
  id
  video
}
fragment ProductVariantAnalyticsFragment on ProductVariant {
  name
  sku
  regularPrice {
    gross {
      ...Price
    }
  }
  attributes {
    name
    value
  }
}
fragment CategoryAnalyticsFragment on ProductCategory {
  name
  id
  ancestors {
    storyblokName
    name
  }
}
fragment ProductAnalyticsFragment on Product {
  id
  brand
  name
}`, {"fragmentName":"SectionFragment"}) as unknown as TypedDocumentString<SectionFragmentFragment, unknown>;
export const ArticleCardFragmentFragmentDoc = new TypedDocumentString(`
    fragment ArticleCardFragment on ArticleCard {
  id
  title
  location
  publishedAt
  image {
    filename
    alt
  }
  link {
    url
  }
}
    `, {"fragmentName":"ArticleCardFragment"}) as unknown as TypedDocumentString<ArticleCardFragmentFragment, unknown>;
export const ArticleOverviewFragmentFragmentDoc = new TypedDocumentString(`
    fragment ArticleOverviewFragment on ArticleOverview {
  __typename
  id
  articleItems: items(page: $currentPage) {
    totalPages
    results {
      ...ArticleCardFragment
    }
  }
}
    fragment ArticleCardFragment on ArticleCard {
  id
  title
  location
  publishedAt
  image {
    filename
    alt
  }
  link {
    url
  }
}`, {"fragmentName":"ArticleOverviewFragment"}) as unknown as TypedDocumentString<ArticleOverviewFragmentFragment, unknown>;
export const BaseBlocksFragmentFragmentDoc = new TypedDocumentString(`
    fragment BaseBlocksFragment on Block {
  ...IframeFragment
  ...SectionFragment
  ...TeaserRowFragment
  ...RichTextFragment
  ...TwoColumnFragment
  ...ThreeColumnFragment
  ...FourColumnFragment
  ...SectionHeaderFragment
  ...DividerFragment
  ...ImageFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...CategorySectionFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...UGCFlowboxFragment
  ...ShopSectionFragment
  ...CookieDeclarationFragment
  ...ArticleOverviewFragment
  ...VideoFragment
  ...FAQItemListFragment
  ...JafixFragment
}
    fragment ArticleCardFragment on ArticleCard {
  id
  title
  location
  publishedAt
  image {
    filename
    alt
  }
  link {
    url
  }
}
fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment CategoryCardFragment on Card {
  __typename
  id
  title
  category
  supportingText
  image {
    ...ImageAsset
  }
  cardLink: link {
    url
    newTab
    hash
  }
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment Price on Money {
  centAmount
  currency
}
fragment PriceTag on Money {
  centAmount
  currency
}
fragment ProductCard on Product {
  name
  slug
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  marketingRibbons {
    kind
    label
    color
  }
  promotionRibbons {
    kind
    label
    color
  }
  image {
    url
    alt
  }
  startingPrice {
    gross {
      ...PriceTag
    }
  }
  primaryVariant {
    ...ProductVariantAnalyticsFragment
    id
    sku
    availability
    price {
      net {
        ...PriceTag
      }
      gross {
        ...PriceTag
      }
    }
  }
  primaryCategory {
    ...CategoryAnalyticsFragment
  }
  variants {
    ...ProductVariantAnalyticsFragment
  }
  ...ProductAnalyticsFragment
}
fragment SectionHeaderFragment on SectionHeader {
  __typename
  id
  title
  imagePosition
  imageStyle
  bodyText {
    ...RichTextFragment
  }
  buttons {
    ...ButtonFragment
  }
  headerImage: image {
    ...ImageAsset
  }
}
fragment TeaserRowFragment on TeaserRow {
  __typename
  id
  title
  viewMoreLink {
    url
    newTab
  }
  items {
    __typename
    id
    content
    image {
      ...ImageAsset
    }
    link {
      url
    }
    title
  }
}
fragment ArticleOverviewFragment on ArticleOverview {
  __typename
  id
  articleItems: items(page: $currentPage) {
    totalPages
    results {
      ...ArticleCardFragment
    }
  }
}
fragment BlockQuoteFragment on BlockQuote {
  __typename
  id
  content
  name
  title
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment ButtonsFragment on Buttons {
  __typename
  id
  buttons {
    ...ButtonFragment
  }
}
fragment CategorySectionFragment on CategorySection {
  __typename
  id
  title
  category
  supportingText
  headerAlign
  variant
  link {
    url
    newTab
    hash
  }
  items {
    ...CategoryCardFragment
  }
}
fragment ColumnBlockFragment on ColumnBlock {
  ...DividerFragment
  ...IframeFragment
  ...ImageFragment
  ...RichTextFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...CookieDeclarationFragment
  ...VideoFragment
  ...FAQItemListFragment
}
fragment FourColumnFragment on FourColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
  column_4 {
    ...ColumnBlockFragment
  }
}
fragment ThreeColumnFragment on ThreeColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
}
fragment TwoColumnFragment on TwoColumns {
  __typename
  id
  alignment
  ratio
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
}
fragment CookieDeclarationFragment on CookieDeclaration {
  __typename
  id
}
fragment DividerFragment on Divider {
  __typename
  id
}
fragment FAQItemListFragment on FAQItemList {
  __typename
  id
  faqItems {
    ...FAQItemFragment
  }
}
fragment IframeFragment on Iframe {
  __typename
  id
  url
  height
}
fragment ImageFragment on Image {
  __typename
  id
  image {
    ...ImageAsset
  }
  aspectRatio
}
fragment JafixFragment on Jafix {
  __typename
  id
  key
}
fragment NewsletterCTAFragment on NewsletterCTA {
  __typename
  id
  orientation
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}
fragment SectionFragment on Section {
  __typename
  id
  backgroundColor
  size
  spacing
  body {
    ...TeaserRowFragment
    ...RichTextFragment
    ...TwoColumnFragment
    ...ThreeColumnFragment
    ...FourColumnFragment
    ...SectionHeaderFragment
    ...ImageFragment
    ...DividerFragment
    ...IframeFragment
    ...ButtonsFragment
    ...BlockQuoteFragment
    ...TableFragment
    ...NewsletterCTAFragment
    ...UGCFlowboxFragment
    ...CookieDeclarationFragment
    ...VideoFragment
    ...FAQItemListFragment
    ...ShopSectionFragment
    ...CategorySectionFragment
    ...JafixFragment
  }
}
fragment ShopSectionFragment on ShopSection {
  __typename
  id
  title
  subtitle
  category
  viewAllLink {
    url
    newTab
  }
  viewAllLabel
  variant
  products {
    ...ProductCard
  }
}
fragment TableCellFragment on ContentTableCell {
  value
}
fragment TableFragment on Table {
  __typename
  id
  style
  dividers
  width
  table {
    thead {
      ...TableCellFragment
    }
    tbody {
      body {
        ...TableCellFragment
      }
    }
  }
}
fragment UGCFlowboxFragment on UGCFlowbox {
  __typename
  id
  key
  tags
}
fragment VideoFragment on Video {
  __typename
  id
  video
}
fragment ProductVariantAnalyticsFragment on ProductVariant {
  name
  sku
  regularPrice {
    gross {
      ...Price
    }
  }
  attributes {
    name
    value
  }
}
fragment CategoryAnalyticsFragment on ProductCategory {
  name
  id
  ancestors {
    storyblokName
    name
  }
}
fragment ProductAnalyticsFragment on Product {
  id
  brand
  name
}`, {"fragmentName":"BaseBlocksFragment"}) as unknown as TypedDocumentString<BaseBlocksFragmentFragment, unknown>;
export const CountrySpecificContainerFragmentFragmentDoc = new TypedDocumentString(`
    fragment CountrySpecificContainerFragment on CountrySpecificContainer {
  __typename
  id
  countries
  countrySpecificContainerBody: body {
    ...BaseBlocksFragment
  }
}
    fragment BaseBlocksFragment on Block {
  ...IframeFragment
  ...SectionFragment
  ...TeaserRowFragment
  ...RichTextFragment
  ...TwoColumnFragment
  ...ThreeColumnFragment
  ...FourColumnFragment
  ...SectionHeaderFragment
  ...DividerFragment
  ...ImageFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...CategorySectionFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...UGCFlowboxFragment
  ...ShopSectionFragment
  ...CookieDeclarationFragment
  ...ArticleOverviewFragment
  ...VideoFragment
  ...FAQItemListFragment
  ...JafixFragment
}
fragment ArticleCardFragment on ArticleCard {
  id
  title
  location
  publishedAt
  image {
    filename
    alt
  }
  link {
    url
  }
}
fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment CategoryCardFragment on Card {
  __typename
  id
  title
  category
  supportingText
  image {
    ...ImageAsset
  }
  cardLink: link {
    url
    newTab
    hash
  }
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment Price on Money {
  centAmount
  currency
}
fragment PriceTag on Money {
  centAmount
  currency
}
fragment ProductCard on Product {
  name
  slug
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  marketingRibbons {
    kind
    label
    color
  }
  promotionRibbons {
    kind
    label
    color
  }
  image {
    url
    alt
  }
  startingPrice {
    gross {
      ...PriceTag
    }
  }
  primaryVariant {
    ...ProductVariantAnalyticsFragment
    id
    sku
    availability
    price {
      net {
        ...PriceTag
      }
      gross {
        ...PriceTag
      }
    }
  }
  primaryCategory {
    ...CategoryAnalyticsFragment
  }
  variants {
    ...ProductVariantAnalyticsFragment
  }
  ...ProductAnalyticsFragment
}
fragment SectionHeaderFragment on SectionHeader {
  __typename
  id
  title
  imagePosition
  imageStyle
  bodyText {
    ...RichTextFragment
  }
  buttons {
    ...ButtonFragment
  }
  headerImage: image {
    ...ImageAsset
  }
}
fragment TeaserRowFragment on TeaserRow {
  __typename
  id
  title
  viewMoreLink {
    url
    newTab
  }
  items {
    __typename
    id
    content
    image {
      ...ImageAsset
    }
    link {
      url
    }
    title
  }
}
fragment ArticleOverviewFragment on ArticleOverview {
  __typename
  id
  articleItems: items(page: $currentPage) {
    totalPages
    results {
      ...ArticleCardFragment
    }
  }
}
fragment BlockQuoteFragment on BlockQuote {
  __typename
  id
  content
  name
  title
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment ButtonsFragment on Buttons {
  __typename
  id
  buttons {
    ...ButtonFragment
  }
}
fragment CategorySectionFragment on CategorySection {
  __typename
  id
  title
  category
  supportingText
  headerAlign
  variant
  link {
    url
    newTab
    hash
  }
  items {
    ...CategoryCardFragment
  }
}
fragment ColumnBlockFragment on ColumnBlock {
  ...DividerFragment
  ...IframeFragment
  ...ImageFragment
  ...RichTextFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...CookieDeclarationFragment
  ...VideoFragment
  ...FAQItemListFragment
}
fragment FourColumnFragment on FourColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
  column_4 {
    ...ColumnBlockFragment
  }
}
fragment ThreeColumnFragment on ThreeColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
}
fragment TwoColumnFragment on TwoColumns {
  __typename
  id
  alignment
  ratio
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
}
fragment CookieDeclarationFragment on CookieDeclaration {
  __typename
  id
}
fragment DividerFragment on Divider {
  __typename
  id
}
fragment FAQItemListFragment on FAQItemList {
  __typename
  id
  faqItems {
    ...FAQItemFragment
  }
}
fragment IframeFragment on Iframe {
  __typename
  id
  url
  height
}
fragment ImageFragment on Image {
  __typename
  id
  image {
    ...ImageAsset
  }
  aspectRatio
}
fragment JafixFragment on Jafix {
  __typename
  id
  key
}
fragment NewsletterCTAFragment on NewsletterCTA {
  __typename
  id
  orientation
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}
fragment SectionFragment on Section {
  __typename
  id
  backgroundColor
  size
  spacing
  body {
    ...TeaserRowFragment
    ...RichTextFragment
    ...TwoColumnFragment
    ...ThreeColumnFragment
    ...FourColumnFragment
    ...SectionHeaderFragment
    ...ImageFragment
    ...DividerFragment
    ...IframeFragment
    ...ButtonsFragment
    ...BlockQuoteFragment
    ...TableFragment
    ...NewsletterCTAFragment
    ...UGCFlowboxFragment
    ...CookieDeclarationFragment
    ...VideoFragment
    ...FAQItemListFragment
    ...ShopSectionFragment
    ...CategorySectionFragment
    ...JafixFragment
  }
}
fragment ShopSectionFragment on ShopSection {
  __typename
  id
  title
  subtitle
  category
  viewAllLink {
    url
    newTab
  }
  viewAllLabel
  variant
  products {
    ...ProductCard
  }
}
fragment TableCellFragment on ContentTableCell {
  value
}
fragment TableFragment on Table {
  __typename
  id
  style
  dividers
  width
  table {
    thead {
      ...TableCellFragment
    }
    tbody {
      body {
        ...TableCellFragment
      }
    }
  }
}
fragment UGCFlowboxFragment on UGCFlowbox {
  __typename
  id
  key
  tags
}
fragment VideoFragment on Video {
  __typename
  id
  video
}
fragment ProductVariantAnalyticsFragment on ProductVariant {
  name
  sku
  regularPrice {
    gross {
      ...Price
    }
  }
  attributes {
    name
    value
  }
}
fragment CategoryAnalyticsFragment on ProductCategory {
  name
  id
  ancestors {
    storyblokName
    name
  }
}
fragment ProductAnalyticsFragment on Product {
  id
  brand
  name
}`, {"fragmentName":"CountrySpecificContainerFragment"}) as unknown as TypedDocumentString<CountrySpecificContainerFragmentFragment, unknown>;
export const BlocksFragmentFragmentDoc = new TypedDocumentString(`
    fragment BlocksFragment on Block {
  ...BaseBlocksFragment
  ...CountrySpecificContainerFragment
}
    fragment BaseBlocksFragment on Block {
  ...IframeFragment
  ...SectionFragment
  ...TeaserRowFragment
  ...RichTextFragment
  ...TwoColumnFragment
  ...ThreeColumnFragment
  ...FourColumnFragment
  ...SectionHeaderFragment
  ...DividerFragment
  ...ImageFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...CategorySectionFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...UGCFlowboxFragment
  ...ShopSectionFragment
  ...CookieDeclarationFragment
  ...ArticleOverviewFragment
  ...VideoFragment
  ...FAQItemListFragment
  ...JafixFragment
}
fragment ArticleCardFragment on ArticleCard {
  id
  title
  location
  publishedAt
  image {
    filename
    alt
  }
  link {
    url
  }
}
fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment CategoryCardFragment on Card {
  __typename
  id
  title
  category
  supportingText
  image {
    ...ImageAsset
  }
  cardLink: link {
    url
    newTab
    hash
  }
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment Price on Money {
  centAmount
  currency
}
fragment PriceTag on Money {
  centAmount
  currency
}
fragment ProductCard on Product {
  name
  slug
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  marketingRibbons {
    kind
    label
    color
  }
  promotionRibbons {
    kind
    label
    color
  }
  image {
    url
    alt
  }
  startingPrice {
    gross {
      ...PriceTag
    }
  }
  primaryVariant {
    ...ProductVariantAnalyticsFragment
    id
    sku
    availability
    price {
      net {
        ...PriceTag
      }
      gross {
        ...PriceTag
      }
    }
  }
  primaryCategory {
    ...CategoryAnalyticsFragment
  }
  variants {
    ...ProductVariantAnalyticsFragment
  }
  ...ProductAnalyticsFragment
}
fragment SectionHeaderFragment on SectionHeader {
  __typename
  id
  title
  imagePosition
  imageStyle
  bodyText {
    ...RichTextFragment
  }
  buttons {
    ...ButtonFragment
  }
  headerImage: image {
    ...ImageAsset
  }
}
fragment TeaserRowFragment on TeaserRow {
  __typename
  id
  title
  viewMoreLink {
    url
    newTab
  }
  items {
    __typename
    id
    content
    image {
      ...ImageAsset
    }
    link {
      url
    }
    title
  }
}
fragment ArticleOverviewFragment on ArticleOverview {
  __typename
  id
  articleItems: items(page: $currentPage) {
    totalPages
    results {
      ...ArticleCardFragment
    }
  }
}
fragment BlockQuoteFragment on BlockQuote {
  __typename
  id
  content
  name
  title
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment ButtonsFragment on Buttons {
  __typename
  id
  buttons {
    ...ButtonFragment
  }
}
fragment CategorySectionFragment on CategorySection {
  __typename
  id
  title
  category
  supportingText
  headerAlign
  variant
  link {
    url
    newTab
    hash
  }
  items {
    ...CategoryCardFragment
  }
}
fragment ColumnBlockFragment on ColumnBlock {
  ...DividerFragment
  ...IframeFragment
  ...ImageFragment
  ...RichTextFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...CookieDeclarationFragment
  ...VideoFragment
  ...FAQItemListFragment
}
fragment FourColumnFragment on FourColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
  column_4 {
    ...ColumnBlockFragment
  }
}
fragment ThreeColumnFragment on ThreeColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
}
fragment TwoColumnFragment on TwoColumns {
  __typename
  id
  alignment
  ratio
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
}
fragment CookieDeclarationFragment on CookieDeclaration {
  __typename
  id
}
fragment CountrySpecificContainerFragment on CountrySpecificContainer {
  __typename
  id
  countries
  countrySpecificContainerBody: body {
    ...BaseBlocksFragment
  }
}
fragment DividerFragment on Divider {
  __typename
  id
}
fragment FAQItemListFragment on FAQItemList {
  __typename
  id
  faqItems {
    ...FAQItemFragment
  }
}
fragment IframeFragment on Iframe {
  __typename
  id
  url
  height
}
fragment ImageFragment on Image {
  __typename
  id
  image {
    ...ImageAsset
  }
  aspectRatio
}
fragment JafixFragment on Jafix {
  __typename
  id
  key
}
fragment NewsletterCTAFragment on NewsletterCTA {
  __typename
  id
  orientation
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}
fragment SectionFragment on Section {
  __typename
  id
  backgroundColor
  size
  spacing
  body {
    ...TeaserRowFragment
    ...RichTextFragment
    ...TwoColumnFragment
    ...ThreeColumnFragment
    ...FourColumnFragment
    ...SectionHeaderFragment
    ...ImageFragment
    ...DividerFragment
    ...IframeFragment
    ...ButtonsFragment
    ...BlockQuoteFragment
    ...TableFragment
    ...NewsletterCTAFragment
    ...UGCFlowboxFragment
    ...CookieDeclarationFragment
    ...VideoFragment
    ...FAQItemListFragment
    ...ShopSectionFragment
    ...CategorySectionFragment
    ...JafixFragment
  }
}
fragment ShopSectionFragment on ShopSection {
  __typename
  id
  title
  subtitle
  category
  viewAllLink {
    url
    newTab
  }
  viewAllLabel
  variant
  products {
    ...ProductCard
  }
}
fragment TableCellFragment on ContentTableCell {
  value
}
fragment TableFragment on Table {
  __typename
  id
  style
  dividers
  width
  table {
    thead {
      ...TableCellFragment
    }
    tbody {
      body {
        ...TableCellFragment
      }
    }
  }
}
fragment UGCFlowboxFragment on UGCFlowbox {
  __typename
  id
  key
  tags
}
fragment VideoFragment on Video {
  __typename
  id
  video
}
fragment ProductVariantAnalyticsFragment on ProductVariant {
  name
  sku
  regularPrice {
    gross {
      ...Price
    }
  }
  attributes {
    name
    value
  }
}
fragment CategoryAnalyticsFragment on ProductCategory {
  name
  id
  ancestors {
    storyblokName
    name
  }
}
fragment ProductAnalyticsFragment on Product {
  id
  brand
  name
}`, {"fragmentName":"BlocksFragment"}) as unknown as TypedDocumentString<BlocksFragmentFragment, unknown>;
export const ContentPageFragmentFragmentDoc = new TypedDocumentString(`
    fragment ContentPageFragment on ContentPage {
  ...AbstractPageFragment
  contentPageTitle: title
  description
  hero {
    ...HeroFragment
  }
  usps {
    ...UspsFragment
  }
  body {
    ...BlocksFragment
  }
}
    fragment AbstractPageFragment on AbstractPage {
  __typename
  id
  name
  path
  translatedPaths {
    locale
    path
  }
  breadcrumbs {
    ...BreadcrumbFragment
  }
  seo {
    ...ContentSEOFragment
  }
}
fragment ContentSEOFragment on ContentSEO {
  __typename
  title
  description
  ogTitle
  ogDescription
  ogImage
  twitterTitle
  twitterDescription
  twitterImage
}
fragment BaseBlocksFragment on Block {
  ...IframeFragment
  ...SectionFragment
  ...TeaserRowFragment
  ...RichTextFragment
  ...TwoColumnFragment
  ...ThreeColumnFragment
  ...FourColumnFragment
  ...SectionHeaderFragment
  ...DividerFragment
  ...ImageFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...CategorySectionFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...UGCFlowboxFragment
  ...ShopSectionFragment
  ...CookieDeclarationFragment
  ...ArticleOverviewFragment
  ...VideoFragment
  ...FAQItemListFragment
  ...JafixFragment
}
fragment BlocksFragment on Block {
  ...BaseBlocksFragment
  ...CountrySpecificContainerFragment
}
fragment ArticleCardFragment on ArticleCard {
  id
  title
  location
  publishedAt
  image {
    filename
    alt
  }
  link {
    url
  }
}
fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment BreadcrumbFragment on Breadcrumb {
  name
  path
}
fragment CategoryCardFragment on Card {
  __typename
  id
  title
  category
  supportingText
  image {
    ...ImageAsset
  }
  cardLink: link {
    url
    newTab
    hash
  }
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment HeroFragment on Hero {
  __typename
  id
  title
  variant
  imagePosition
  imageStyle
  bodyText {
    ...RichTextFragment
  }
  buttons {
    ...ButtonFragment
  }
  image {
    ...ImageAsset
  }
}
fragment Price on Money {
  centAmount
  currency
}
fragment PriceTag on Money {
  centAmount
  currency
}
fragment ProductCard on Product {
  name
  slug
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  marketingRibbons {
    kind
    label
    color
  }
  promotionRibbons {
    kind
    label
    color
  }
  image {
    url
    alt
  }
  startingPrice {
    gross {
      ...PriceTag
    }
  }
  primaryVariant {
    ...ProductVariantAnalyticsFragment
    id
    sku
    availability
    price {
      net {
        ...PriceTag
      }
      gross {
        ...PriceTag
      }
    }
  }
  primaryCategory {
    ...CategoryAnalyticsFragment
  }
  variants {
    ...ProductVariantAnalyticsFragment
  }
  ...ProductAnalyticsFragment
}
fragment SectionHeaderFragment on SectionHeader {
  __typename
  id
  title
  imagePosition
  imageStyle
  bodyText {
    ...RichTextFragment
  }
  buttons {
    ...ButtonFragment
  }
  headerImage: image {
    ...ImageAsset
  }
}
fragment TeaserRowFragment on TeaserRow {
  __typename
  id
  title
  viewMoreLink {
    url
    newTab
  }
  items {
    __typename
    id
    content
    image {
      ...ImageAsset
    }
    link {
      url
    }
    title
  }
}
fragment UspsFragment on Usps {
  id
  usp1
  usp1Link {
    url
    newTab
    hash
  }
  usp2
  usp2Link {
    url
    newTab
    hash
  }
  usp3
  usp3Link {
    url
    newTab
    hash
  }
}
fragment ArticleOverviewFragment on ArticleOverview {
  __typename
  id
  articleItems: items(page: $currentPage) {
    totalPages
    results {
      ...ArticleCardFragment
    }
  }
}
fragment BlockQuoteFragment on BlockQuote {
  __typename
  id
  content
  name
  title
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment ButtonsFragment on Buttons {
  __typename
  id
  buttons {
    ...ButtonFragment
  }
}
fragment CategorySectionFragment on CategorySection {
  __typename
  id
  title
  category
  supportingText
  headerAlign
  variant
  link {
    url
    newTab
    hash
  }
  items {
    ...CategoryCardFragment
  }
}
fragment ColumnBlockFragment on ColumnBlock {
  ...DividerFragment
  ...IframeFragment
  ...ImageFragment
  ...RichTextFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...CookieDeclarationFragment
  ...VideoFragment
  ...FAQItemListFragment
}
fragment FourColumnFragment on FourColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
  column_4 {
    ...ColumnBlockFragment
  }
}
fragment ThreeColumnFragment on ThreeColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
}
fragment TwoColumnFragment on TwoColumns {
  __typename
  id
  alignment
  ratio
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
}
fragment CookieDeclarationFragment on CookieDeclaration {
  __typename
  id
}
fragment CountrySpecificContainerFragment on CountrySpecificContainer {
  __typename
  id
  countries
  countrySpecificContainerBody: body {
    ...BaseBlocksFragment
  }
}
fragment DividerFragment on Divider {
  __typename
  id
}
fragment FAQItemListFragment on FAQItemList {
  __typename
  id
  faqItems {
    ...FAQItemFragment
  }
}
fragment IframeFragment on Iframe {
  __typename
  id
  url
  height
}
fragment ImageFragment on Image {
  __typename
  id
  image {
    ...ImageAsset
  }
  aspectRatio
}
fragment JafixFragment on Jafix {
  __typename
  id
  key
}
fragment NewsletterCTAFragment on NewsletterCTA {
  __typename
  id
  orientation
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}
fragment SectionFragment on Section {
  __typename
  id
  backgroundColor
  size
  spacing
  body {
    ...TeaserRowFragment
    ...RichTextFragment
    ...TwoColumnFragment
    ...ThreeColumnFragment
    ...FourColumnFragment
    ...SectionHeaderFragment
    ...ImageFragment
    ...DividerFragment
    ...IframeFragment
    ...ButtonsFragment
    ...BlockQuoteFragment
    ...TableFragment
    ...NewsletterCTAFragment
    ...UGCFlowboxFragment
    ...CookieDeclarationFragment
    ...VideoFragment
    ...FAQItemListFragment
    ...ShopSectionFragment
    ...CategorySectionFragment
    ...JafixFragment
  }
}
fragment ShopSectionFragment on ShopSection {
  __typename
  id
  title
  subtitle
  category
  viewAllLink {
    url
    newTab
  }
  viewAllLabel
  variant
  products {
    ...ProductCard
  }
}
fragment TableCellFragment on ContentTableCell {
  value
}
fragment TableFragment on Table {
  __typename
  id
  style
  dividers
  width
  table {
    thead {
      ...TableCellFragment
    }
    tbody {
      body {
        ...TableCellFragment
      }
    }
  }
}
fragment UGCFlowboxFragment on UGCFlowbox {
  __typename
  id
  key
  tags
}
fragment VideoFragment on Video {
  __typename
  id
  video
}
fragment ProductVariantAnalyticsFragment on ProductVariant {
  name
  sku
  regularPrice {
    gross {
      ...Price
    }
  }
  attributes {
    name
    value
  }
}
fragment CategoryAnalyticsFragment on ProductCategory {
  name
  id
  ancestors {
    storyblokName
    name
  }
}
fragment ProductAnalyticsFragment on Product {
  id
  brand
  name
}`, {"fragmentName":"ContentPageFragment"}) as unknown as TypedDocumentString<ContentPageFragmentFragment, unknown>;
export const FaqGroupFragmentFragmentDoc = new TypedDocumentString(`
    fragment FAQGroupFragment on FAQGroup {
  id
  title
  slug
  icon {
    ...ImageAsset
  }
  leadText {
    ...RichTextFragment
  }
  faqItems {
    ...FAQItemFragment
  }
}
    fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}`, {"fragmentName":"FAQGroupFragment"}) as unknown as TypedDocumentString<FaqGroupFragmentFragment, unknown>;
export const FaqPageFragmentFragmentDoc = new TypedDocumentString(`
    fragment FAQPageFragment on FAQPage {
  ...AbstractPageFragment
  title
  faqGroups {
    ...FAQGroupFragment
    translatedPaths {
      locale
      path
    }
  }
}
    fragment AbstractPageFragment on AbstractPage {
  __typename
  id
  name
  path
  translatedPaths {
    locale
    path
  }
  breadcrumbs {
    ...BreadcrumbFragment
  }
  seo {
    ...ContentSEOFragment
  }
}
fragment ContentSEOFragment on ContentSEO {
  __typename
  title
  description
  ogTitle
  ogDescription
  ogImage
  twitterTitle
  twitterDescription
  twitterImage
}
fragment FAQGroupFragment on FAQGroup {
  id
  title
  slug
  icon {
    ...ImageAsset
  }
  leadText {
    ...RichTextFragment
  }
  faqItems {
    ...FAQItemFragment
  }
}
fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment BreadcrumbFragment on Breadcrumb {
  name
  path
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}`, {"fragmentName":"FAQPageFragment"}) as unknown as TypedDocumentString<FaqPageFragmentFragment, unknown>;
export const ProductListingConfigFragmentDoc = new TypedDocumentString(`
    fragment ProductListingConfig on ProductListingConfig {
  categoryId
  categoryPageId
  defaultOrder
  enabledFacets
}
    `, {"fragmentName":"ProductListingConfig"}) as unknown as TypedDocumentString<ProductListingConfigFragment, unknown>;
export const ProductListingPageFragmentFragmentDoc = new TypedDocumentString(`
    fragment ProductListingPageFragment on ProductListingPage {
  ...AbstractPageFragment
  plpTitle: title
  description
  hero {
    ...HeroFragment
  }
  afterBlocks {
    ...BlocksFragment
  }
  beforeBlocks {
    ...BlocksFragment
  }
  category {
    id
  }
  productListingConfig {
    ...ProductListingConfig
  }
}
    fragment AbstractPageFragment on AbstractPage {
  __typename
  id
  name
  path
  translatedPaths {
    locale
    path
  }
  breadcrumbs {
    ...BreadcrumbFragment
  }
  seo {
    ...ContentSEOFragment
  }
}
fragment ContentSEOFragment on ContentSEO {
  __typename
  title
  description
  ogTitle
  ogDescription
  ogImage
  twitterTitle
  twitterDescription
  twitterImage
}
fragment BaseBlocksFragment on Block {
  ...IframeFragment
  ...SectionFragment
  ...TeaserRowFragment
  ...RichTextFragment
  ...TwoColumnFragment
  ...ThreeColumnFragment
  ...FourColumnFragment
  ...SectionHeaderFragment
  ...DividerFragment
  ...ImageFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...CategorySectionFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...UGCFlowboxFragment
  ...ShopSectionFragment
  ...CookieDeclarationFragment
  ...ArticleOverviewFragment
  ...VideoFragment
  ...FAQItemListFragment
  ...JafixFragment
}
fragment BlocksFragment on Block {
  ...BaseBlocksFragment
  ...CountrySpecificContainerFragment
}
fragment ArticleCardFragment on ArticleCard {
  id
  title
  location
  publishedAt
  image {
    filename
    alt
  }
  link {
    url
  }
}
fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment BreadcrumbFragment on Breadcrumb {
  name
  path
}
fragment CategoryCardFragment on Card {
  __typename
  id
  title
  category
  supportingText
  image {
    ...ImageAsset
  }
  cardLink: link {
    url
    newTab
    hash
  }
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment HeroFragment on Hero {
  __typename
  id
  title
  variant
  imagePosition
  imageStyle
  bodyText {
    ...RichTextFragment
  }
  buttons {
    ...ButtonFragment
  }
  image {
    ...ImageAsset
  }
}
fragment Price on Money {
  centAmount
  currency
}
fragment PriceTag on Money {
  centAmount
  currency
}
fragment ProductCard on Product {
  name
  slug
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  marketingRibbons {
    kind
    label
    color
  }
  promotionRibbons {
    kind
    label
    color
  }
  image {
    url
    alt
  }
  startingPrice {
    gross {
      ...PriceTag
    }
  }
  primaryVariant {
    ...ProductVariantAnalyticsFragment
    id
    sku
    availability
    price {
      net {
        ...PriceTag
      }
      gross {
        ...PriceTag
      }
    }
  }
  primaryCategory {
    ...CategoryAnalyticsFragment
  }
  variants {
    ...ProductVariantAnalyticsFragment
  }
  ...ProductAnalyticsFragment
}
fragment ProductListingConfig on ProductListingConfig {
  categoryId
  categoryPageId
  defaultOrder
  enabledFacets
}
fragment SectionHeaderFragment on SectionHeader {
  __typename
  id
  title
  imagePosition
  imageStyle
  bodyText {
    ...RichTextFragment
  }
  buttons {
    ...ButtonFragment
  }
  headerImage: image {
    ...ImageAsset
  }
}
fragment TeaserRowFragment on TeaserRow {
  __typename
  id
  title
  viewMoreLink {
    url
    newTab
  }
  items {
    __typename
    id
    content
    image {
      ...ImageAsset
    }
    link {
      url
    }
    title
  }
}
fragment ArticleOverviewFragment on ArticleOverview {
  __typename
  id
  articleItems: items(page: $currentPage) {
    totalPages
    results {
      ...ArticleCardFragment
    }
  }
}
fragment BlockQuoteFragment on BlockQuote {
  __typename
  id
  content
  name
  title
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment ButtonsFragment on Buttons {
  __typename
  id
  buttons {
    ...ButtonFragment
  }
}
fragment CategorySectionFragment on CategorySection {
  __typename
  id
  title
  category
  supportingText
  headerAlign
  variant
  link {
    url
    newTab
    hash
  }
  items {
    ...CategoryCardFragment
  }
}
fragment ColumnBlockFragment on ColumnBlock {
  ...DividerFragment
  ...IframeFragment
  ...ImageFragment
  ...RichTextFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...CookieDeclarationFragment
  ...VideoFragment
  ...FAQItemListFragment
}
fragment FourColumnFragment on FourColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
  column_4 {
    ...ColumnBlockFragment
  }
}
fragment ThreeColumnFragment on ThreeColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
}
fragment TwoColumnFragment on TwoColumns {
  __typename
  id
  alignment
  ratio
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
}
fragment CookieDeclarationFragment on CookieDeclaration {
  __typename
  id
}
fragment CountrySpecificContainerFragment on CountrySpecificContainer {
  __typename
  id
  countries
  countrySpecificContainerBody: body {
    ...BaseBlocksFragment
  }
}
fragment DividerFragment on Divider {
  __typename
  id
}
fragment FAQItemListFragment on FAQItemList {
  __typename
  id
  faqItems {
    ...FAQItemFragment
  }
}
fragment IframeFragment on Iframe {
  __typename
  id
  url
  height
}
fragment ImageFragment on Image {
  __typename
  id
  image {
    ...ImageAsset
  }
  aspectRatio
}
fragment JafixFragment on Jafix {
  __typename
  id
  key
}
fragment NewsletterCTAFragment on NewsletterCTA {
  __typename
  id
  orientation
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}
fragment SectionFragment on Section {
  __typename
  id
  backgroundColor
  size
  spacing
  body {
    ...TeaserRowFragment
    ...RichTextFragment
    ...TwoColumnFragment
    ...ThreeColumnFragment
    ...FourColumnFragment
    ...SectionHeaderFragment
    ...ImageFragment
    ...DividerFragment
    ...IframeFragment
    ...ButtonsFragment
    ...BlockQuoteFragment
    ...TableFragment
    ...NewsletterCTAFragment
    ...UGCFlowboxFragment
    ...CookieDeclarationFragment
    ...VideoFragment
    ...FAQItemListFragment
    ...ShopSectionFragment
    ...CategorySectionFragment
    ...JafixFragment
  }
}
fragment ShopSectionFragment on ShopSection {
  __typename
  id
  title
  subtitle
  category
  viewAllLink {
    url
    newTab
  }
  viewAllLabel
  variant
  products {
    ...ProductCard
  }
}
fragment TableCellFragment on ContentTableCell {
  value
}
fragment TableFragment on Table {
  __typename
  id
  style
  dividers
  width
  table {
    thead {
      ...TableCellFragment
    }
    tbody {
      body {
        ...TableCellFragment
      }
    }
  }
}
fragment UGCFlowboxFragment on UGCFlowbox {
  __typename
  id
  key
  tags
}
fragment VideoFragment on Video {
  __typename
  id
  video
}
fragment ProductVariantAnalyticsFragment on ProductVariant {
  name
  sku
  regularPrice {
    gross {
      ...Price
    }
  }
  attributes {
    name
    value
  }
}
fragment CategoryAnalyticsFragment on ProductCategory {
  name
  id
  ancestors {
    storyblokName
    name
  }
}
fragment ProductAnalyticsFragment on Product {
  id
  brand
  name
}`, {"fragmentName":"ProductListingPageFragment"}) as unknown as TypedDocumentString<ProductListingPageFragmentFragment, unknown>;
export const ArticlePageFragmentFragmentDoc = new TypedDocumentString(`
    fragment ArticlePageFragment on ArticlePage {
  ...AbstractPageFragment
  title
  image {
    filename
    alt
  }
  location
  publishedAt
  body {
    ...TwoColumnFragment
    ...ThreeColumnFragment
    ...FourColumnFragment
    ...BlockQuoteFragment
    ...ButtonsFragment
    ...ImageFragment
    ...RichTextFragment
    ...TableFragment
    ...VideoFragment
    ...FAQItemListFragment
  }
}
    fragment AbstractPageFragment on AbstractPage {
  __typename
  id
  name
  path
  translatedPaths {
    locale
    path
  }
  breadcrumbs {
    ...BreadcrumbFragment
  }
  seo {
    ...ContentSEOFragment
  }
}
fragment ContentSEOFragment on ContentSEO {
  __typename
  title
  description
  ogTitle
  ogDescription
  ogImage
  twitterTitle
  twitterDescription
  twitterImage
}
fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment BreadcrumbFragment on Breadcrumb {
  name
  path
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment BlockQuoteFragment on BlockQuote {
  __typename
  id
  content
  name
  title
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment ButtonsFragment on Buttons {
  __typename
  id
  buttons {
    ...ButtonFragment
  }
}
fragment ColumnBlockFragment on ColumnBlock {
  ...DividerFragment
  ...IframeFragment
  ...ImageFragment
  ...RichTextFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...CookieDeclarationFragment
  ...VideoFragment
  ...FAQItemListFragment
}
fragment FourColumnFragment on FourColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
  column_4 {
    ...ColumnBlockFragment
  }
}
fragment ThreeColumnFragment on ThreeColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
}
fragment TwoColumnFragment on TwoColumns {
  __typename
  id
  alignment
  ratio
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
}
fragment CookieDeclarationFragment on CookieDeclaration {
  __typename
  id
}
fragment DividerFragment on Divider {
  __typename
  id
}
fragment FAQItemListFragment on FAQItemList {
  __typename
  id
  faqItems {
    ...FAQItemFragment
  }
}
fragment IframeFragment on Iframe {
  __typename
  id
  url
  height
}
fragment ImageFragment on Image {
  __typename
  id
  image {
    ...ImageAsset
  }
  aspectRatio
}
fragment NewsletterCTAFragment on NewsletterCTA {
  __typename
  id
  orientation
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}
fragment TableCellFragment on ContentTableCell {
  value
}
fragment TableFragment on Table {
  __typename
  id
  style
  dividers
  width
  table {
    thead {
      ...TableCellFragment
    }
    tbody {
      body {
        ...TableCellFragment
      }
    }
  }
}
fragment VideoFragment on Video {
  __typename
  id
  video
}`, {"fragmentName":"ArticlePageFragment"}) as unknown as TypedDocumentString<ArticlePageFragmentFragment, unknown>;
export const ProductVariantFragmentFragmentDoc = new TypedDocumentString(`
    fragment ProductVariantFragment on ProductVariant {
  id
  name
  sku
  availability
  images {
    url
    alt
  }
  deliveryTime
  description
  attributes {
    name
    label
    value
  }
  orderConfiguration {
    min
    max
    hasMax
    stepSize
  }
}
    `, {"fragmentName":"ProductVariantFragment"}) as unknown as TypedDocumentString<ProductVariantFragmentFragment, unknown>;
export const ProductBuySectionFragmentFragmentDoc = new TypedDocumentString(`
    fragment ProductBuySectionFragment on ProductVariant {
  sku
  availability
  availabilityQuantity
  price {
    gross {
      ...Price
    }
  }
  regularPrice {
    gross {
      ...Price
    }
  }
}
    fragment Price on Money {
  centAmount
  currency
}`, {"fragmentName":"ProductBuySectionFragment"}) as unknown as TypedDocumentString<ProductBuySectionFragmentFragment, unknown>;
export const ProductDetailPageFragmentFragmentDoc = new TypedDocumentString(`
    fragment ProductDetailPageFragment on Product {
  meta {
    title
    description
  }
  usps {
    ...UspsFragment
  }
  name
  slug
  availability
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  brand
  marketingRibbons {
    kind
    label
    color
  }
  promotionRibbons {
    kind
    label
    color
  }
  primaryVariant {
    sku
    images {
      url
      alt
    }
    orderConfiguration {
      min
      max
      hasMax
      stepSize
    }
    ...ProductVariantAnalyticsFragment
  }
  primaryCategory {
    id
    name
    slug
    ancestors {
      storyblokName
      name
      id
    }
  }
  variants {
    ...ProductVariantAnalyticsFragment
    ...ProductVariantFragment
    ...ProductBuySectionFragment
  }
  relatedProducts {
    id
    slug
    availability
    image {
      url
      alt
    }
    primaryVariant {
      sku
    }
    variants {
      availability
      price {
        gross {
          centAmount
        }
      }
    }
    startingPrice {
      gross {
        ...Price
      }
    }
  }
  startingPrice {
    gross {
      ...Price
    }
  }
  instructions {
    key
    label
  }
  materials {
    base
    outside
    filling
    lining
  }
  reviews {
    amount
    averageRating
    lowestRating
    highestRating
  }
  sizeGuide {
    ...TableFragment
    ...ImageFragment
    ...RichTextFragment
    ...CountrySpecificContainerFragment
  }
  breadcrumbs {
    ...BreadcrumbFragment
  }
  ...ProductAnalyticsFragment
}
    fragment BaseBlocksFragment on Block {
  ...IframeFragment
  ...SectionFragment
  ...TeaserRowFragment
  ...RichTextFragment
  ...TwoColumnFragment
  ...ThreeColumnFragment
  ...FourColumnFragment
  ...SectionHeaderFragment
  ...DividerFragment
  ...ImageFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...CategorySectionFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...UGCFlowboxFragment
  ...ShopSectionFragment
  ...CookieDeclarationFragment
  ...ArticleOverviewFragment
  ...VideoFragment
  ...FAQItemListFragment
  ...JafixFragment
}
fragment ProductBuySectionFragment on ProductVariant {
  sku
  availability
  availabilityQuantity
  price {
    gross {
      ...Price
    }
  }
  regularPrice {
    gross {
      ...Price
    }
  }
}
fragment ProductVariantFragment on ProductVariant {
  id
  name
  sku
  availability
  images {
    url
    alt
  }
  deliveryTime
  description
  attributes {
    name
    label
    value
  }
  orderConfiguration {
    min
    max
    hasMax
    stepSize
  }
}
fragment ArticleCardFragment on ArticleCard {
  id
  title
  location
  publishedAt
  image {
    filename
    alt
  }
  link {
    url
  }
}
fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment BreadcrumbFragment on Breadcrumb {
  name
  path
}
fragment CategoryCardFragment on Card {
  __typename
  id
  title
  category
  supportingText
  image {
    ...ImageAsset
  }
  cardLink: link {
    url
    newTab
    hash
  }
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment Price on Money {
  centAmount
  currency
}
fragment PriceTag on Money {
  centAmount
  currency
}
fragment ProductCard on Product {
  name
  slug
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  marketingRibbons {
    kind
    label
    color
  }
  promotionRibbons {
    kind
    label
    color
  }
  image {
    url
    alt
  }
  startingPrice {
    gross {
      ...PriceTag
    }
  }
  primaryVariant {
    ...ProductVariantAnalyticsFragment
    id
    sku
    availability
    price {
      net {
        ...PriceTag
      }
      gross {
        ...PriceTag
      }
    }
  }
  primaryCategory {
    ...CategoryAnalyticsFragment
  }
  variants {
    ...ProductVariantAnalyticsFragment
  }
  ...ProductAnalyticsFragment
}
fragment SectionHeaderFragment on SectionHeader {
  __typename
  id
  title
  imagePosition
  imageStyle
  bodyText {
    ...RichTextFragment
  }
  buttons {
    ...ButtonFragment
  }
  headerImage: image {
    ...ImageAsset
  }
}
fragment TeaserRowFragment on TeaserRow {
  __typename
  id
  title
  viewMoreLink {
    url
    newTab
  }
  items {
    __typename
    id
    content
    image {
      ...ImageAsset
    }
    link {
      url
    }
    title
  }
}
fragment UspsFragment on Usps {
  id
  usp1
  usp1Link {
    url
    newTab
    hash
  }
  usp2
  usp2Link {
    url
    newTab
    hash
  }
  usp3
  usp3Link {
    url
    newTab
    hash
  }
}
fragment ArticleOverviewFragment on ArticleOverview {
  __typename
  id
  articleItems: items(page: $currentPage) {
    totalPages
    results {
      ...ArticleCardFragment
    }
  }
}
fragment BlockQuoteFragment on BlockQuote {
  __typename
  id
  content
  name
  title
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment ButtonsFragment on Buttons {
  __typename
  id
  buttons {
    ...ButtonFragment
  }
}
fragment CategorySectionFragment on CategorySection {
  __typename
  id
  title
  category
  supportingText
  headerAlign
  variant
  link {
    url
    newTab
    hash
  }
  items {
    ...CategoryCardFragment
  }
}
fragment ColumnBlockFragment on ColumnBlock {
  ...DividerFragment
  ...IframeFragment
  ...ImageFragment
  ...RichTextFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...CookieDeclarationFragment
  ...VideoFragment
  ...FAQItemListFragment
}
fragment FourColumnFragment on FourColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
  column_4 {
    ...ColumnBlockFragment
  }
}
fragment ThreeColumnFragment on ThreeColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
}
fragment TwoColumnFragment on TwoColumns {
  __typename
  id
  alignment
  ratio
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
}
fragment CookieDeclarationFragment on CookieDeclaration {
  __typename
  id
}
fragment CountrySpecificContainerFragment on CountrySpecificContainer {
  __typename
  id
  countries
  countrySpecificContainerBody: body {
    ...BaseBlocksFragment
  }
}
fragment DividerFragment on Divider {
  __typename
  id
}
fragment FAQItemListFragment on FAQItemList {
  __typename
  id
  faqItems {
    ...FAQItemFragment
  }
}
fragment IframeFragment on Iframe {
  __typename
  id
  url
  height
}
fragment ImageFragment on Image {
  __typename
  id
  image {
    ...ImageAsset
  }
  aspectRatio
}
fragment JafixFragment on Jafix {
  __typename
  id
  key
}
fragment NewsletterCTAFragment on NewsletterCTA {
  __typename
  id
  orientation
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}
fragment SectionFragment on Section {
  __typename
  id
  backgroundColor
  size
  spacing
  body {
    ...TeaserRowFragment
    ...RichTextFragment
    ...TwoColumnFragment
    ...ThreeColumnFragment
    ...FourColumnFragment
    ...SectionHeaderFragment
    ...ImageFragment
    ...DividerFragment
    ...IframeFragment
    ...ButtonsFragment
    ...BlockQuoteFragment
    ...TableFragment
    ...NewsletterCTAFragment
    ...UGCFlowboxFragment
    ...CookieDeclarationFragment
    ...VideoFragment
    ...FAQItemListFragment
    ...ShopSectionFragment
    ...CategorySectionFragment
    ...JafixFragment
  }
}
fragment ShopSectionFragment on ShopSection {
  __typename
  id
  title
  subtitle
  category
  viewAllLink {
    url
    newTab
  }
  viewAllLabel
  variant
  products {
    ...ProductCard
  }
}
fragment TableCellFragment on ContentTableCell {
  value
}
fragment TableFragment on Table {
  __typename
  id
  style
  dividers
  width
  table {
    thead {
      ...TableCellFragment
    }
    tbody {
      body {
        ...TableCellFragment
      }
    }
  }
}
fragment UGCFlowboxFragment on UGCFlowbox {
  __typename
  id
  key
  tags
}
fragment VideoFragment on Video {
  __typename
  id
  video
}
fragment ProductVariantAnalyticsFragment on ProductVariant {
  name
  sku
  regularPrice {
    gross {
      ...Price
    }
  }
  attributes {
    name
    value
  }
}
fragment CategoryAnalyticsFragment on ProductCategory {
  name
  id
  ancestors {
    storyblokName
    name
  }
}
fragment ProductAnalyticsFragment on Product {
  id
  brand
  name
}`, {"fragmentName":"ProductDetailPageFragment"}) as unknown as TypedDocumentString<ProductDetailPageFragmentFragment, unknown>;
export const StoreFragmentFragmentDoc = new TypedDocumentString(`
    fragment StoreFragment on Store {
  slug
  address {
    addressLine
    city
    district
    phone
    zipcode
    streetNumber
    countryId
  }
  name
  slug
  storeCode
  openingHours {
    fridayclose1
    fridayclose2
    fridayopen1
    fridayopen2
    mondayclose1
    mondayclose2
    mondayopen1
    mondayopen2
    saturdayclose1
    saturdayclose2
    saturdayopen1
    saturdayopen2
    sundayclose1
    sundayclose2
    sundayopen1
    sundayopen2
    thursdayclose1
    thursdayclose2
    thursdayopen1
    thursdayopen2
    tuesdayclose1
    tuesdayclose2
    tuesdayopen1
    tuesdayopen2
    wednesdayclose1
    wednesdayclose2
    wednesdayopen1
    wednesdayopen2
  }
  coordinates {
    lat
    lng
  }
  nearbyStores {
    name
    slug
    address {
      addressLine
      city
      streetNumber
      phone
      zipcode
    }
    distanceInMeters
    objectID
    storeCode
  }
}
    `, {"fragmentName":"StoreFragment"}) as unknown as TypedDocumentString<StoreFragmentFragment, unknown>;
export const PaazlConfigFragmentFragmentDoc = new TypedDocumentString(`
    fragment PaazlConfigFragment on PaazlCheckoutConfig {
  configObject
}
    `, {"fragmentName":"PaazlConfigFragment"}) as unknown as TypedDocumentString<PaazlConfigFragmentFragment, unknown>;
export const AddressFragmentFragmentDoc = new TypedDocumentString(`
    fragment AddressFragment on Address {
  id
  email
  firstName
  lastName
  streetName
  houseNumber
  houseNumberSuffix
  postalCode
  city
  phone
  country
  company
  vatNumber
}
    `, {"fragmentName":"AddressFragment"}) as unknown as TypedDocumentString<AddressFragmentFragment, unknown>;
export const PaymentMethodFragmentDoc = new TypedDocumentString(`
    fragment PaymentMethod on PaymentMethod {
  id
  name
  provider
  issuers {
    id
    name
  }
}
    `, {"fragmentName":"PaymentMethod"}) as unknown as TypedDocumentString<PaymentMethodFragment, unknown>;
export const OrderDetailFragmentDoc = new TypedDocumentString(`
    fragment OrderDetail on Order {
  customerEmail
  orderNumber
  shippingAddress {
    firstName
    lastName
    streetName
    houseNumber
    houseNumberSuffix
    postalCode
    city
    phone
  }
  shippingCosts {
    ...Price
  }
  estimatedMaxDeliveryDays
  lineItems {
    id
    quantity
    productId
    productSlug
    productName
    category {
      ancestors {
        storyblokName
        name
      }
    }
    price {
      gross {
        ...Price
      }
    }
    variant {
      name
      size
      color
      sku
      primaryImage {
        url
        alt
      }
    }
  }
  currency
  total {
    gross {
      ...Price
    }
  }
  selectedPaymentMethod {
    ...PaymentMethod
  }
  shippingMethod
  shippingOption
}
    fragment PaymentMethod on PaymentMethod {
  id
  name
  provider
  issuers {
    id
    name
  }
}
fragment Price on Money {
  centAmount
  currency
}`, {"fragmentName":"OrderDetail"}) as unknown as TypedDocumentString<OrderDetailFragment, unknown>;
export const FailedOrderDetailFragmentDoc = new TypedDocumentString(`
    fragment FailedOrderDetail on Order {
  ...OrderDetail
  lineItems {
    id
    quantity
    productId
    productSlug
    productName
    addedAt
    category {
      ancestors {
        storyblokName
        name
      }
    }
    price {
      gross {
        ...Price
      }
    }
    variant {
      name
      sku
      primaryImage {
        url
        alt
      }
    }
  }
  subTotal {
    gross {
      ...Price
    }
  }
  total {
    gross {
      ...Price
    }
  }
  shippingCosts {
    ...Price
  }
  selectedPaymentMethod {
    ...PaymentMethod
  }
  shippingOption
  paymentStatus
}
    fragment OrderDetail on Order {
  customerEmail
  orderNumber
  shippingAddress {
    firstName
    lastName
    streetName
    houseNumber
    houseNumberSuffix
    postalCode
    city
    phone
  }
  shippingCosts {
    ...Price
  }
  estimatedMaxDeliveryDays
  lineItems {
    id
    quantity
    productId
    productSlug
    productName
    category {
      ancestors {
        storyblokName
        name
      }
    }
    price {
      gross {
        ...Price
      }
    }
    variant {
      name
      size
      color
      sku
      primaryImage {
        url
        alt
      }
    }
  }
  currency
  total {
    gross {
      ...Price
    }
  }
  selectedPaymentMethod {
    ...PaymentMethod
  }
  shippingMethod
  shippingOption
}
fragment PaymentMethod on PaymentMethod {
  id
  name
  provider
  issuers {
    id
    name
  }
}
fragment Price on Money {
  centAmount
  currency
}`, {"fragmentName":"FailedOrderDetail"}) as unknown as TypedDocumentString<FailedOrderDetailFragment, unknown>;
export const LineItemSummaryFragmentFragmentDoc = new TypedDocumentString(`
    fragment LineItemSummaryFragment on LineItem {
  id
  quantity
  productName
  variant {
    name
    color
    size
    primaryImage {
      url
      alt
    }
  }
}
    `, {"fragmentName":"LineItemSummaryFragment"}) as unknown as TypedDocumentString<LineItemSummaryFragmentFragment, unknown>;
export const RangeFacetFragmentFragmentDoc = new TypedDocumentString(`
    fragment RangeFacetFragment on RangeFacet {
  __typename
  key
  label
  min
  max
  selectedMin
  selectedMax
}
    `, {"fragmentName":"RangeFacetFragment"}) as unknown as TypedDocumentString<RangeFacetFragmentFragment, unknown>;
export const FacetValueFragmentFragmentDoc = new TypedDocumentString(`
    fragment FacetValueFragment on FacetValue {
  key
  label
  count
}
    `, {"fragmentName":"FacetValueFragment"}) as unknown as TypedDocumentString<FacetValueFragmentFragment, unknown>;
export const OptionsFacetFragmentFragmentDoc = new TypedDocumentString(`
    fragment OptionsFacetFragment on OptionsFacet {
  __typename
  key
  label
  options {
    ...FacetValueFragment
  }
}
    fragment FacetValueFragment on FacetValue {
  key
  label
  count
}`, {"fragmentName":"OptionsFacetFragment"}) as unknown as TypedDocumentString<OptionsFacetFragmentFragment, unknown>;
export const ToggleFacetFragmentFragmentDoc = new TypedDocumentString(`
    fragment ToggleFacetFragment on ToggleFacet {
  __typename
  key
  label
  options {
    ...FacetValueFragment
  }
}
    fragment FacetValueFragment on FacetValue {
  key
  label
  count
}`, {"fragmentName":"ToggleFacetFragment"}) as unknown as TypedDocumentString<ToggleFacetFragmentFragment, unknown>;
export const FacetFragmentFragmentDoc = new TypedDocumentString(`
    fragment FacetFragment on Facet {
  ...RangeFacetFragment
  ...OptionsFacetFragment
  ...ToggleFacetFragment
}
    fragment FacetValueFragment on FacetValue {
  key
  label
  count
}
fragment RangeFacetFragment on RangeFacet {
  __typename
  key
  label
  min
  max
  selectedMin
  selectedMax
}
fragment OptionsFacetFragment on OptionsFacet {
  __typename
  key
  label
  options {
    ...FacetValueFragment
  }
}
fragment ToggleFacetFragment on ToggleFacet {
  __typename
  key
  label
  options {
    ...FacetValueFragment
  }
}`, {"fragmentName":"FacetFragment"}) as unknown as TypedDocumentString<FacetFragmentFragment, unknown>;
export const ProductSearchResultsFragmentDoc = new TypedDocumentString(`
    fragment ProductSearchResults on ProductSearchResults {
  total
  totalPages
  queryID
  results {
    ...ProductCard
  }
  facets {
    ...FacetFragment
  }
}
    fragment FacetValueFragment on FacetValue {
  key
  label
  count
}
fragment RangeFacetFragment on RangeFacet {
  __typename
  key
  label
  min
  max
  selectedMin
  selectedMax
}
fragment OptionsFacetFragment on OptionsFacet {
  __typename
  key
  label
  options {
    ...FacetValueFragment
  }
}
fragment ToggleFacetFragment on ToggleFacet {
  __typename
  key
  label
  options {
    ...FacetValueFragment
  }
}
fragment FacetFragment on Facet {
  ...RangeFacetFragment
  ...OptionsFacetFragment
  ...ToggleFacetFragment
}
fragment Price on Money {
  centAmount
  currency
}
fragment PriceTag on Money {
  centAmount
  currency
}
fragment ProductCard on Product {
  name
  slug
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  marketingRibbons {
    kind
    label
    color
  }
  promotionRibbons {
    kind
    label
    color
  }
  image {
    url
    alt
  }
  startingPrice {
    gross {
      ...PriceTag
    }
  }
  primaryVariant {
    ...ProductVariantAnalyticsFragment
    id
    sku
    availability
    price {
      net {
        ...PriceTag
      }
      gross {
        ...PriceTag
      }
    }
  }
  primaryCategory {
    ...CategoryAnalyticsFragment
  }
  variants {
    ...ProductVariantAnalyticsFragment
  }
  ...ProductAnalyticsFragment
}
fragment ProductVariantAnalyticsFragment on ProductVariant {
  name
  sku
  regularPrice {
    gross {
      ...Price
    }
  }
  attributes {
    name
    value
  }
}
fragment CategoryAnalyticsFragment on ProductCategory {
  name
  id
  ancestors {
    storyblokName
    name
  }
}
fragment ProductAnalyticsFragment on Product {
  id
  brand
  name
}`, {"fragmentName":"ProductSearchResults"}) as unknown as TypedDocumentString<ProductSearchResultsFragment, unknown>;
export const CartSummaryFragmentFragmentDoc = new TypedDocumentString(`
    fragment CartSummaryFragment on Cart {
  subTotal {
    ...Price
  }
  discount {
    amount {
      ...Price
    }
  }
  total {
    ...Price
  }
  subTotalBeforeDiscount {
    ...Price
  }
  shippingCosts {
    ...Price
  }
}
    fragment Price on Money {
  centAmount
  currency
}`, {"fragmentName":"CartSummaryFragment"}) as unknown as TypedDocumentString<CartSummaryFragmentFragment, unknown>;
export const LineItemFragmentDoc = new TypedDocumentString(`
    fragment LineItem on LineItem {
  id
  quantity
  productId
  productSlug
  productName
  addedAt
  availableStock
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  category {
    ancestors {
      storyblokName
      name
    }
  }
  regularPrice {
    gross {
      ...Price
    }
  }
  price {
    gross {
      ...Price
    }
    tax {
      value {
        ...Price
      }
      rate
    }
  }
  discounts {
    code
    value {
      centAmount
      currency
    }
    description
  }
  variant {
    name
    descriptionShort
    sku
    size
    color
    primaryImage {
      url
      alt
    }
    orderConfiguration {
      min
      max
      stepSize
    }
  }
}
    fragment Price on Money {
  centAmount
  currency
}`, {"fragmentName":"LineItem"}) as unknown as TypedDocumentString<LineItemFragment, unknown>;
export const CheckoutSummaryFragmentFragmentDoc = new TypedDocumentString(`
    fragment CheckoutSummaryFragment on Cart {
  ...CartSummaryFragment
  lineItems {
    ...LineItem
    id
    quantity
    productSlug
    productName
    addedAt
    variant {
      name
      sku
      primaryImage {
        url
        alt
      }
    }
  }
}
    fragment CartSummaryFragment on Cart {
  subTotal {
    ...Price
  }
  discount {
    amount {
      ...Price
    }
  }
  total {
    ...Price
  }
  subTotalBeforeDiscount {
    ...Price
  }
  shippingCosts {
    ...Price
  }
}
fragment Price on Money {
  centAmount
  currency
}
fragment LineItem on LineItem {
  id
  quantity
  productId
  productSlug
  productName
  addedAt
  availableStock
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  category {
    ancestors {
      storyblokName
      name
    }
  }
  regularPrice {
    gross {
      ...Price
    }
  }
  price {
    gross {
      ...Price
    }
    tax {
      value {
        ...Price
      }
      rate
    }
  }
  discounts {
    code
    value {
      centAmount
      currency
    }
    description
  }
  variant {
    name
    descriptionShort
    sku
    size
    color
    primaryImage {
      url
      alt
    }
    orderConfiguration {
      min
      max
      stepSize
    }
  }
}`, {"fragmentName":"CheckoutSummaryFragment"}) as unknown as TypedDocumentString<CheckoutSummaryFragmentFragment, unknown>;
export const CartFragmentDoc = new TypedDocumentString(`
    fragment Cart on Cart {
  ...CheckoutSummaryFragment
  id {
    id
    version
  }
  lineItems {
    ...LineItem
  }
  subTotal {
    ...Price
  }
  discount {
    amount {
      ...Price
    }
  }
  total {
    ...Price
  }
  subTotalBeforeDiscount {
    ...Price
  }
  shippingCosts {
    ...Price
  }
  shippingOption
}
    fragment CheckoutSummaryFragment on Cart {
  ...CartSummaryFragment
  lineItems {
    ...LineItem
    id
    quantity
    productSlug
    productName
    addedAt
    variant {
      name
      sku
      primaryImage {
        url
        alt
      }
    }
  }
}
fragment CartSummaryFragment on Cart {
  subTotal {
    ...Price
  }
  discount {
    amount {
      ...Price
    }
  }
  total {
    ...Price
  }
  subTotalBeforeDiscount {
    ...Price
  }
  shippingCosts {
    ...Price
  }
}
fragment Price on Money {
  centAmount
  currency
}
fragment LineItem on LineItem {
  id
  quantity
  productId
  productSlug
  productName
  addedAt
  availableStock
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  category {
    ancestors {
      storyblokName
      name
    }
  }
  regularPrice {
    gross {
      ...Price
    }
  }
  price {
    gross {
      ...Price
    }
    tax {
      value {
        ...Price
      }
      rate
    }
  }
  discounts {
    code
    value {
      centAmount
      currency
    }
    description
  }
  variant {
    name
    descriptionShort
    sku
    size
    color
    primaryImage {
      url
      alt
    }
    orderConfiguration {
      min
      max
      stepSize
    }
  }
}`, {"fragmentName":"Cart"}) as unknown as TypedDocumentString<CartFragment, unknown>;
export const AddressFragmentDoc = new TypedDocumentString(`
    fragment Address on Address {
  id
  email
  salutation
  firstName
  lastName
  streetName
  houseNumber
  houseNumberSuffix
  postalCode
  city
  phone
  country
  company
}
    `, {"fragmentName":"Address"}) as unknown as TypedDocumentString<AddressFragment, unknown>;
export const CustomerFragmentDoc = new TypedDocumentString(`
    fragment Customer on Customer {
  firstName
  lastName
  accountType
  company
  email
  vatNumber
  billingAddress {
    ...Address
  }
  shippingAddress {
    ...Address
  }
  addresses {
    ...Address
  }
}
    fragment Address on Address {
  id
  email
  salutation
  firstName
  lastName
  streetName
  houseNumber
  houseNumberSuffix
  postalCode
  city
  phone
  country
  company
}`, {"fragmentName":"Customer"}) as unknown as TypedDocumentString<CustomerFragment, unknown>;
export const AddressValidationResultFragmentDoc = new TypedDocumentString(`
    fragment AddressValidationResult on AddressValidationResult {
  valid
  suggestions {
    city
    country
    houseNumber
    houseNumberSuffix
    postalCode
    streetName
  }
}
    `, {"fragmentName":"AddressValidationResult"}) as unknown as TypedDocumentString<AddressValidationResultFragment, unknown>;
export const CombinedProductAnalyticsFragmentFragmentDoc = new TypedDocumentString(`
    fragment CombinedProductAnalyticsFragment on Product {
  ...ProductAnalyticsFragment
  primaryCategory {
    ...CategoryAnalyticsFragment
  }
  primaryVariant {
    ...ProductVariantAnalyticsFragment
  }
  variants {
    ...ProductVariantAnalyticsFragment
  }
}
    fragment Price on Money {
  centAmount
  currency
}
fragment ProductVariantAnalyticsFragment on ProductVariant {
  name
  sku
  regularPrice {
    gross {
      ...Price
    }
  }
  attributes {
    name
    value
  }
}
fragment CategoryAnalyticsFragment on ProductCategory {
  name
  id
  ancestors {
    storyblokName
    name
  }
}
fragment ProductAnalyticsFragment on Product {
  id
  brand
  name
}`, {"fragmentName":"CombinedProductAnalyticsFragment"}) as unknown as TypedDocumentString<CombinedProductAnalyticsFragmentFragment, unknown>;
export const StoreContentPreviewDataDocument = new TypedDocumentString(`
    mutation StoreContentPreviewData($path: String!, $data: String!) {
  storeContentPreview(data: $data, path: $path) {
    id
  }
}
    `) as unknown as TypedDocumentString<StoreContentPreviewDataMutation, StoreContentPreviewDataMutationVariables>;
export const NewsletterSignUpDocument = new TypedDocumentString(`
    mutation NewsletterSignUp($storeContext: StoreContextInput!, $email: String!) {
  newsletterSignUp(storeContext: $storeContext, email: $email)
}
    `) as unknown as TypedDocumentString<NewsletterSignUpMutation, NewsletterSignUpMutationVariables>;
export const GetCompanyReviewDocument = new TypedDocumentString(`
    query GetCompanyReview($storeContext: StoreContextInput!) {
  companyReview(storeContext: $storeContext) {
    amount
    totalAmount
    averageRating
  }
}
    `) as unknown as TypedDocumentString<GetCompanyReviewQuery, GetCompanyReviewQueryVariables>;
export const GetSiteDocument = new TypedDocumentString(`
    query GetSite($storeContext: StoreContextInput!, $version: ContentVersion!, $previewID: String) {
  site(storeContext: $storeContext, version: $version, previewID: $previewID) {
    ...Site
  }
}
    fragment FooterNewsletterFragment on Site {
  showNewsletterCTA
  newsletterCTATitle
  newsletterCTABody
}
fragment Site on Site {
  __typename
  id
  logo {
    ...ImageAsset
  }
  organizationAddress {
    postalCode
    locality
    country
    street
  }
  footerLogo {
    ...ImageAsset
  }
  mainMenu {
    ...MainMenu
    ...MenuLink
  }
  footerMenu {
    ...MenuBlock
  }
  paymentMethods {
    ...ImageAsset
  }
  customerServiceEmail
  customerServiceHours
  customerServicePhone
  faqItems {
    ...FAQItemFragment
  }
  trustMarks {
    ...ImageAsset
  }
  carriers {
    ...ImageAsset
  }
  paymentTerms {
    ...RichTextFragment
  }
  socialsHeading
  facebook {
    url
  }
  instagram {
    url
  }
  linkedIn {
    url
  }
  youtube {
    url
  }
  tiktok {
    url
  }
  pinterest {
    url
  }
  businessLabel
  businessPage {
    url
    newTab
  }
  serviceLabel
  servicePage {
    url
    newTab
  }
  disclaimerLabel
  disclaimerPage {
    url
    newTab
  }
  termsLabel
  termsPage {
    url
    newTab
  }
  cookiesLabel
  cookiesPage {
    url
    newTab
  }
  privacyLabel
  privacyPage {
    url
    newTab
  }
  usps {
    ...UspsFragment
  }
  notificationBanners {
    ...NotificationBanner
  }
  ...FooterNewsletterFragment
}
fragment MainMenu on MenuItem {
  ...MenuItemFields
  subMenuItems {
    ...MenuItemFields
    ...MenuLink
    ... on MenuItem {
      subMenuItems {
        ...MenuItemFields
        ...MenuLink
      }
    }
  }
}
fragment MenuItemFields on MenuItem {
  __typename
  id
  label
  optionalLink: link {
    url
  }
}
fragment MenuLink on MenuLink {
  __typename
  id
  label
  link {
    url
    newTab
  }
}
fragment MenuBlock on MenuBlock {
  __typename
  id
  label
  menuLinks {
    ...MenuLink
  }
}
fragment NotificationBanner on NotificationBanner {
  __typename
  id
  text
  linkLabel
  optionalLink: link {
    url
  }
}
fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment UspsFragment on Usps {
  id
  usp1
  usp1Link {
    url
    newTab
    hash
  }
  usp2
  usp2Link {
    url
    newTab
    hash
  }
  usp3
  usp3Link {
    url
    newTab
    hash
  }
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}`) as unknown as TypedDocumentString<GetSiteQuery, GetSiteQueryVariables>;
export const CustomerPasswordResetDocument = new TypedDocumentString(`
    mutation CustomerPasswordReset($storeContext: StoreContextInput!, $password: String!, $token: String!) {
  customerPasswordReset(
    storeContext: $storeContext
    password: $password
    token: $token
  ) {
    ...Customer
  }
}
    fragment Address on Address {
  id
  email
  salutation
  firstName
  lastName
  streetName
  houseNumber
  houseNumberSuffix
  postalCode
  city
  phone
  country
  company
}
fragment Customer on Customer {
  firstName
  lastName
  accountType
  company
  email
  vatNumber
  billingAddress {
    ...Address
  }
  shippingAddress {
    ...Address
  }
  addresses {
    ...Address
  }
}`) as unknown as TypedDocumentString<CustomerPasswordResetMutation, CustomerPasswordResetMutationVariables>;
export const CustomerPasswordResetRequestDocument = new TypedDocumentString(`
    mutation CustomerPasswordResetRequest($storeContext: StoreContextInput!, $email: String!) {
  customerPasswordResetRequest(storeContext: $storeContext, email: $email)
}
    `) as unknown as TypedDocumentString<CustomerPasswordResetRequestMutation, CustomerPasswordResetRequestMutationVariables>;
export const CustomerCreateDocument = new TypedDocumentString(`
    mutation CustomerCreate($storeContext: StoreContextInput!, $customer: CustomerCreateInput!) {
  customerCreate(storeContext: $storeContext, customer: $customer) {
    ...Customer
  }
}
    fragment Address on Address {
  id
  email
  salutation
  firstName
  lastName
  streetName
  houseNumber
  houseNumberSuffix
  postalCode
  city
  phone
  country
  company
}
fragment Customer on Customer {
  firstName
  lastName
  accountType
  company
  email
  vatNumber
  billingAddress {
    ...Address
  }
  shippingAddress {
    ...Address
  }
  addresses {
    ...Address
  }
}`) as unknown as TypedDocumentString<CustomerCreateMutation, CustomerCreateMutationVariables>;
export const CustomerPasswordUpdateDocument = new TypedDocumentString(`
    mutation CustomerPasswordUpdate($storeContext: StoreContextInput!, $password: String!, $newPassword: String!) {
  customerPasswordUpdate(
    storeContext: $storeContext
    password: $password
    newPassword: $newPassword
  ) {
    ...Customer
  }
}
    fragment Address on Address {
  id
  email
  salutation
  firstName
  lastName
  streetName
  houseNumber
  houseNumberSuffix
  postalCode
  city
  phone
  country
  company
}
fragment Customer on Customer {
  firstName
  lastName
  accountType
  company
  email
  vatNumber
  billingAddress {
    ...Address
  }
  shippingAddress {
    ...Address
  }
  addresses {
    ...Address
  }
}`) as unknown as TypedDocumentString<CustomerPasswordUpdateMutation, CustomerPasswordUpdateMutationVariables>;
export const PageRedirectDocument = new TypedDocumentString(`
    query PageRedirect($path: String!, $storeContext: StoreContextInput!, $pageType: PageRedirectPageType!) {
  pageRedirect(path: $path, storeContext: $storeContext, pageType: $pageType) {
    destination
    statusCode
  }
}
    `) as unknown as TypedDocumentString<PageRedirectQuery, PageRedirectQueryVariables>;
export const GetContentPageDocument = new TypedDocumentString(`
    query GetContentPage($storeContext: StoreContextInput!, $path: String!, $previewID: String, $version: ContentVersion, $currentPage: Int) {
  page(
    storeContext: $storeContext
    path: $path
    previewID: $previewID
    version: $version
    currentPage: $currentPage
  ) {
    ...ContentPageFragment
    ...ProductListingPageFragment
    ...ArticlePageFragment
    ...FAQPageFragment
  }
}
    fragment AbstractPageFragment on AbstractPage {
  __typename
  id
  name
  path
  translatedPaths {
    locale
    path
  }
  breadcrumbs {
    ...BreadcrumbFragment
  }
  seo {
    ...ContentSEOFragment
  }
}
fragment ContentSEOFragment on ContentSEO {
  __typename
  title
  description
  ogTitle
  ogDescription
  ogImage
  twitterTitle
  twitterDescription
  twitterImage
}
fragment ContentPageFragment on ContentPage {
  ...AbstractPageFragment
  contentPageTitle: title
  description
  hero {
    ...HeroFragment
  }
  usps {
    ...UspsFragment
  }
  body {
    ...BlocksFragment
  }
}
fragment FAQPageFragment on FAQPage {
  ...AbstractPageFragment
  title
  faqGroups {
    ...FAQGroupFragment
    translatedPaths {
      locale
      path
    }
  }
}
fragment BaseBlocksFragment on Block {
  ...IframeFragment
  ...SectionFragment
  ...TeaserRowFragment
  ...RichTextFragment
  ...TwoColumnFragment
  ...ThreeColumnFragment
  ...FourColumnFragment
  ...SectionHeaderFragment
  ...DividerFragment
  ...ImageFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...CategorySectionFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...UGCFlowboxFragment
  ...ShopSectionFragment
  ...CookieDeclarationFragment
  ...ArticleOverviewFragment
  ...VideoFragment
  ...FAQItemListFragment
  ...JafixFragment
}
fragment BlocksFragment on Block {
  ...BaseBlocksFragment
  ...CountrySpecificContainerFragment
}
fragment ProductListingPageFragment on ProductListingPage {
  ...AbstractPageFragment
  plpTitle: title
  description
  hero {
    ...HeroFragment
  }
  afterBlocks {
    ...BlocksFragment
  }
  beforeBlocks {
    ...BlocksFragment
  }
  category {
    id
  }
  productListingConfig {
    ...ProductListingConfig
  }
}
fragment ArticlePageFragment on ArticlePage {
  ...AbstractPageFragment
  title
  image {
    filename
    alt
  }
  location
  publishedAt
  body {
    ...TwoColumnFragment
    ...ThreeColumnFragment
    ...FourColumnFragment
    ...BlockQuoteFragment
    ...ButtonsFragment
    ...ImageFragment
    ...RichTextFragment
    ...TableFragment
    ...VideoFragment
    ...FAQItemListFragment
  }
}
fragment FAQGroupFragment on FAQGroup {
  id
  title
  slug
  icon {
    ...ImageAsset
  }
  leadText {
    ...RichTextFragment
  }
  faqItems {
    ...FAQItemFragment
  }
}
fragment ArticleCardFragment on ArticleCard {
  id
  title
  location
  publishedAt
  image {
    filename
    alt
  }
  link {
    url
  }
}
fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment BreadcrumbFragment on Breadcrumb {
  name
  path
}
fragment CategoryCardFragment on Card {
  __typename
  id
  title
  category
  supportingText
  image {
    ...ImageAsset
  }
  cardLink: link {
    url
    newTab
    hash
  }
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment HeroFragment on Hero {
  __typename
  id
  title
  variant
  imagePosition
  imageStyle
  bodyText {
    ...RichTextFragment
  }
  buttons {
    ...ButtonFragment
  }
  image {
    ...ImageAsset
  }
}
fragment Price on Money {
  centAmount
  currency
}
fragment PriceTag on Money {
  centAmount
  currency
}
fragment ProductCard on Product {
  name
  slug
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  marketingRibbons {
    kind
    label
    color
  }
  promotionRibbons {
    kind
    label
    color
  }
  image {
    url
    alt
  }
  startingPrice {
    gross {
      ...PriceTag
    }
  }
  primaryVariant {
    ...ProductVariantAnalyticsFragment
    id
    sku
    availability
    price {
      net {
        ...PriceTag
      }
      gross {
        ...PriceTag
      }
    }
  }
  primaryCategory {
    ...CategoryAnalyticsFragment
  }
  variants {
    ...ProductVariantAnalyticsFragment
  }
  ...ProductAnalyticsFragment
}
fragment ProductListingConfig on ProductListingConfig {
  categoryId
  categoryPageId
  defaultOrder
  enabledFacets
}
fragment SectionHeaderFragment on SectionHeader {
  __typename
  id
  title
  imagePosition
  imageStyle
  bodyText {
    ...RichTextFragment
  }
  buttons {
    ...ButtonFragment
  }
  headerImage: image {
    ...ImageAsset
  }
}
fragment TeaserRowFragment on TeaserRow {
  __typename
  id
  title
  viewMoreLink {
    url
    newTab
  }
  items {
    __typename
    id
    content
    image {
      ...ImageAsset
    }
    link {
      url
    }
    title
  }
}
fragment UspsFragment on Usps {
  id
  usp1
  usp1Link {
    url
    newTab
    hash
  }
  usp2
  usp2Link {
    url
    newTab
    hash
  }
  usp3
  usp3Link {
    url
    newTab
    hash
  }
}
fragment ArticleOverviewFragment on ArticleOverview {
  __typename
  id
  articleItems: items(page: $currentPage) {
    totalPages
    results {
      ...ArticleCardFragment
    }
  }
}
fragment BlockQuoteFragment on BlockQuote {
  __typename
  id
  content
  name
  title
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment ButtonsFragment on Buttons {
  __typename
  id
  buttons {
    ...ButtonFragment
  }
}
fragment CategorySectionFragment on CategorySection {
  __typename
  id
  title
  category
  supportingText
  headerAlign
  variant
  link {
    url
    newTab
    hash
  }
  items {
    ...CategoryCardFragment
  }
}
fragment ColumnBlockFragment on ColumnBlock {
  ...DividerFragment
  ...IframeFragment
  ...ImageFragment
  ...RichTextFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...CookieDeclarationFragment
  ...VideoFragment
  ...FAQItemListFragment
}
fragment FourColumnFragment on FourColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
  column_4 {
    ...ColumnBlockFragment
  }
}
fragment ThreeColumnFragment on ThreeColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
}
fragment TwoColumnFragment on TwoColumns {
  __typename
  id
  alignment
  ratio
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
}
fragment CookieDeclarationFragment on CookieDeclaration {
  __typename
  id
}
fragment CountrySpecificContainerFragment on CountrySpecificContainer {
  __typename
  id
  countries
  countrySpecificContainerBody: body {
    ...BaseBlocksFragment
  }
}
fragment DividerFragment on Divider {
  __typename
  id
}
fragment FAQItemListFragment on FAQItemList {
  __typename
  id
  faqItems {
    ...FAQItemFragment
  }
}
fragment IframeFragment on Iframe {
  __typename
  id
  url
  height
}
fragment ImageFragment on Image {
  __typename
  id
  image {
    ...ImageAsset
  }
  aspectRatio
}
fragment JafixFragment on Jafix {
  __typename
  id
  key
}
fragment NewsletterCTAFragment on NewsletterCTA {
  __typename
  id
  orientation
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}
fragment SectionFragment on Section {
  __typename
  id
  backgroundColor
  size
  spacing
  body {
    ...TeaserRowFragment
    ...RichTextFragment
    ...TwoColumnFragment
    ...ThreeColumnFragment
    ...FourColumnFragment
    ...SectionHeaderFragment
    ...ImageFragment
    ...DividerFragment
    ...IframeFragment
    ...ButtonsFragment
    ...BlockQuoteFragment
    ...TableFragment
    ...NewsletterCTAFragment
    ...UGCFlowboxFragment
    ...CookieDeclarationFragment
    ...VideoFragment
    ...FAQItemListFragment
    ...ShopSectionFragment
    ...CategorySectionFragment
    ...JafixFragment
  }
}
fragment ShopSectionFragment on ShopSection {
  __typename
  id
  title
  subtitle
  category
  viewAllLink {
    url
    newTab
  }
  viewAllLabel
  variant
  products {
    ...ProductCard
  }
}
fragment TableCellFragment on ContentTableCell {
  value
}
fragment TableFragment on Table {
  __typename
  id
  style
  dividers
  width
  table {
    thead {
      ...TableCellFragment
    }
    tbody {
      body {
        ...TableCellFragment
      }
    }
  }
}
fragment UGCFlowboxFragment on UGCFlowbox {
  __typename
  id
  key
  tags
}
fragment VideoFragment on Video {
  __typename
  id
  video
}
fragment ProductVariantAnalyticsFragment on ProductVariant {
  name
  sku
  regularPrice {
    gross {
      ...Price
    }
  }
  attributes {
    name
    value
  }
}
fragment CategoryAnalyticsFragment on ProductCategory {
  name
  id
  ancestors {
    storyblokName
    name
  }
}
fragment ProductAnalyticsFragment on Product {
  id
  brand
  name
}`) as unknown as TypedDocumentString<GetContentPageQuery, GetContentPageQueryVariables>;
export const GetProductDetailPageDocument = new TypedDocumentString(`
    query GetProductDetailPage($storeContext: StoreContextInput!, $slug: String!, $currentPage: Int) {
  product(storeContext: $storeContext, slug: $slug) {
    ...ProductDetailPageFragment
    localizedSlugs {
      locale
      slug
    }
  }
}
    fragment BaseBlocksFragment on Block {
  ...IframeFragment
  ...SectionFragment
  ...TeaserRowFragment
  ...RichTextFragment
  ...TwoColumnFragment
  ...ThreeColumnFragment
  ...FourColumnFragment
  ...SectionHeaderFragment
  ...DividerFragment
  ...ImageFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...CategorySectionFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...UGCFlowboxFragment
  ...ShopSectionFragment
  ...CookieDeclarationFragment
  ...ArticleOverviewFragment
  ...VideoFragment
  ...FAQItemListFragment
  ...JafixFragment
}
fragment ProductBuySectionFragment on ProductVariant {
  sku
  availability
  availabilityQuantity
  price {
    gross {
      ...Price
    }
  }
  regularPrice {
    gross {
      ...Price
    }
  }
}
fragment ProductDetailPageFragment on Product {
  meta {
    title
    description
  }
  usps {
    ...UspsFragment
  }
  name
  slug
  availability
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  brand
  marketingRibbons {
    kind
    label
    color
  }
  promotionRibbons {
    kind
    label
    color
  }
  primaryVariant {
    sku
    images {
      url
      alt
    }
    orderConfiguration {
      min
      max
      hasMax
      stepSize
    }
    ...ProductVariantAnalyticsFragment
  }
  primaryCategory {
    id
    name
    slug
    ancestors {
      storyblokName
      name
      id
    }
  }
  variants {
    ...ProductVariantAnalyticsFragment
    ...ProductVariantFragment
    ...ProductBuySectionFragment
  }
  relatedProducts {
    id
    slug
    availability
    image {
      url
      alt
    }
    primaryVariant {
      sku
    }
    variants {
      availability
      price {
        gross {
          centAmount
        }
      }
    }
    startingPrice {
      gross {
        ...Price
      }
    }
  }
  startingPrice {
    gross {
      ...Price
    }
  }
  instructions {
    key
    label
  }
  materials {
    base
    outside
    filling
    lining
  }
  reviews {
    amount
    averageRating
    lowestRating
    highestRating
  }
  sizeGuide {
    ...TableFragment
    ...ImageFragment
    ...RichTextFragment
    ...CountrySpecificContainerFragment
  }
  breadcrumbs {
    ...BreadcrumbFragment
  }
  ...ProductAnalyticsFragment
}
fragment ProductVariantFragment on ProductVariant {
  id
  name
  sku
  availability
  images {
    url
    alt
  }
  deliveryTime
  description
  attributes {
    name
    label
    value
  }
  orderConfiguration {
    min
    max
    hasMax
    stepSize
  }
}
fragment ArticleCardFragment on ArticleCard {
  id
  title
  location
  publishedAt
  image {
    filename
    alt
  }
  link {
    url
  }
}
fragment ImageAsset on ContentAsset {
  filename
  alt
  focus
}
fragment BreadcrumbFragment on Breadcrumb {
  name
  path
}
fragment CategoryCardFragment on Card {
  __typename
  id
  title
  category
  supportingText
  image {
    ...ImageAsset
  }
  cardLink: link {
    url
    newTab
    hash
  }
}
fragment FAQItemFragment on FAQItem {
  __typename
  id
  slug
  title
  richContent: content {
    ...RichTextFragment
  }
}
fragment Price on Money {
  centAmount
  currency
}
fragment PriceTag on Money {
  centAmount
  currency
}
fragment ProductCard on Product {
  name
  slug
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  marketingRibbons {
    kind
    label
    color
  }
  promotionRibbons {
    kind
    label
    color
  }
  image {
    url
    alt
  }
  startingPrice {
    gross {
      ...PriceTag
    }
  }
  primaryVariant {
    ...ProductVariantAnalyticsFragment
    id
    sku
    availability
    price {
      net {
        ...PriceTag
      }
      gross {
        ...PriceTag
      }
    }
  }
  primaryCategory {
    ...CategoryAnalyticsFragment
  }
  variants {
    ...ProductVariantAnalyticsFragment
  }
  ...ProductAnalyticsFragment
}
fragment SectionHeaderFragment on SectionHeader {
  __typename
  id
  title
  imagePosition
  imageStyle
  bodyText {
    ...RichTextFragment
  }
  buttons {
    ...ButtonFragment
  }
  headerImage: image {
    ...ImageAsset
  }
}
fragment TeaserRowFragment on TeaserRow {
  __typename
  id
  title
  viewMoreLink {
    url
    newTab
  }
  items {
    __typename
    id
    content
    image {
      ...ImageAsset
    }
    link {
      url
    }
    title
  }
}
fragment UspsFragment on Usps {
  id
  usp1
  usp1Link {
    url
    newTab
    hash
  }
  usp2
  usp2Link {
    url
    newTab
    hash
  }
  usp3
  usp3Link {
    url
    newTab
    hash
  }
}
fragment ArticleOverviewFragment on ArticleOverview {
  __typename
  id
  articleItems: items(page: $currentPage) {
    totalPages
    results {
      ...ArticleCardFragment
    }
  }
}
fragment BlockQuoteFragment on BlockQuote {
  __typename
  id
  content
  name
  title
}
fragment ButtonFragment on Button {
  __typename
  id
  title
  variant
  size
  link {
    url
    newTab
    hash
  }
}
fragment ButtonsFragment on Buttons {
  __typename
  id
  buttons {
    ...ButtonFragment
  }
}
fragment CategorySectionFragment on CategorySection {
  __typename
  id
  title
  category
  supportingText
  headerAlign
  variant
  link {
    url
    newTab
    hash
  }
  items {
    ...CategoryCardFragment
  }
}
fragment ColumnBlockFragment on ColumnBlock {
  ...DividerFragment
  ...IframeFragment
  ...ImageFragment
  ...RichTextFragment
  ...ButtonsFragment
  ...BlockQuoteFragment
  ...TableFragment
  ...NewsletterCTAFragment
  ...CookieDeclarationFragment
  ...VideoFragment
  ...FAQItemListFragment
}
fragment FourColumnFragment on FourColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
  column_4 {
    ...ColumnBlockFragment
  }
}
fragment ThreeColumnFragment on ThreeColumns {
  __typename
  id
  alignment
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
  column_3 {
    ...ColumnBlockFragment
  }
}
fragment TwoColumnFragment on TwoColumns {
  __typename
  id
  alignment
  ratio
  column_1 {
    ...ColumnBlockFragment
  }
  column_2 {
    ...ColumnBlockFragment
  }
}
fragment CookieDeclarationFragment on CookieDeclaration {
  __typename
  id
}
fragment CountrySpecificContainerFragment on CountrySpecificContainer {
  __typename
  id
  countries
  countrySpecificContainerBody: body {
    ...BaseBlocksFragment
  }
}
fragment DividerFragment on Divider {
  __typename
  id
}
fragment FAQItemListFragment on FAQItemList {
  __typename
  id
  faqItems {
    ...FAQItemFragment
  }
}
fragment IframeFragment on Iframe {
  __typename
  id
  url
  height
}
fragment ImageFragment on Image {
  __typename
  id
  image {
    ...ImageAsset
  }
  aspectRatio
}
fragment JafixFragment on Jafix {
  __typename
  id
  key
}
fragment NewsletterCTAFragment on NewsletterCTA {
  __typename
  id
  orientation
}
fragment RichTextFragment on RichText {
  __typename
  id
  content
}
fragment SectionFragment on Section {
  __typename
  id
  backgroundColor
  size
  spacing
  body {
    ...TeaserRowFragment
    ...RichTextFragment
    ...TwoColumnFragment
    ...ThreeColumnFragment
    ...FourColumnFragment
    ...SectionHeaderFragment
    ...ImageFragment
    ...DividerFragment
    ...IframeFragment
    ...ButtonsFragment
    ...BlockQuoteFragment
    ...TableFragment
    ...NewsletterCTAFragment
    ...UGCFlowboxFragment
    ...CookieDeclarationFragment
    ...VideoFragment
    ...FAQItemListFragment
    ...ShopSectionFragment
    ...CategorySectionFragment
    ...JafixFragment
  }
}
fragment ShopSectionFragment on ShopSection {
  __typename
  id
  title
  subtitle
  category
  viewAllLink {
    url
    newTab
  }
  viewAllLabel
  variant
  products {
    ...ProductCard
  }
}
fragment TableCellFragment on ContentTableCell {
  value
}
fragment TableFragment on Table {
  __typename
  id
  style
  dividers
  width
  table {
    thead {
      ...TableCellFragment
    }
    tbody {
      body {
        ...TableCellFragment
      }
    }
  }
}
fragment UGCFlowboxFragment on UGCFlowbox {
  __typename
  id
  key
  tags
}
fragment VideoFragment on Video {
  __typename
  id
  video
}
fragment ProductVariantAnalyticsFragment on ProductVariant {
  name
  sku
  regularPrice {
    gross {
      ...Price
    }
  }
  attributes {
    name
    value
  }
}
fragment CategoryAnalyticsFragment on ProductCategory {
  name
  id
  ancestors {
    storyblokName
    name
  }
}
fragment ProductAnalyticsFragment on Product {
  id
  brand
  name
}`) as unknown as TypedDocumentString<GetProductDetailPageQuery, GetProductDetailPageQueryVariables>;
export const GetStoreDocument = new TypedDocumentString(`
    query GetStore($slug: String!) {
  store(slug: $slug) {
    ...StoreFragment
  }
}
    fragment StoreFragment on Store {
  slug
  address {
    addressLine
    city
    district
    phone
    zipcode
    streetNumber
    countryId
  }
  name
  slug
  storeCode
  openingHours {
    fridayclose1
    fridayclose2
    fridayopen1
    fridayopen2
    mondayclose1
    mondayclose2
    mondayopen1
    mondayopen2
    saturdayclose1
    saturdayclose2
    saturdayopen1
    saturdayopen2
    sundayclose1
    sundayclose2
    sundayopen1
    sundayopen2
    thursdayclose1
    thursdayclose2
    thursdayopen1
    thursdayopen2
    tuesdayclose1
    tuesdayclose2
    tuesdayopen1
    tuesdayopen2
    wednesdayclose1
    wednesdayclose2
    wednesdayopen1
    wednesdayopen2
  }
  coordinates {
    lat
    lng
  }
  nearbyStores {
    name
    slug
    address {
      addressLine
      city
      streetNumber
      phone
      zipcode
    }
    distanceInMeters
    objectID
    storeCode
  }
}`) as unknown as TypedDocumentString<GetStoreQuery, GetStoreQueryVariables>;
export const OrderDocument = new TypedDocumentString(`
    query Order($storeContext: StoreContextInput!, $orderId: String!) {
  orderConfirmation(storeContext: $storeContext, orderId: $orderId) {
    ...OrderDetail
  }
}
    fragment OrderDetail on Order {
  customerEmail
  orderNumber
  shippingAddress {
    firstName
    lastName
    streetName
    houseNumber
    houseNumberSuffix
    postalCode
    city
    phone
  }
  shippingCosts {
    ...Price
  }
  estimatedMaxDeliveryDays
  lineItems {
    id
    quantity
    productId
    productSlug
    productName
    category {
      ancestors {
        storyblokName
        name
      }
    }
    price {
      gross {
        ...Price
      }
    }
    variant {
      name
      size
      color
      sku
      primaryImage {
        url
        alt
      }
    }
  }
  currency
  total {
    gross {
      ...Price
    }
  }
  selectedPaymentMethod {
    ...PaymentMethod
  }
  shippingMethod
  shippingOption
}
fragment PaymentMethod on PaymentMethod {
  id
  name
  provider
  issuers {
    id
    name
  }
}
fragment Price on Money {
  centAmount
  currency
}`) as unknown as TypedDocumentString<OrderQuery, OrderQueryVariables>;
export const GetCheckoutDeliveryDocument = new TypedDocumentString(`
    query GetCheckoutDelivery($storeContext: StoreContextInput!) {
  cart(storeContext: $storeContext) {
    paazlCheckoutConfig {
      ...PaazlConfigFragment
    }
  }
}
    fragment PaazlConfigFragment on PaazlCheckoutConfig {
  configObject
}`) as unknown as TypedDocumentString<GetCheckoutDeliveryQuery, GetCheckoutDeliveryQueryVariables>;
export const CustomerAddressUpdateDocument = new TypedDocumentString(`
    mutation CustomerAddressUpdate($storeContext: StoreContextInput!, $address: AddressUpdateInput!) {
  customerInformationUpdate(storeContext: $storeContext, address: $address) {
    ...Customer
  }
}
    fragment Address on Address {
  id
  email
  salutation
  firstName
  lastName
  streetName
  houseNumber
  houseNumberSuffix
  postalCode
  city
  phone
  country
  company
}
fragment Customer on Customer {
  firstName
  lastName
  accountType
  company
  email
  vatNumber
  billingAddress {
    ...Address
  }
  shippingAddress {
    ...Address
  }
  addresses {
    ...Address
  }
}`) as unknown as TypedDocumentString<CustomerAddressUpdateMutation, CustomerAddressUpdateMutationVariables>;
export const GetCheckoutInformationDocument = new TypedDocumentString(`
    query GetCheckoutInformation($storeContext: StoreContextInput!) {
  cart(storeContext: $storeContext) {
    customerEmail
    billingAddress {
      ...AddressFragment
    }
  }
}
    fragment AddressFragment on Address {
  id
  email
  firstName
  lastName
  streetName
  houseNumber
  houseNumberSuffix
  postalCode
  city
  phone
  country
  company
  vatNumber
}`) as unknown as TypedDocumentString<GetCheckoutInformationQuery, GetCheckoutInformationQueryVariables>;
export const UpdateCheckoutInformationDocument = new TypedDocumentString(`
    mutation UpdateCheckoutInformation($storeContext: StoreContextInput!, $setBillingAddress: AddressInput, $setShippingAddress: AddressInput, $setCustomerEmail: String) {
  checkoutUpdate(
    storeContext: $storeContext
    setBillingAddress: $setBillingAddress
    setShippingAddress: $setShippingAddress
    setCustomerEmail: $setCustomerEmail
  ) {
    customerEmail
    shippingAddress {
      ...AddressFragment
    }
    billingAddress {
      ...AddressFragment
    }
  }
}
    fragment AddressFragment on Address {
  id
  email
  firstName
  lastName
  streetName
  houseNumber
  houseNumberSuffix
  postalCode
  city
  phone
  country
  company
  vatNumber
}`) as unknown as TypedDocumentString<UpdateCheckoutInformationMutation, UpdateCheckoutInformationMutationVariables>;
export const UpdateCheckoutLoginDocument = new TypedDocumentString(`
    mutation UpdateCheckoutLogin($storeContext: StoreContextInput!, $id: CartIdentifierInput!, $setCustomerEmail: String, $setBillingAddress: AddressInput) {
  checkoutUpdate(
    storeContext: $storeContext
    id: $id
    setCustomerEmail: $setCustomerEmail
    setBillingAddress: $setBillingAddress
  ) {
    id {
      id
      version
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateCheckoutLoginMutation, UpdateCheckoutLoginMutationVariables>;
export const CheckoutCustomerLoginDocument = new TypedDocumentString(`
    mutation CheckoutCustomerLogin($storeContext: StoreContextInput!, $email: String!, $password: String!) {
  customerLogin(storeContext: $storeContext, email: $email, password: $password) {
    ...Customer
  }
}
    fragment Address on Address {
  id
  email
  salutation
  firstName
  lastName
  streetName
  houseNumber
  houseNumberSuffix
  postalCode
  city
  phone
  country
  company
}
fragment Customer on Customer {
  firstName
  lastName
  accountType
  company
  email
  vatNumber
  billingAddress {
    ...Address
  }
  shippingAddress {
    ...Address
  }
  addresses {
    ...Address
  }
}`) as unknown as TypedDocumentString<CheckoutCustomerLoginMutation, CheckoutCustomerLoginMutationVariables>;
export const GetCheckoutLoginDocument = new TypedDocumentString(`
    query GetCheckoutLogin($storeContext: StoreContextInput!) {
  cart(storeContext: $storeContext) {
    id {
      id
      version
    }
    customerEmail
  }
}
    `) as unknown as TypedDocumentString<GetCheckoutLoginQuery, GetCheckoutLoginQueryVariables>;
export const FailedOrderDocument = new TypedDocumentString(`
    query FailedOrder($storeContext: StoreContextInput!, $orderId: String!) {
  order(storeContext: $storeContext, orderId: $orderId) {
    ...FailedOrderDetail
  }
  availablePaymentMethods(
    storeContext: $storeContext
    orderId: $orderId
    device: web
  ) {
    name
    paymentMethod {
      ...PaymentMethod
    }
  }
}
    fragment OrderDetail on Order {
  customerEmail
  orderNumber
  shippingAddress {
    firstName
    lastName
    streetName
    houseNumber
    houseNumberSuffix
    postalCode
    city
    phone
  }
  shippingCosts {
    ...Price
  }
  estimatedMaxDeliveryDays
  lineItems {
    id
    quantity
    productId
    productSlug
    productName
    category {
      ancestors {
        storyblokName
        name
      }
    }
    price {
      gross {
        ...Price
      }
    }
    variant {
      name
      size
      color
      sku
      primaryImage {
        url
        alt
      }
    }
  }
  currency
  total {
    gross {
      ...Price
    }
  }
  selectedPaymentMethod {
    ...PaymentMethod
  }
  shippingMethod
  shippingOption
}
fragment FailedOrderDetail on Order {
  ...OrderDetail
  lineItems {
    id
    quantity
    productId
    productSlug
    productName
    addedAt
    category {
      ancestors {
        storyblokName
        name
      }
    }
    price {
      gross {
        ...Price
      }
    }
    variant {
      name
      sku
      primaryImage {
        url
        alt
      }
    }
  }
  subTotal {
    gross {
      ...Price
    }
  }
  total {
    gross {
      ...Price
    }
  }
  shippingCosts {
    ...Price
  }
  selectedPaymentMethod {
    ...PaymentMethod
  }
  shippingOption
  paymentStatus
}
fragment PaymentMethod on PaymentMethod {
  id
  name
  provider
  issuers {
    id
    name
  }
}
fragment Price on Money {
  centAmount
  currency
}`) as unknown as TypedDocumentString<FailedOrderQuery, FailedOrderQueryVariables>;
export const GetOrderPaymentStatusDocument = new TypedDocumentString(`
    query GetOrderPaymentStatus($orderId: String!, $storeContext: StoreContextInput!) {
  orderPaymentStatus(orderId: $orderId, storeContext: $storeContext)
}
    `) as unknown as TypedDocumentString<GetOrderPaymentStatusQuery, GetOrderPaymentStatusQueryVariables>;
export const PaymentCreateDocument = new TypedDocumentString(`
    mutation PaymentCreate($storeContext: StoreContextInput!, $paymentContext: PaymentContextInput!) {
  createPayment(storeContext: $storeContext, paymentContext: $paymentContext) {
    redirectURL
    additionalData
    method
  }
}
    `) as unknown as TypedDocumentString<PaymentCreateMutation, PaymentCreateMutationVariables>;
export const GetCheckoutPaymentDocument = new TypedDocumentString(`
    query GetCheckoutPayment($storeContext: StoreContextInput!) {
  cart(storeContext: $storeContext) {
    availablePaymentMethods(device: web) {
      name
      paymentMethod {
        ...PaymentMethod
      }
    }
    selectedPaymentMethod {
      ...PaymentMethod
    }
  }
}
    fragment PaymentMethod on PaymentMethod {
  id
  name
  provider
  issuers {
    id
    name
  }
}`) as unknown as TypedDocumentString<GetCheckoutPaymentQuery, GetCheckoutPaymentQueryVariables>;
export const CreateOrderDocument = new TypedDocumentString(`
    mutation CreateOrder($storeContext: StoreContextInput!) {
  checkoutComplete(storeContext: $storeContext) {
    orderId
    orderNumber
  }
}
    `) as unknown as TypedDocumentString<CreateOrderMutation, CreateOrderMutationVariables>;
export const GetContentSlugsDocument = new TypedDocumentString(`
    query GetContentSlugs($storeContext: StoreContextInput!, $pageSize: Int!, $page: Int!, $includeCountryUnique: Boolean!, $includeShared: Boolean!) {
  pages(
    storeContext: $storeContext
    pageSize: $pageSize
    page: $page
    version: published
    includeCountryUnique: $includeCountryUnique
    includeShared: $includeShared
  ) {
    results {
      ... on AbstractPage {
        __typename
        name
        path
      }
    }
    total
    moreResultsCountryUnique
    moreResultsShared
  }
}
    `) as unknown as TypedDocumentString<GetContentSlugsQuery, GetContentSlugsQueryVariables>;
export const GetProductSlugsDocument = new TypedDocumentString(`
    query GetProductSlugs($storeContext: StoreContextInput!, $pageSize: Int!, $fromId: String) {
  products(storeContext: $storeContext, fromId: $fromId, pageSize: $pageSize) {
    lastId
    total
    results {
      slug
    }
  }
}
    `) as unknown as TypedDocumentString<GetProductSlugsQuery, GetProductSlugsQueryVariables>;
export const GetProductCountDocument = new TypedDocumentString(`
    query GetProductCount($storeContext: StoreContextInput!, $sort: ProductSortOrder!, $filters: [FacetFilterInput!], $searchTerm: String, $categoryPageId: String) {
  productSearch(
    storeContext: $storeContext
    sort: $sort
    filters: $filters
    categoryPageId: $categoryPageId
    searchTerm: $searchTerm
  ) {
    total
  }
}
    `) as unknown as TypedDocumentString<GetProductCountQuery, GetProductCountQueryVariables>;
export const CartLineItemsAddDocument = new TypedDocumentString(`
    mutation CartLineItemsAdd($storeContext: StoreContextInput!, $id: CartIdentifierInput, $lineItems: [CartLineItemCreateInput!]!) {
  cartLineItemsAdd(storeContext: $storeContext, id: $id, lineItems: $lineItems) {
    ...Cart
  }
}
    fragment CheckoutSummaryFragment on Cart {
  ...CartSummaryFragment
  lineItems {
    ...LineItem
    id
    quantity
    productSlug
    productName
    addedAt
    variant {
      name
      sku
      primaryImage {
        url
        alt
      }
    }
  }
}
fragment CartSummaryFragment on Cart {
  subTotal {
    ...Price
  }
  discount {
    amount {
      ...Price
    }
  }
  total {
    ...Price
  }
  subTotalBeforeDiscount {
    ...Price
  }
  shippingCosts {
    ...Price
  }
}
fragment Price on Money {
  centAmount
  currency
}
fragment Cart on Cart {
  ...CheckoutSummaryFragment
  id {
    id
    version
  }
  lineItems {
    ...LineItem
  }
  subTotal {
    ...Price
  }
  discount {
    amount {
      ...Price
    }
  }
  total {
    ...Price
  }
  subTotalBeforeDiscount {
    ...Price
  }
  shippingCosts {
    ...Price
  }
  shippingOption
}
fragment LineItem on LineItem {
  id
  quantity
  productId
  productSlug
  productName
  addedAt
  availableStock
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  category {
    ancestors {
      storyblokName
      name
    }
  }
  regularPrice {
    gross {
      ...Price
    }
  }
  price {
    gross {
      ...Price
    }
    tax {
      value {
        ...Price
      }
      rate
    }
  }
  discounts {
    code
    value {
      centAmount
      currency
    }
    description
  }
  variant {
    name
    descriptionShort
    sku
    size
    color
    primaryImage {
      url
      alt
    }
    orderConfiguration {
      min
      max
      stepSize
    }
  }
}`) as unknown as TypedDocumentString<CartLineItemsAddMutation, CartLineItemsAddMutationVariables>;
export const GetCartDocument = new TypedDocumentString(`
    query GetCart($storeContext: StoreContextInput!) {
  cart(storeContext: $storeContext) {
    ...Cart
  }
}
    fragment CheckoutSummaryFragment on Cart {
  ...CartSummaryFragment
  lineItems {
    ...LineItem
    id
    quantity
    productSlug
    productName
    addedAt
    variant {
      name
      sku
      primaryImage {
        url
        alt
      }
    }
  }
}
fragment CartSummaryFragment on Cart {
  subTotal {
    ...Price
  }
  discount {
    amount {
      ...Price
    }
  }
  total {
    ...Price
  }
  subTotalBeforeDiscount {
    ...Price
  }
  shippingCosts {
    ...Price
  }
}
fragment Price on Money {
  centAmount
  currency
}
fragment Cart on Cart {
  ...CheckoutSummaryFragment
  id {
    id
    version
  }
  lineItems {
    ...LineItem
  }
  subTotal {
    ...Price
  }
  discount {
    amount {
      ...Price
    }
  }
  total {
    ...Price
  }
  subTotalBeforeDiscount {
    ...Price
  }
  shippingCosts {
    ...Price
  }
  shippingOption
}
fragment LineItem on LineItem {
  id
  quantity
  productId
  productSlug
  productName
  addedAt
  availableStock
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  category {
    ancestors {
      storyblokName
      name
    }
  }
  regularPrice {
    gross {
      ...Price
    }
  }
  price {
    gross {
      ...Price
    }
    tax {
      value {
        ...Price
      }
      rate
    }
  }
  discounts {
    code
    value {
      centAmount
      currency
    }
    description
  }
  variant {
    name
    descriptionShort
    sku
    size
    color
    primaryImage {
      url
      alt
    }
    orderConfiguration {
      min
      max
      stepSize
    }
  }
}`) as unknown as TypedDocumentString<GetCartQuery, GetCartQueryVariables>;
export const CartLineItemsUpdateDocument = new TypedDocumentString(`
    mutation CartLineItemsUpdate($storeContext: StoreContextInput!, $id: CartIdentifierInput!, $lineItems: [CartLineItemUpdateInput!]!) {
  cartLineItemsUpdate(storeContext: $storeContext, id: $id, lineItems: $lineItems) {
    ...Cart
  }
}
    fragment CheckoutSummaryFragment on Cart {
  ...CartSummaryFragment
  lineItems {
    ...LineItem
    id
    quantity
    productSlug
    productName
    addedAt
    variant {
      name
      sku
      primaryImage {
        url
        alt
      }
    }
  }
}
fragment CartSummaryFragment on Cart {
  subTotal {
    ...Price
  }
  discount {
    amount {
      ...Price
    }
  }
  total {
    ...Price
  }
  subTotalBeforeDiscount {
    ...Price
  }
  shippingCosts {
    ...Price
  }
}
fragment Price on Money {
  centAmount
  currency
}
fragment Cart on Cart {
  ...CheckoutSummaryFragment
  id {
    id
    version
  }
  lineItems {
    ...LineItem
  }
  subTotal {
    ...Price
  }
  discount {
    amount {
      ...Price
    }
  }
  total {
    ...Price
  }
  subTotalBeforeDiscount {
    ...Price
  }
  shippingCosts {
    ...Price
  }
  shippingOption
}
fragment LineItem on LineItem {
  id
  quantity
  productId
  productSlug
  productName
  addedAt
  availableStock
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  category {
    ancestors {
      storyblokName
      name
    }
  }
  regularPrice {
    gross {
      ...Price
    }
  }
  price {
    gross {
      ...Price
    }
    tax {
      value {
        ...Price
      }
      rate
    }
  }
  discounts {
    code
    value {
      centAmount
      currency
    }
    description
  }
  variant {
    name
    descriptionShort
    sku
    size
    color
    primaryImage {
      url
      alt
    }
    orderConfiguration {
      min
      max
      stepSize
    }
  }
}`) as unknown as TypedDocumentString<CartLineItemsUpdateMutation, CartLineItemsUpdateMutationVariables>;
export const ProcessPaazlCheckoutDocument = new TypedDocumentString(`
    mutation ProcessPaazlCheckout($storeContext: StoreContextInput!) {
  checkoutUpdate(storeContext: $storeContext, processPaazlCheckout: true) {
    ...Cart
  }
}
    fragment CheckoutSummaryFragment on Cart {
  ...CartSummaryFragment
  lineItems {
    ...LineItem
    id
    quantity
    productSlug
    productName
    addedAt
    variant {
      name
      sku
      primaryImage {
        url
        alt
      }
    }
  }
}
fragment CartSummaryFragment on Cart {
  subTotal {
    ...Price
  }
  discount {
    amount {
      ...Price
    }
  }
  total {
    ...Price
  }
  subTotalBeforeDiscount {
    ...Price
  }
  shippingCosts {
    ...Price
  }
}
fragment Price on Money {
  centAmount
  currency
}
fragment Cart on Cart {
  ...CheckoutSummaryFragment
  id {
    id
    version
  }
  lineItems {
    ...LineItem
  }
  subTotal {
    ...Price
  }
  discount {
    amount {
      ...Price
    }
  }
  total {
    ...Price
  }
  subTotalBeforeDiscount {
    ...Price
  }
  shippingCosts {
    ...Price
  }
  shippingOption
}
fragment LineItem on LineItem {
  id
  quantity
  productId
  productSlug
  productName
  addedAt
  availableStock
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  category {
    ancestors {
      storyblokName
      name
    }
  }
  regularPrice {
    gross {
      ...Price
    }
  }
  price {
    gross {
      ...Price
    }
    tax {
      value {
        ...Price
      }
      rate
    }
  }
  discounts {
    code
    value {
      centAmount
      currency
    }
    description
  }
  variant {
    name
    descriptionShort
    sku
    size
    color
    primaryImage {
      url
      alt
    }
    orderConfiguration {
      min
      max
      stepSize
    }
  }
}`) as unknown as TypedDocumentString<ProcessPaazlCheckoutMutation, ProcessPaazlCheckoutMutationVariables>;
export const GetCustomerDocument = new TypedDocumentString(`
    query GetCustomer {
  customer {
    ...Customer
  }
}
    fragment Address on Address {
  id
  email
  salutation
  firstName
  lastName
  streetName
  houseNumber
  houseNumberSuffix
  postalCode
  city
  phone
  country
  company
}
fragment Customer on Customer {
  firstName
  lastName
  accountType
  company
  email
  vatNumber
  billingAddress {
    ...Address
  }
  shippingAddress {
    ...Address
  }
  addresses {
    ...Address
  }
}`) as unknown as TypedDocumentString<GetCustomerQuery, GetCustomerQueryVariables>;
export const CustomerLoginDocument = new TypedDocumentString(`
    mutation CustomerLogin($storeContext: StoreContextInput!, $email: String!, $password: String!) {
  customerLogin(storeContext: $storeContext, email: $email, password: $password) {
    ...Customer
  }
}
    fragment Address on Address {
  id
  email
  salutation
  firstName
  lastName
  streetName
  houseNumber
  houseNumberSuffix
  postalCode
  city
  phone
  country
  company
}
fragment Customer on Customer {
  firstName
  lastName
  accountType
  company
  email
  vatNumber
  billingAddress {
    ...Address
  }
  shippingAddress {
    ...Address
  }
  addresses {
    ...Address
  }
}`) as unknown as TypedDocumentString<CustomerLoginMutation, CustomerLoginMutationVariables>;
export const CustomerLogoutDocument = new TypedDocumentString(`
    mutation CustomerLogout($storeContext: StoreContextInput!) {
  customerLogout(storeContext: $storeContext)
}
    `) as unknown as TypedDocumentString<CustomerLogoutMutation, CustomerLogoutMutationVariables>;
export const GetAddressValidateDocument = new TypedDocumentString(`
    query GetAddressValidate($storeContext: StoreContextInput!, $address: AddressInput!) {
  addressValidate(storeContext: $storeContext, address: $address) {
    ...AddressValidationResult
  }
}
    fragment AddressValidationResult on AddressValidationResult {
  valid
  suggestions {
    city
    country
    houseNumber
    houseNumberSuffix
    postalCode
    streetName
  }
}`) as unknown as TypedDocumentString<GetAddressValidateQuery, GetAddressValidateQueryVariables>;
export const GetProductsDocument = new TypedDocumentString(`
    query GetProducts($storeContext: StoreContextInput!, $sort: ProductSortOrder!, $filters: [FacetFilterInput!], $searchTerm: String, $categoryPageId: String, $pageSize: Int!, $page: Int!) {
  productSearch(
    storeContext: $storeContext
    sort: $sort
    filters: $filters
    categoryPageId: $categoryPageId
    searchTerm: $searchTerm
    pageSize: $pageSize
    page: $page
  ) {
    ...ProductSearchResults
  }
}
    fragment FacetValueFragment on FacetValue {
  key
  label
  count
}
fragment RangeFacetFragment on RangeFacet {
  __typename
  key
  label
  min
  max
  selectedMin
  selectedMax
}
fragment OptionsFacetFragment on OptionsFacet {
  __typename
  key
  label
  options {
    ...FacetValueFragment
  }
}
fragment ToggleFacetFragment on ToggleFacet {
  __typename
  key
  label
  options {
    ...FacetValueFragment
  }
}
fragment FacetFragment on Facet {
  ...RangeFacetFragment
  ...OptionsFacetFragment
  ...ToggleFacetFragment
}
fragment Price on Money {
  centAmount
  currency
}
fragment PriceTag on Money {
  centAmount
  currency
}
fragment ProductCard on Product {
  name
  slug
  neckline
  rawMaterial
  brand
  denier
  fit
  packSize
  marketingRibbons {
    kind
    label
    color
  }
  promotionRibbons {
    kind
    label
    color
  }
  image {
    url
    alt
  }
  startingPrice {
    gross {
      ...PriceTag
    }
  }
  primaryVariant {
    ...ProductVariantAnalyticsFragment
    id
    sku
    availability
    price {
      net {
        ...PriceTag
      }
      gross {
        ...PriceTag
      }
    }
  }
  primaryCategory {
    ...CategoryAnalyticsFragment
  }
  variants {
    ...ProductVariantAnalyticsFragment
  }
  ...ProductAnalyticsFragment
}
fragment ProductSearchResults on ProductSearchResults {
  total
  totalPages
  queryID
  results {
    ...ProductCard
  }
  facets {
    ...FacetFragment
  }
}
fragment ProductVariantAnalyticsFragment on ProductVariant {
  name
  sku
  regularPrice {
    gross {
      ...Price
    }
  }
  attributes {
    name
    value
  }
}
fragment CategoryAnalyticsFragment on ProductCategory {
  name
  id
  ancestors {
    storyblokName
    name
  }
}
fragment ProductAnalyticsFragment on Product {
  id
  brand
  name
}`) as unknown as TypedDocumentString<GetProductsQuery, GetProductsQueryVariables>;